import {
  Component,
  Input,
  OnInit,
  HostListener,
  OnDestroy,
  inject,
  Renderer2,
  Inject,
  Injectable,
  PLATFORM_ID,
  HostBinding,
  NgZone,
} from '@angular/core';
import { ApiService } from '../../services/api.service';
import {
  ActivatedRoute,
  NavigationEnd,
  Router,
  RouterLink,
  RouterLinkActive,
} from '@angular/router';
import {
  AsyncPipe,
  CurrencyPipe,
  DOCUMENT,
  isPlatformBrowser,
  NgClass,
  NgFor,
  NgIf,
  NgTemplateOutlet,
  DecimalPipe,
  TitleCasePipe,
  KeyValuePipe,
  UpperCasePipe,
} from '@angular/common';
import { filter, Subscription } from 'rxjs';
import { UtilService } from '../../services/util.service';
import { FormsModule } from '@angular/forms';
import { AuthService } from '../../auth.service';
import { jwtDecode } from 'jwt-decode';
import { Location } from '@angular/common';
import { AddServicesModalComponent } from '../add-services-modal/add-services-modal.component';
import { TooltipModule } from 'primeng/tooltip';
import { QuickOrderMenuComponent } from '../quick-order-menu/quick-order-menu.component';
import {
  buildProductContext,
  buildServicesPayloadV11,
  bentPiecesWithCovers,
  CoverInput,
  isCoverPiece,
  presetFromWire,
  productAttrInches,
  parseLengthToInches,
  ServiceInput,
  ServiceKind,
  ServiceOrderInput,
} from '../services/service-order-payload.builder';

@Component({
  selector: 'app-header',
  imports: [
    RouterLink,
    QuickOrderMenuComponent,
    NgFor,
    NgClass,
    NgIf,
    NgTemplateOutlet,
    FormsModule,
    DecimalPipe,
    RouterLinkActive,
    TitleCasePipe,
    CurrencyPipe,
    KeyValuePipe,
    UpperCasePipe,
    AddServicesModalComponent,
    TooltipModule
  ],
  templateUrl: './header.component.html',
  styleUrl: './header.component.css',
})
@Injectable({
  providedIn: 'root',
})
export class HeaderComponent implements OnInit, OnDestroy {
  /** Standalone tool pages (/generate-services): render only the drawers, no header or nav. */
  @Input() bare = false;
  showMainHeader = true;
  visible: boolean = false;
  piecesQtyDropdownOpen = false;
  searchValue: string = '';
  cartCount: any;
  isAdmin: boolean = false;
  isHomePage: boolean = false;
  isAccountPage: boolean = false;
  activeIndex: number = -1;
  user: any;
  priviousToken = '';
  userSubscription = new Subscription();
  cartSubscription = new Subscription();
  adminTokenSubscription = new Subscription();
  cartList: any;
  loggedAsCustomer = false;
  authService = inject(AuthService);
  routerSubscription: Subscription = new Subscription();
  compareActive: boolean = false;
  private history: string[] = [];
  queryList: any;
  ShowList = false;
  searchEnabled = false;
  overflowXValue = false;
  pQueryList: any;
  selectedQuoteProduct: any = null;
  quotesSubscription = new Subscription();
  showLogin: boolean = false;
  showAccountPopupVisible: boolean = false;
  adminWithoutCustomer: boolean = false;
  // Quotes-list "Add More Service / Edit Service": reuse the cart's rich "Editing
  // Services" drawer, but scoped to a single quote line and persisted back to the
  // quote (services only — no variant/qty/delete machinery).
  quoteMode: boolean = false;
  quotesList: any[] = [];
  // /generate-services: the same drawer, but saving hands the built services schema
  // back to that page (util.generatedServices$) — nothing touches the cart or quotes.
  generatorMode: boolean = false;
  /** Service names the generator offers this session (Cutting + Bending, or
   *  Punching + Slitting — the four can't be combined on one schema). */
  generatorAllowedServices: string[] | null = null;
  /** Id of the generated schema being edited; null while creating a new one. */
  generatorRecordId: string | null = null;
  _multipleVarientsPopupOpen: boolean = false;
  private _variantPopupJustTriggered: boolean = false;
  set multipleVarientsPopupOpen(val: boolean) {
    if (this._multipleVarientsPopupOpen !== val) {
      this._multipleVarientsPopupOpen = val;
      this.util.setServicesDrawerOpen(val);
      if (val) {
        this.renderer.addClass(this.document.body, 'no-scroll');
      } else {
        this.renderer.removeClass(this.document.body, 'no-scroll');
      }
    }
  }
  isEditVariantMode: boolean = false;
  isDeletingVariant: boolean = false;
  addNewProduct: boolean = false;
  addServiceMode: boolean = false; // opened from product-detail "Add Services" (save instead of add-to-cart)
  // Latest product from the product page at commit time (reflects a post-save size
  // change). Used so the "added to cart" popup shows the current product, not the
  // one captured when services were first saved.
  pendingServiceLatestProduct: any = null;
  productServiceActionSubscription = new Subscription();
  cameFromVariantEdit: boolean = false;
  editingVariantServices: boolean = false; // "Editing Services" drawer for a cart variant
  editingVariant: any = null;              // the cart variant being edited in that drawer
  // Services ticked (but not yet configured) in the "Editing Services" drawer,
  // keyed by productOptionType. Drives the checkbox state and blocks "Update
  // Services" until the picked service is actually configured.
  editVariantSelectedTypes = new Set<any>();
  cameFromEditServices: boolean = false;   // configure screen was opened from the "Editing Services" drawer
  splitItemsIndividually: boolean = false;
  selectedSplitIndices: Set<number> = new Set();
  isConfiguringSplit: boolean = false;
  serviceFlow: 'together' | 'groups' | 'separately' = 'together';
  serviceGroups: any[] = [];
  activeGroupId: number | null = null;
  groupSelectedServices: { [groupId: number]: any[] } = {};

  setServiceFlow(flow: 'together' | 'groups' | 'separately') {
    const previousFlow = this.serviceFlow;
    this.serviceFlow = flow;

    if (flow === 'separately') {
      this.splitItemsIndividually = true;
      this.serviceGroups = this.flattenedSplitItems.map((unit, idx) => ({
        id: idx + 1,
        qty: 1,
        configs: [],
        unitRef: unit,
        label: `UNIT ${idx + 1}`,
        attributes: this.getUnitAttributes(unit),
        uploadedFile: null
      }));
    } else {
      this.splitItemsIndividually = false;
    }

    if (flow === 'groups') {
      if (previousFlow !== 'groups' || this.serviceGroups.length === 0 || this.splitItemsIndividually) {
        const totalQty = this.flattenedSplitItems.length;
        // Start with a single group holding every unit. The next group is only
        // added once the user frees up units (see onGroupQtyChange) or via the
        // "+ Add Another Group" button — so there's no empty "0 of 0" group up front.
        this.serviceGroups = [
          {
            id: 1,
            label: 'GROUP 1',
            qty: totalQty,
            configs: [],
            uploadedFile: null
          }
        ];
      } else {
        this.serviceGroups.forEach((g, idx) => {
          g.label = `GROUP ${idx + 1}`;
        });
      }
    } else if (flow === 'together') {
      this.serviceGroups = [{
        id: 1,
        label: 'ALL UNITS',
        qty: this.flattenedSplitItems.length,
        configs: [],
        uploadedFile: null
      }];
    }

    this.isConfiguringSplit = false;
    this.selectedSplitIndices.clear();
  }

  getUnitAttributes(unit: any): any[] {
    const attrs: any[] = [];
    const source = unit.product?.attributeSelector || unit.attributeSelector;
    if (source) {
      Object.keys(source).forEach(key => {
        const val = source[key].find((v: any) => this.isAttributeActive(v, unit.product || unit));
        if (val) attrs.push({ key, value: val.attributeValue });
      });
    }
    return attrs;
  }

  addServiceGroup() {
    this.serviceGroups.push({
      qty: 0,
      id: this.serviceGroups.length + 1,
      label: `GROUP ${this.serviceGroups.length + 1}`,
      configs: [],
      uploadedFile: null
    });
  }

  addIndividualUnit() {
    const assignedQty = this.serviceGroups.reduce((sum: number, g: any) => sum + (g.qty || 0), 0);
    this.serviceGroups.push({
      qty: 1,
      id: this.serviceGroups.length + 1,
      label: `UNIT ${assignedQty + 1}`,
      configs: [],
      uploadedFile: null,
      isIndividual: true
    });
  }

  getActiveGroupLabel(): string {
    if (this.activeGroupId == null) {
      return 'Cart';
    }
    const group = this.serviceGroups.find((g: any) => g.id === this.activeGroupId);
    if (group) {
      return group.label || `Group ${group.id}`;
    }
    return `Group ${this.activeGroupId}`;
  }

  public onGroupQtyChange(index: number) {
    // Keep exactly one empty trailing group while units are still unassigned (so
    // the leftover has somewhere to go), and none once everything is assigned.
    // A new group is never spawned when the quantity is already complete.
    this.normalizeTrailingGroups(index);
  }

  /** Normalize the trailing group(s): drop any empty group (no units, no configs)
   *  that sits after the group being edited, then — only when units remain
   *  unassigned — append a single fresh empty group to receive the leftover.
   *  Never touches the group being edited, so clearing its input mid-edit doesn't
   *  delete it out from under the user. */
  private normalizeTrailingGroups(editingIndex: number) {
    while (
      this.serviceGroups.length > 1 &&
      this.serviceGroups.length - 1 > editingIndex &&
      !this.groupHasUnitsOrConfigs(this.serviceGroups[this.serviceGroups.length - 1])
    ) {
      this.serviceGroups.pop();
    }
    if (
      this.unassignedUnitsCount > 0 &&
      this.groupHasUnitsOrConfigs(this.serviceGroups[this.serviceGroups.length - 1])
    ) {
      this.addServiceGroup();
    }
  }

  private groupHasUnitsOrConfigs(g: any): boolean {
    return (g?.qty || 0) > 0 || (g?.configs?.length || 0) > 0;
  }

  getGroupMaxQty(index: number): number {
    const total = this.flattenedSplitItems?.length || 0;
    const assignedBefore = this.serviceGroups
      .slice(0, index)
      .reduce((sum, g) => sum + (g.qty || 0), 0);
    const individualAfter = this.serviceGroups
      .slice(index + 1)
      .filter((g: any) => g.isIndividual)
      .reduce((sum, g) => sum + (g.qty || 0), 0);
    return Math.max(0, total - assignedBefore - individualAfter);
  }

  removeGroupConfig(group: any, configIndex: number, confirmed = false) {
    const removed = group.configs[configIndex];

    // Removing Cutting drops the pieces its bends sit on, so confirm before taking
    // both services down.
    if (!confirmed && removed?.name === 'Cutting' && this.groupBendingWithBends(group)) {
      this.askServiceConfirm({
        title: 'Remove Cutting?',
        message: 'Bends are currently applied to pieces created through cutting. Removing cutting will also remove all configured bend settings.',
        affected: ['Cutting', 'Bending'],
        cancelLabel: 'KEEP SERVICES',
        confirmLabel: 'REMOVE SERVICES',
        onConfirm: () => this.removeGroupConfig(group, configIndex, true),
      });
      return;
    }

    // Every other removal (e.g. Bending, or the last remaining service) is confirmed
    // with the generic "Remove configured services?" prompt before dropping the config.
    if (!confirmed) {
      this.askServiceConfirm({
        title: 'Remove configured services?',
        message: 'This will remove all configured services for this product. All service specifications will be deleted.',
        affected: [],
        cancelLabel: 'KEEP SERVICES',
        confirmLabel: 'REMOVE SERVICES',
        onConfirm: () => this.removeGroupConfig(group, configIndex, true),
      });
      return;
    }

    group.configs.splice(configIndex, 1);

    // Bending pieces are derived from Cutting (syncBendPiecesFromCutting), so a
    // bend built on top of cuts can't stand on its own. When the last Cutting
    // config is removed, also drop any dependent Bending (combined mode → has
    // `pieces`); a standalone bend (bendRows only) is left untouched.
    if (removed?.name === 'Cutting' && !this.hasConfigsForService(group, 'Cutting')) {
      group.configs = (group.configs || []).filter(
        (c: any) => !(c.name === 'Bending' && c.pieces?.length)
      );
      if (!this.hasConfigsForService(group, 'Bending')) {
        this.clearGroupServiceSelection(group, 'Bending');
      }
    }

    // Clear the lingering checkbox selection so the service reverts to a fully
    // unselected state. Without this, the selection stays in groupSelectedServices
    // (fresh session) leaving the checkbox checked after removal.
    if (removed?.name && !this.hasConfigsForService(group, removed.name)) {
      this.clearGroupServiceSelection(group, removed.name);
    }
  }

  /** Drop a service from a group's lingering checkbox selection. */
  private clearGroupServiceSelection(group: any, serviceName: string) {
    const selected = this.groupSelectedServices[group.id];
    if (!selected) return;
    const idx = selected.findIndex((s: any) => s.name === serviceName);
    if (idx !== -1) selected.splice(idx, 1);
  }

  editGroupConfig(group: any, configIndex: number) {
    const config = group.configs[configIndex];
    const service = this.services.find(s => s.name === config.name);
    if (service) {
      this.activeGroupId = group.id;
      this.selectedService = service;
      this.addNewConfig = true;
      // edit a single saved config (single-service context, no review step)
      this.wizardServices = [service];
      this.wizardStep = 0;
      this.isReviewStep = false;
      this.selectedPieceIndex = 0;
      this.bendViewMode = 'formed';
      // Edit a DEEP copy so in-progress changes don't mutate the saved config, and
      // leave the original in place — tracked by editIndex so saveService replaces
      // it in-place instead of removing + re-adding. This way, backing out of the
      // configure screen ("Back to items") keeps the saved service and its data
      // intact instead of losing it.
      const clone = JSON.parse(JSON.stringify(config));
      clone.isSaved = false;
      clone.editIndex = configIndex;
      this.draftConfig = clone;
      this.wizardDrafts = { [service.name]: this.draftConfig };
    }
  }

  get unassignedUnitsCount(): number {
    const total = this.flattenedSplitItems?.length || 0;
    if (this.serviceFlow === 'together') return 0;
    if (this.serviceFlow === 'separately') return total - this.selectedSplitIndices.size;

    const assignedInGroups = this.serviceGroups.reduce((sum, g) => sum + (g.qty || 0), 0);
    return total - assignedInGroups;
  }

  get activeServiceGroups(): any[] {
    const total = this.flattenedSplitItems?.length || 0;
    return this.serviceGroups.filter((g, idx) => {
      if (idx === 0) return true;
      const assignedBefore = this.serviceGroups.slice(0, idx).reduce((s, prev) => s + (prev.qty || 0), 0);
      return assignedBefore < total;
    });
  }

  get flattenedSplitItems(): any[] {
    const result: any[] = [];
    const source = (this.selectedVariantProducts && this.selectedVariantProducts.length > 0 && !this.addNewProduct) ? this.selectedVariantProducts : [this.selectedProductForNewConfig];
    if (!source || source.length === 0 || !source[0]) return [];

    source.forEach((item: any, itemIdx: number) => {
      const qty = item.qty || item.cartQty || 1;
      for (let i = 0; i < qty; i++) {
        result.push({
          ...item,
          originalItemIndex: itemIdx,
          unitIndex: i,
          displayLabel: `ITEM ${result.length + 1}`,
          uniqueIndex: result.length
        });
      }
    });
    return result;
  }

  trackByUniqueIndex(index: number, item: any) {
    return item.unitIndex + '-' + item.originalItemIndex;
  }

  toggleUnitSelection(index: number) {
    if (this.selectedSplitIndices.has(index)) {
      this.selectedSplitIndices.delete(index);
    } else {
      this.selectedSplitIndices.add(index);
    }
    // Reassign the Set to trigger Angular change detection
    this.selectedSplitIndices = new Set(this.selectedSplitIndices);
  }

  isUnitSelected(index: number): boolean {
    return this.selectedSplitIndices.has(index);
  }

  onConfigureSplitServices() {
    if (this.selectedSplitIndices.size > 0) {
      this.isConfiguringSplit = true;
    }
  }

  cancelSplitSelection() {
    this.selectedSplitIndices.clear();
    this.isConfiguringSplit = false;
    this.splitItemsIndividually = false;
  }
  selectedService: any;
  get multipleVarientsPopupOpen(): boolean {
    return this._multipleVarientsPopupOpen;
  }
  selectedVariantProducts: any = [];
  multipleVarientsSubscription = new Subscription();
  services: any[] = [
    { name: 'Cutting', qty: 1, productOptionType: 0, notes: '', price: 0, msg: "Custom cuts to your specs", img: "/cutting-img.svg", configs: [], minimumServiceFee: 0, includedQtyInMinimumFee: 0, eachAdditionalPrice: 0 },
    { name: 'Bending', qty: 1, productOptionType: 1, notes: '', price: 0, msg: "Custom bends to your specs", img: "/bending-img.svg", configs: [], minimumServiceFee: 0, includedQtyInMinimumFee: 0, eachAdditionalPrice: 0 },
    { name: 'Slitting', qty: 1, productOptionType: 3, notes: '', price: 0, msg: "Slits rolls-based materials", img: "/slitting-img.svg", configs: [], minimumServiceFee: 0, includedQtyInMinimumFee: 0, eachAdditionalPrice: 0 },
    { name: 'Punching', qty: 1, productOptionType: 2, Punching: false, price: 0, notes: '', msg: "Punches vinyl for plotter compatibility", img: "/punching-img.svg", configs: [], minimumServiceFee: 0, includedQtyInMinimumFee: 0, eachAdditionalPrice: 0 },
  ];

  get hasSavedServices(): boolean {
    return this.serviceGroups.some(g => g.configs && g.configs.length > 0) ||
      this.services.some(s => s.configs && s.configs.length > 0);
  }

  addNewConfig = false;
  isSavingService = false;
  showSavedState = false;
  selectedProductForNewConfig: any;
  filterServicesForNewConfig: any = [];
  // draftConfig is the configurator's working copy. A baseline signature is captured
  // every time a fresh draft is assigned (configurator opened) so we can tell whether
  // the user actually changed anything — used to suppress the "discard changes?" popup
  // when the configure screen is closed without edits.
  private _draftConfig: any = null;
  private _draftBaseline: string | null = null;
  get draftConfig(): any { return this._draftConfig; }
  set draftConfig(val: any) {
    this._draftConfig = val;
    this._draftBaseline = val ? this.draftSignature(val) : null;
  }

  /** Normalised signature of the user-editable fields of a configurator draft. Used to
   *  detect real edits; must include every field the user can change so a genuine edit
   *  is never missed (a false "dirty" only keeps the existing prompt, which is safe). */
  private draftSignature(d: any): string {
    if (!d) return '';
    try {
      return JSON.stringify({
        measurements: d.measurements ?? null,
        bendRows: d.bendRows ?? null,
        pieces: (d.pieces || []).map((p: any) => ({
          bendRows: p?.bendRows ?? null,
          width: p?.width ?? null,
          length: p?.length ?? null,
          qty: p?.qty ?? null,
          bendPreset: p?.bendPreset ?? null,
        })),
        bendPreset: d.bendPreset ?? null,
        internalQty: d.internalQty ?? null,
        notes: d.notes ?? '',
        uploadedFile: d.uploadedFile?.url ?? null,
      });
    } catch {
      return '';
    }
  }

  /** True when the open configurator draft differs from its initial (just-opened) state. */
  isDraftDirty(): boolean {
    if (!this._draftConfig) return false;
    return this.draftSignature(this._draftConfig) !== this._draftBaseline;
  }
  /** Snapshot of the saved services taken when re-opening the drawer via "Edit",
   *  so a "discard on close" can revert in-session edits while keeping them. */
  editServicesSnapshot: any = null;
  activeSpecKey: string | null = null;
  showDiscardPopup: boolean = false;
  discardType: 'config' | 'modal' = 'config';
  includeRemainingMaterial: boolean = true;

  getLetter(index: number): string {
    return 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'[index] || String(index + 1);
  }

  get isMaterialFullyAllocated(): boolean {
    return this.totalInternalQty >= (this.draftConfig?.qty || 0);
  }

  /** Cutting/other services: every measurement row must have width, length and qty
   *  filled. Slitting only slits along the width, so length is not required. */
  get isCutMeasurementsValid(): boolean {
    return this.areMeasurementsValid(this.draftConfig, this.selectedService?.name);
  }

  /** Bending can't be added/saved until at least one bend has been configured. */
  get isBendConfigValid(): boolean {
    return this.isBendDraftValid(this.draftConfig);
  }

  // The two checks above, on an explicit config instead of the one on screen, so the
  // stepper can test a step the user isn't currently standing on.
  private areMeasurementsValid(cfg: any, serviceName?: string): boolean {
    const measurements = cfg?.measurements;
    if (!measurements || !measurements.length) return false;
    const isSlitting = (serviceName || '').toLowerCase() === 'slitting';
    return measurements.every((m: any) =>
      m.width != null && Number(m.width) > 0 &&
      (isSlitting || (m.length != null && Number(m.length) > 0)) &&
      m.qty != null && Number(m.qty) > 0
    );
  }

  private isBendDraftValid(cfg: any): boolean {
    // At least one bend, and every bend row must have a direction + angle chosen
    // (the default blank row can't be saved until the user picks them).
    const rowsOk = (rows: any[]) =>
      !!rows?.length && rows.every((r: any) => this.isBendRowComplete(r));
    if (cfg?.pieces?.length) {
      // A piece counts as "being bent" once it has a row with a distance in it — NOT
      // merely a row. Picking a piece now opens an empty starter row (selectBendPiece),
      // so keying off row count alone would mean every piece the user so much as looked
      // at has to be filled in before Confirm unlocks.
      const withBends = cfg.pieces.filter(
        (p: any) => (p.bendRows || []).some((r: any) => this.isBendRowComplete(r))
      );
      return withBends.length > 0
        && withBends.every((p: any) => rowsOk(p.bendRows) && this.coverRowsValid(p));
    }
    return rowsOk(cfg?.bendRows) && this.coverRowsValid(cfg);
  }

  private coverRowsValid(target: any): boolean {
    const opts = target?.bendOptions;
    if (target?.bendPreset !== 'ChannelRaceway' || opts?.includeCover === false) return true;
    return (opts?.coverRows || []).every((r: any) => this.isBendRowComplete(r));
  }

  /** Pieces preview shown in the cut configurator: a cut appears as soon as it has
   *  both a width and a length, even while its qty is still 0. */
  get generatedPieces(): any[] {
    return this.generatedPiecesFor(this.draftConfig).filter((p: any) =>
      p.width != null && Number(p.width) > 0 && p.length != null && Number(p.length) > 0);
  }

  get hasRemainingMaterial(): boolean {
    return this.totalInternalQty > 0 && this.totalInternalQty < (this.draftConfig?.qty || 0);
  }

  clearAllMeasurements(): void {
    if (this.draftConfig) {
      this.draftConfig.measurements = [{ width: null, length: null, qty: 1 }];
    }
  }
  showServiceUnavailablePopup: boolean = false;
  serviceUnavailableVariant: any = null;
  serviceUnavailableVal: any = null;
  serviceUnavailableAttrKey: string = '';
  unavailableServiceOptions: any[] = [];

  @HostBinding('class.header-active')
  get isHeaderActive(): boolean {
    return this.ShowList;
  }

  constructor(
    private api: ApiService,
    private renderer: Renderer2,
    @Inject(DOCUMENT) private document: Document,
    private util: UtilService,
    private router: Router,
    private activateRoute: ActivatedRoute,
    private location: Location
  ) {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.history.push(event.urlAfterRedirects);
      }
    });
  }
  private platformId = inject(PLATFORM_ID);
  private zone = inject(NgZone);
  ngOnDestroy(): void {
    this.removeScrollListener?.();
    this.cartSubscription.unsubscribe();
    this.userSubscription.unsubscribe();
    this.quotesSubscription.unsubscribe();
    this.multipleVarientsSubscription.unsubscribe();
    this.productServiceActionSubscription.unsubscribe();
    this.renderer.removeClass(this.document.body, 'no-scroll');
  }
  async ngOnInit() {
    this.initScrollState();
    this.isAccountPage = this.isAccountUrl(this.router.url);
    this.routerSubscription = this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(async (event: any) => {
        if (isPlatformBrowser(this.platformId)) {
          let token = localStorage.getItem('token');
          if (token && this.priviousToken != token) {
            let [user, cartResult] = await Promise.all([
              this.api.getCurrentUser(),
              this.api.getCartList().catch(() => null)
            ]);
            this.priviousToken = token;
            this.util.setCurrentUser(user);
            this.util.setCurrentCustomer(user.customer);
            this.adminWithoutCustomer = !user.customer ||
              (Array.isArray(user.customer) && user.customer.length === 0) ||
              (typeof user.customer === 'object' && Object.keys(user.customer).length === 0);
            this.util.CartUpdated(cartResult || []);
          }
          if (!this.checkToken()) {
            this.util.setCurrentUser(null);
            this.util.setAdminToken(null);
            localStorage.removeItem('token');
            localStorage.removeItem('currentUser');
            localStorage.removeItem('adminToken');
            this.util.CartUpdated([]);
          }
        }
        this.isHomePage = event.urlAfterRedirects === '/';
        this.isAccountPage = this.isAccountUrl(event.urlAfterRedirects);
        // Admin only. The account area used to drop the header on phones too, but the
        // redesign keeps it (Figma "Mobile>Account>overview", 15051:278987).
        if (this.router.url.includes('admin') && this.checkScreenSize()) {
          this.showMainHeader = false;
        } else {
          this.showMainHeader = true;
        }

        if (event.urlAfterRedirects.split('/')[1].startsWith('search')) {
          let res = decodeURIComponent(event.urlAfterRedirects.split('=')[1]);
          this.searchValue = res.replace('&page', '');
        }
        if (this.isHomePage) {
          this.searchValue = '';
        }

        if (
          event.urlAfterRedirects.split('/')[1] === 'compare' ||
          event.urlAfterRedirects.split('/')[1] === 'account' ||
          event.urlAfterRedirects.startsWith('/admin/customers') ||
          event.urlAfterRedirects.startsWith('/admin/pages') ||
          /^\/admin\/customer\/\d+$/.test(event.urlAfterRedirects)
        ) {
          if (event.urlAfterRedirects.split('/')[1] === 'compare') {
            this.compareActive = true;
          }
        }
        // Only the search term (`q`) belongs in the box — product URLs carry other
        // query params too (e.g. ?noRedirect=true on a replaced item's link).
        if (event.url.startsWith('/product'))
          this.searchValue = this.router.parseUrl(event.url).queryParamMap.get('q') ?? '';
        if (this.searchValue === 'undefined') {
          this.searchValue = '';
        }
        if (this.multipleVarientsPopupOpen) {
          this.multipleVarientsPopupOpen = false;
        }
      });
    this.cartSubscription = this.util.cart$.subscribe((cart) => {
      this.cartList = cart;
      this.cartCount = this.cartList.items?.reduce(
        (sum: number, item: any) => sum + item.qty,
        0
      );
    });
    this.adminTokenSubscription = this.util.adminToken$.subscribe((token) => {
      this.loggedAsCustomer = !!token;
    });
    // Keep the latest quote lines so the quotes-list "Editing Services" drawer can
    // resolve the clicked quoteId to its product + configured services.
    this.quotesSubscription = this.util.quotes$.subscribe((res: any) => {
      this.quotesList = res?.items || [];
    });
    if (isPlatformBrowser(this.platformId)) {
      this.loggedAsCustomer = !!localStorage.getItem('adminToken');
    }

    this.userSubscription = this.util.user$.subscribe((user) => {
      this.user = user;
    });
    this.userSubscription = this.util.checkToken$.subscribe((token) => {
      const decoded: any = jwtDecode(token);
      let userRole =
        decoded['http://schemas.microsoft.com/ws/2008/06/identity/claims/role'];
      if (userRole.some((data: string) => data === 'Admin')) {
        this.isAdmin = true;
      }
    });
    if (this.authService.isAuthenticated() && this.authService.isAdmin()) {
      this.isAdmin = true;
    }

    this.multipleVarientsSubscription = this.util.multipleVarients$.subscribe((res: any) => {
      try {
        if (res) {
          this._variantPopupJustTriggered = true;
          setTimeout(() => { this._variantPopupJustTriggered = false; }, 0);
          // Fresh drawer: clear any leftover "Editing Services" state so the variant
          // attributes (configure-heading-attrs) don't leak into the product-detail flow.
          this.editingVariantServices = false;
          this.editingVariant = null;
          this.cameFromEditServices = false;

          if (res?.__generatorMode) {
            this.openGeneratorServices(res);
            return;
          }
          this.generatorMode = false;
          this.generatorAllowedServices = null;
          this.generatorRecordId = null;

          // Quotes-list deep-link: open the "Editing Services" drawer for a single
          // quote line and persist back to the quote (services only).
          if (res?.__quoteMode && res?.editServicesForQuoteId) {
            this.openQuoteEditServices(res.editServicesForQuoteId);
            return;
          }
          this.quoteMode = false;

          if (res?.productOptionsDTO?.length > 0 && !res?.editVariants) {
            this.multipleVarientsPopupOpen = true;
            this.addNewProduct = true;
            this.isEditVariantMode = false;
            // Opened from the product-detail "Add Services" button: services are saved
            // back to the product page (button reads "Save Services"), not added to cart here.
            this.addServiceMode = !!res?.__addServiceMode;
            this.selectedProductForNewConfig = JSON.parse(JSON.stringify(res));
            this.filterServicesForNewConfig = this.getFilteredServicesForConfig(res);
            this.setServiceFlow('together');
          } else {
            this.addServiceMode = false;
            this.multipleVarientsPopupOpen = true;
            this.addNewProduct = false;
            this.selectedProductForNewConfig = JSON.parse(JSON.stringify(res));
            this.selectedVariantProducts = this.findItemsWithSamePartName(res);
            console.log('Selected variants for config:', this.selectedVariantProducts);
            this.filterServicesForNewConfig = this.getFilteredServicesForConfig(res);
            this.isEditVariantMode = res.editVariants || false;
            this.setServiceFlow('together');

            // Deep-link from the cart page. A line that ALREADY has services opens the
            // Editing Services drawer so the existing services are shown (edit/remove)
            // and more can be added. A line with NO services opens the full S&F Services
            // configurator (all units / split into groups / each unit); isEditVariantMode
            // + cartId make onDone replace the original line with the configured groups.
            if (res.editServicesForCartId) {
              const target = this.selectedVariantProducts?.find(
                (v: any) => v.cartId === res.editServicesForCartId
              );
              if (target?.options?.length > 0) {
                this.openVariantEditServices(target);
              } else {
                this.addNewProduct = true;
                this.isEditVariantMode = true;
                this.selectedProductForNewConfig.cartId = res.editServicesForCartId;
                this.selectedProductForNewConfig.qty = Number(res.qty) || this.selectedProductForNewConfig.qty || 1;
                // Rebuild the flow now that this is the single-product configurator so
                // the unit count (and the flow-selection row) reflect this line's qty.
                this.setServiceFlow('together');
              }
            }
          }
        } else {
          this.selectedVariantProducts = [];
          this.multipleVarientsPopupOpen = false;
        }
      } catch (error) {
      }
    });

    // product-detail "Add Services" flow: commit / edit / remove the pending services
    this.productServiceActionSubscription = this.util.productServiceAction$.subscribe(({ action, product, names }) => {
      if (action === 'commit') {
        // The user may have changed size after saving services; commit against the
        // latest product so the current slug is added to cart, not the stale one.
        if (product) this.syncPendingServiceProductSlug(product);
        this.onDone();
      } else if (action === 'commitQuote') {
        // Same as 'commit' but the product + services go to Quotes instead of Cart.
        if (product) this.syncPendingServiceProductSlug(product);
        this.onDoneQuote();
      } else if (action === 'edit') {
        // Snapshot the already-saved services so that "close + discard" reverts the
        // in-session edits WITHOUT destroying the saved state the product page still
        // references (otherwise re-opening Edit shows an empty drawer).
        this.editServicesSnapshot = this.captureServiceState();
        this.multipleVarientsPopupOpen = true;
      } else if (action === 'remove') {
        this.forceClosePopup();
      } else if (action === 'removeSome') {
        this.removeConfiguredServicesByName(names || [], product);
      }
    });
  }

  findItemsInCart(item: any) {
    const items = this.cartList?.items?.filter((cartItem: any) =>
      (cartItem.product?.urlSlug || cartItem.urlSlug) === (item?.urlSlug || item?.product?.urlSlug)
    );
    return items ? JSON.parse(JSON.stringify(items)) : [];
  }

  findItemsWithSamePartName(product: any) {
    let partList = this.cartList?.items?.filter((cartItem: any) => {
      return cartItem?.product?.partName === product?.partName;
    });
    const cloned = partList ? JSON.parse(JSON.stringify(partList)) : [];
    cloned.forEach((item: any) => {
      item.options = this.hydrateOptionsFromServices(item);
      // Restore the order-level (general) diagram so the drawer shows it. Per-service
      // files (e.g. the bending sketch) are restored onto their option instead.
      const att = (item?.services?.order?.attachments || [])
        .find((a: any) => a?.url && (a?.scope === 'general' || !a?.scope));
      if (att) item.uploadedFile = { name: att.filename, url: att.url };
    });
    return cloned;
  }

  /**
   * Rebuild the local `options` working model from a cart line's v2.0 services
   * order. The cart API no longer returns the old `options` array — services now
   * live in item.services.order.billing.services (keyed by name). The variant
   * editor (service display, edit and the save round-trip via
   * buildServicesFromSavedOptions) is built around `options`, so we reconstruct
   * it here whenever variants are loaded from the cart.
   */
  private hydrateOptionsFromServices(item: any): any[] {
    const order = item?.services?.order;
    const services = order?.billing?.services;
    if (!services) return [];
    const meta: { [key: string]: { productOptionType: number; serviceType: number } } = {
      cutting: { productOptionType: 0, serviceType: 2 },
      bending: { productOptionType: 1, serviceType: 3 },
      punching: { productOptionType: 2, serviceType: 4 },
      slitting: { productOptionType: 3, serviceType: 5 },
    };
    // Attachments are scoped: 'general' is the order-level diagram (handled by the
    // variant's uploadedFile), while 'bending'/'cutting' belong to that service.
    const attachments = order?.attachments || [];
    const scopeForKey = (k: string) =>
      k === 'bending' ? 'bending' : (k === 'cutting' || k === 'slitting') ? 'cutting' : 'general';

    // Reconstruct the configurator geometry from the stored order so the edit
    // screen reloads the real width/length/bends instead of falling back to 1.
    const measurements = this.measurementsFromOrder(order);
    const bendPieces = this.bendPiecesFromOrder(order);
    // Whether the leftover material was returned to the customer (vs discarded).
    const includeRemainingMaterial = this.orderIncludesRemaining(order);

    return Object.keys(services)
      .filter((key) => key !== 'material' && meta[key])
      .map((key) => {
        const line = services[key];
        const opt: any = {
          productOptionType: meta[key].productOptionType,
          serviceType: meta[key].serviceType,
          qty: Number(line?.quantity) || 1,
          totalPrice: Number(line?.total) || 0,
          minimumServiceFee: Number(line?.basePrice) || 0,
          includedQtyInMinimumFee: Number(line?.includedQuantity) || 0,
          eachAdditionalPrice: Number(line?.additionalUnitPrice) || 0,
          includeRemainingMaterial,
        };
        // Cut-producing services carry the entered piece dimensions; bending
        // carries the per-piece bend rows.
        if ((key === 'cutting' || key === 'slitting') && measurements.length) {
          opt.measurements = JSON.parse(JSON.stringify(measurements));
        }
        if (key === 'bending' && bendPieces.length) {
          opt.pieces = JSON.parse(JSON.stringify(bendPieces));
          opt.bendRows = JSON.parse(JSON.stringify(bendPieces[0].bendRows || []));
          // Standalone bend restore: carry the sheet's bend side so re-editing keeps it.
          opt.bendAxis = bendPieces[0].bendAxis === 'width' ? 'width' : 'length';
          if (bendPieces[0].bendOptions) opt.bendOptions = JSON.parse(JSON.stringify(bendPieces[0].bendOptions));
        }
        if (order?.notes) opt.notes = order.notes;
        // Attach this service's own scoped file (e.g. the bending sketch).
        const att = attachments.find((a: any) => a?.url && a?.scope === scopeForKey(key) && a?.scope !== 'general');
        if (att) {
          opt.document = att.url;
          opt.OriginalFileName = att.filename;
          opt.uploadedFile = { name: att.filename, url: att.url };
        }
        return opt;
      });
  }

  /** True when the order's leftover material was returned to the customer
   *  (a returned "Remaining Material" piece) rather than discarded as scrap. */
  private orderIncludesRemaining(order: any): boolean {
    return (order?.pieces || []).some(
      (p: any) => p?.role === 'output' && p?.customerDisposition === 'return' && p?.label === 'Remaining Material'
    );
  }

  /** Rebuild the cut measurements (width × length × qty) from the order's
   *  "return" output pieces, grouping identical dimensions back into one row.
   *  The leftover "Remaining Material" piece is excluded — it is not a cut. */
  private measurementsFromOrder(order: any): any[] {
    // A raceway cover is cut by the builder itself (v2.1) — not a row the user typed.
    const pieces = (order?.pieces || []).filter(
      (p: any) => p?.role === 'output' && p?.customerDisposition === 'return' && p?.label !== 'Remaining Material'
        && !isCoverPiece(p)
    );
    const byDims = new Map<string, any>();
    pieces.forEach((p: any) => {
      const width = p.dimensions?.width ?? p.dimensions?.diameter ?? null;
      const length = p.dimensions?.length ?? null;
      const qty = Number(p.quantity) || 1;
      const dimsKey = `${width}|${length}`;
      if (byDims.has(dimsKey)) byDims.get(dimsKey).qty += qty;
      else byDims.set(dimsKey, { width, length, qty });
    });
    return Array.from(byDims.values());
  }

  /** Rebuild per-piece bend rows from the order's bent pieces. The builder stores
   *  cumulative bend distances, so convert them back to per-segment distances. */
  private bendPiecesFromOrder(order: any): any[] {
    return bentPiecesWithCovers(order?.pieces || []).map(({ piece: p, cover }) => {
      const rows = (p.bends || []).slice().sort((a: any, b: any) => a.sequence - b.sequence);
      let prev = 0;
      const bendRows = rows.map((b: any) => {
        // v2.0 (new): top-level `distance`; older stored payloads used `position.distance`.
        const cumulative = Number(b.distance ?? b.position?.distance) || 0;
        const distance = cumulative - prev;
        prev = cumulative;
        return { distance, direction: b.direction || 'up', angle: b.angle ?? 90 };
      });
      // Which edge the bends were measured along, so re-editing restores the side.
      // v2.0 (new): piece-level `bendFromEdge`; older payloads used per-bend geometry.
      const first = rows[0];
      const bendAxis = (p.bendFromEdge === 'width' || first?.position?.referenceEdge === 'width' || first?.orientation === 'parallel-to-length')
        ? 'width' : 'length';
      const piece: any = {
        label: p.label,
        width: p.dimensions?.width ?? null,
        length: p.dimensions?.length ?? null,
        qty: Number(p.quantity) || 1,
        bendRows,
        bendPreset: presetFromWire(p.bendPreset),
        bendAxis,
      };
      // v2.1 sends the cover as its own piece; fold it back into the channel's
      // options. A raceway saved without one had its cover switched off.
      if (piece.bendPreset === 'ChannelRaceway') {
        piece.bendOptions = cover
          ? { includeCover: true, coverRows: cover.bendRows.map((r) => ({ ...r, useCustom: false, customAngle: null, userSet: true })), coverEndFlange: cover.endFlange ?? null }
          : { includeCover: false };
      }
      return piece;
    });
  }

  getVariantGrandTotal() {
    return this.selectedVariantProducts?.reduce((total: number, variant: any) => {
      return total + (variant.price * variant.qty);
    }, 0);
  }

  handleVariantPlus(variant: any) {
    variant.qty = Number(variant.qty) + 1;
    variant.qtyChanged = true;
  }

  handleVariantMinus(variant: any) {
    if (variant.qty > 1) {
      variant.qty = Number(variant.qty) - 1;
      variant.qtyChanged = true;
    } else {
      variant.pendingDelete = true;
    }
  }

  toggleEditDetails(variant: any) {
    variant.showEditDetails = !variant.showEditDetails;
    if (variant.showEditDetails) {
      if (!variant.expandedSections) variant.expandedSections = {};
      // Keep the full attributeSelector from the API-fetched selectedProductForNewConfig.
      // Only fall back to variant.product if selectedProductForNewConfig isn't set yet.
      if (!this.selectedProductForNewConfig) {
        this.selectedProductForNewConfig = JSON.parse(JSON.stringify(variant.product || variant));
      }
      // Update cart context for this specific variant (used by service section)
      this.selectedProductForNewConfig.cartId = variant.cartId;
      this.selectedProductForNewConfig.qty = variant.qty;
      this.filterServicesForNewConfig = this.getFilteredServicesForConfig(this.selectedProductForNewConfig);
      this.setServiceFlow('together');
    }
  }

  toggleSection(variant: any, section: string) {
    if (!variant.expandedSections) variant.expandedSections = {};
    variant.expandedSections[section] = !variant.expandedSections[section];
  }

  isSectionExpanded(variant: any, section: string): boolean {
    return variant.expandedSections?.[section] || false;
  }

  toggleVariantServiceSection(variant: any) {
    this.toggleSection(variant, 'service');
  }

  toggleVariantInlineService(variant: any, service: any) {
    if (!variant.inlineSelectedServices) variant.inlineSelectedServices = [];
    const idx = variant.inlineSelectedServices.findIndex((s: any) => s.name === service.name);
    if (idx === -1) {
      variant.inlineSelectedServices.push(service);
    } else {
      variant.inlineSelectedServices.splice(idx, 1);
    }
  }

  isVariantInlineServiceSelected(variant: any, service: any): boolean {
    return variant.inlineSelectedServices?.some((s: any) => s.name === service.name) || false;
  }

  hasVariantInlineServiceSelected(variant: any): boolean {
    return (variant.inlineSelectedServices?.length || 0) > 0;
  }

  configureVariantInlineService(variant: any) {
    if (!(variant.inlineSelectedServices?.length > 0)) return;

    this.selectedProductForNewConfig = JSON.parse(JSON.stringify(variant.product || variant));
    this.selectedProductForNewConfig.cartId = variant.cartId;
    this.selectedProductForNewConfig.qty = variant.qty;
    this.selectedProductForNewConfig.options = variant.options || [];
    this.filterServicesForNewConfig = this.getFilteredServicesForConfig(this.selectedProductForNewConfig);
    this.setServiceFlow('together');

    // Resolve each inline-selected option to a full service definition
    const services = variant.inlineSelectedServices
      .map((option: any) =>
        this.filterServicesForNewConfig.find((s: any) => s.productOptionType === option.productOptionType)
        || this.services.find((s: any) => s.productOptionType === option.productOptionType)
      )
      .filter(Boolean);

    if (services.length > 0) {
      // No groupId here: this is a single cart variant (not a split group), so the
      // wizard saves onto the service config directly. Passing variant.cartId as a
      // groupId would set activeGroupId to a cart GUID — breaking saveService() and
      // showing the raw id on the save button.
      this.startConfigureWizard(services, this.selectedProductForNewConfig, variant.qty);
      // render the header's Configure stepper screen (not the add-services-modal)
      // and remember to return to the "Variants Already in Cart" edit view afterwards
      this.addNewProduct = true;
      this.cameFromVariantEdit = true;
    }
  }

  isVariantServiceConfigured(variant: any, service: any): boolean {
    return variant.options?.some((opt: any) => opt.productOptionType === service.productOptionType) || false;
  }

  /** Distinct configured service names for a cart variant, e.g. "Cutting & Bending". */
  getVariantServiceNames(variant: any): string {
    const names = new Set<string>();
    (variant.options || []).forEach((o: any) => {
      const n = this.getServiceName(o.productOptionType);
      if (n) names.add(n);
    });
    return Array.from(names).join(' & ');
  }

  /** Open the dedicated "Editing Services" drawer for a cart variant: lists the
   *  already-configured services with per-service Edit / Remove, plus file upload. */
  openVariantEditServices(variant: any) {
    this.editingVariant = variant;
    // Start with no pending (ticked-but-unconfigured) service selections.
    this.editVariantSelectedTypes.clear();
    // Track whether this editing session actually changes anything, so the
    // "Added" badge / emphasis only fires when a service was added or updated.
    variant.__servicesEditedSession = false;
    this.selectedProductForNewConfig = JSON.parse(JSON.stringify(variant.product || variant));
    this.selectedProductForNewConfig.cartId = variant.cartId;
    this.selectedProductForNewConfig.qty = variant.qty;
    this.selectedProductForNewConfig.options = variant.options || [];
    this.filterServicesForNewConfig = this.getFilteredServicesForConfig(this.selectedProductForNewConfig);
    this.setServiceFlow('together');
    this.cameFromVariantEdit = true;
    this.editingVariantServices = true;
  }

  /** Open the cart's "Editing Services" drawer for a single quote line. The quote line
   *  is wrapped as a one-element variant set so the existing (cartId-keyed) drawer
   *  plumbing works unchanged; saving routes to the Quotes API instead of the cart. */
  private openQuoteEditServices(quoteId: string) {
    const quote = (this.quotesList || []).find((q: any) => q.quoteId === quoteId);
    if (!quote) { this.quoteMode = false; return; }
    this.quoteMode = true;
    this.addServiceMode = false;
    const variant = this.buildQuoteVariant(quote);

    if (variant.options && variant.options.length > 0) {
      // Line already has services → the "Editing Services" drawer (edit / remove /
      // add more), unchanged.
      this.addNewProduct = false;
      this.isEditVariantMode = false;
      this.selectedVariantProducts = [variant];
      this.multipleVarientsPopupOpen = true;
      this.openVariantEditServices(variant);
    } else {
      // No services yet → open the full S&F configurator WITH the split selector
      // (ALL UNITS TOGETHER / SPLIT INTO GROUPS / EACH UNIT SEPARATELY), matching the
      // cart. The quoteId rides on selectedProductForNewConfig so onDoneQuote replaces
      // this line (delete + re-add one line per group/unit).
      this.addNewProduct = true;
      this.isEditVariantMode = true;
      this.selectedVariantProducts = [];
      this.selectedProductForNewConfig = JSON.parse(JSON.stringify(quote.product || quote));
      this.selectedProductForNewConfig.quoteId = quote.quoteId;
      this.selectedProductForNewConfig.qty = Number(quote.qty) || 1;
      this.filterServicesForNewConfig = this.getFilteredServicesForConfig(quote.product || quote);
      this.multipleVarientsPopupOpen = true;
      this.setServiceFlow('together');
    }
  }

  /** /generate-services entry point. `res` = { __generatorMode, __generatorServices,
   *  product (full product detail), qty, services?, recordId? }. With no services it
   *  opens the configurator; with a saved schema it opens the "Editing Services" drawer
   *  hydrated from it, exactly like a cart/quote line that already has services. */
  private openGeneratorServices(res: any) {
    this.quoteMode = false;
    this.addServiceMode = false;
    this.generatorMode = true;
    this.generatorAllowedServices = res.__generatorServices || null;
    this.generatorRecordId = res.recordId || null;
    const product = JSON.parse(JSON.stringify(res.product || {}));
    const qty = Number(res.qty) || 1;

    if (res.services?.order) {
      const variant: any = {
        product,
        cartId: this.generatorRecordId || 'generated',   // the drawer plumbing keys on cartId
        qty,
        price: product.price,
        options: this.hydrateOptionsFromServices(res),
      };
      const att = (res.services.order.attachments || [])
        .find((a: any) => a?.url && (a?.scope === 'general' || !a?.scope));
      if (att) variant.uploadedFile = { name: att.filename, url: att.url };
      this.addNewProduct = false;
      this.isEditVariantMode = false;
      this.selectedVariantProducts = [variant];
      this.multipleVarientsPopupOpen = true;
      this.openVariantEditServices(variant);
    } else {
      this.addNewProduct = true;
      this.isEditVariantMode = false;
      this.selectedVariantProducts = [];
      this.selectedProductForNewConfig = product;
      this.selectedProductForNewConfig.qty = qty;
      this.selectedProductForNewConfig.cartQty = qty;
      this.filterServicesForNewConfig = this.getFilteredServicesForConfig(product);
      this.multipleVarientsPopupOpen = true;
      this.setServiceFlow('together');
    }
  }

  /** Generator "Editing Services" save: rebuild the schema from the edited options. */
  saveGeneratorServiceChanges() {
    const variant = this.editingVariant;
    const options = variant?.options || [];
    if (!options.length) {
      this.util.showQuotesToast('Add at least one service', 'error', undefined);
      return;
    }
    const qty = Number(variant.qty) || 1;
    this.util.emitGeneratedServices({
      productSlug: variant.product?.urlSlug || '',
      qty,
      services: this.buildServicesFromSavedOptions(variant.product, qty, options, undefined, variant.uploadedFile),
      recordId: this.generatorRecordId,
    });
    this.forceClosePopup();
  }

  /** Generator configurator save: same config collection as the single-line cart
   *  update in onDone (the generator is always one 'together' line). */
  private onDoneGenerator() {
    const product = this.selectedProductForNewConfig;
    const qty = Number(product?.qty) || 1;
    const seenCfg = new Set<any>();
    const configs = [
      ...(this.serviceGroups || []).flatMap((g: any) => g.configs || []),
      ...(this.services || []).flatMap((s: any) => s.configs || []),
    ].filter((c: any) => c && !seenCfg.has(c) && seenCfg.add(c));
    if (!configs.length) {
      this.util.showQuotesToast('Add at least one service', 'error', undefined);
      return;
    }
    this.util.emitGeneratedServices({
      productSlug: product?.urlSlug || '',
      qty,
      services: this.buildServicesFromConfigs(product, qty, configs, undefined, (this.serviceGroups || [])[0]?.uploadedFile),
      recordId: this.generatorRecordId,
    });
    this.forceClosePopup();
  }

  /** Wrap a quote line as a drawer "variant": cartId is set to the quoteId so the
   *  existing drawer code (which keys on cartId) operates on it, and the configured
   *  services are rebuilt into the local `options` model the drawer edits. */
  private buildQuoteVariant(quote: any) {
    const product = JSON.parse(JSON.stringify(quote.product || quote));
    const variant: any = {
      product,
      cartId: quote.quoteId,   // reuse the cartId-keyed drawer plumbing
      quoteId: quote.quoteId,
      qty: quote.qty || 1,
      price: quote.price,
      options: this.hydrateOptionsFromServices(quote),
    };
    const att = (quote?.services?.order?.attachments || [])
      .find((a: any) => a?.url && (a?.scope === 'general' || !a?.scope));
    if (att) variant.uploadedFile = { name: att.filename, url: att.url };
    // Remember which services existed so an "all removed" save can clear them.
    variant.__originalServiceTypes = (variant.options || []).map((o: any) => o.productOptionType);
    return variant;
  }

  /** Persist the quote line's edited services. Quotes/addoption REPLACES the whole
   *  service set, so post the full current option set; if every service was removed,
   *  clear them off the line via the removeoption endpoint. */
  async saveQuoteServiceChanges() {
    const variant = this.editingVariant;
    if (!variant) { this.forceClosePopup(); return; }
    const quoteId = variant.quoteId || variant.cartId;
    const qty = variant.qty || 1;
    const options = variant.options || [];
    this.util.setLoder(true);
    try {
      if (options.length > 0) {
        const services = this.buildServicesFromSavedOptions(variant.product, qty, options, quoteId, variant.uploadedFile);
        await this.api.addOptions({ QuoteId: quoteId, qty, services });
      } else {
        for (const type of (variant.__originalServiceTypes || [])) {
          await this.api.removeQuoteService({ quoteId, productOptionType: type });
        }
      }
      const quotes = await this.api.getQuotes();
      this.util.quotes$.next(quotes);
      this.util.showQuotesToast('Services updated', 'success', undefined);
    } catch (err: any) {
      const warning = err?.error?.warnings?.[0] || err?.error?.message || err?.error?.title;
      this.util.showQuotesToast(warning || 'Error saving services', 'error', undefined);
    } finally {
      this.util.setLoder(false);
      this.forceClosePopup();
    }
  }

  /** Close the "Editing Services" drawer and return to the "Variants Already in Cart" list. */
  closeVariantEditServices() {
    // Quote / generator mode has no variant list to return to — closing discards and exits.
    if (this.quoteMode || this.generatorMode) { this.forceClosePopup(); return; }
    const edited = this.editingVariant;
    // If a service was added/updated in this session, briefly emphasise the
    // variant's saved-service card and show an "Added" badge on return.
    if (edited?.__servicesEditedSession) {
      edited.__justSavedServices = true;
      setTimeout(() => { edited.__justSavedServices = false; }, 4000);
    }
    this.editingVariantServices = false;
    this.editingVariant = null;
  }

  /** Leave the configure screen (without saving) and return to the "Editing Services" drawer. */
  backToEditServices() {
    this.draftConfig = null;
    this.addNewConfig = false;
    this.addNewProduct = false;
    this.selectedService = null;
    this.wizardServices = [];
    this.wizardDrafts = {};
    this.wizardPieceSelection = {};
    this.cameFromEditServices = false;
    this.editingVariantServices = true;
  }

  /** Save the configured service back onto the variant's option, then return to the
   *  "Editing Services" drawer with the just-saved service flagged as "Added". */
  async saveEditServiceConfig(confirmed = false) {
    if (this.isSavingService) return;

    // Editing an existing Cutting option re-derives the variant's bend pieces, so
    // confirm before applying when configured bends already exist on the variant.
    if (!confirmed && (this.draftConfig?.name || '').toLowerCase() === 'cutting'
        && this.draftConfig?.editVariantOption && this.variantBendingWithBends()
        && !this.draftConfig?.__cutRemoved) {
      this.askServiceConfirm({
        title: 'Bend Configuration Needs Updating',
        message: 'Changes to cutting affect the pieces available for bending. Existing bend configurations will be removed and will need to be reconfigured.',
        affected: ['Cutting', 'Bending'],
        cancelLabel: 'CANCEL',
        confirmLabel: 'UPDATE CUTTING',
        onConfirm: () => this.saveEditServiceConfig(true),
      });
      return;
    }

    // Saving Cutting on a variant that already carries bends invalidates the pieces
    // those bends sit on. Drop the dependent Bending so the user re-adds it against the
    // new cuts. This applies both when editing an existing Cutting option AND when
    // ADDING a new one (editVariantOption is null then) — the "Cutting Requires Bend
    // Updates" prompt already warned in either case. Removing a single cut piece
    // (__cutRemoved) does the same; its "Remove Cut Piece?" prompt already warned.
    const invalidatesBends =
      (this.draftConfig?.name || '').toLowerCase() === 'cutting'
      && !!this.variantBendingWithBends();

    this.isSavingService = true;
    await new Promise(resolve => setTimeout(resolve, 800));

    let opt = this.draftConfig?.editVariantOption;
    const isNew = !opt;
    if (isNew) {
      // Adding a service that wasn't configured yet → build a fresh option.
      const svc = this.draftConfig?.editVariantNewService || this.selectedService;
      opt = {
        name: svc?.name,
        productOptionType: svc?.productOptionType,
        serviceType: svc?.serviceType,
      };
    }
    if (opt) {
      opt.qty = this.draftConfig.internalQty ?? opt.qty ?? 1;
      opt.measurements = JSON.parse(JSON.stringify(this.draftConfig.measurements || []));
      if (this.selectedService?.name === 'Bending') {
        opt.bendRows = JSON.parse(JSON.stringify(this.activeBend?.bendRows || this.draftConfig.bendRows || []));
        opt.bendPreset = this.bendPreset || null;
        opt.bendAxis = this.bendAxis;
        opt.bendOptions = this.cloneBendOptions(this.activeBend || this.draftConfig);
        if (this.draftConfig.pieces) opt.pieces = JSON.parse(JSON.stringify(this.draftConfig.pieces));
      }
      opt.totalAmount = this.calculateTotal(this.draftConfig);
      // The draft's sketch is the single source of truth for this edit (it was
      // pre-filled from the option's own scoped file and the sketch UI binds to it),
      // so DON'T fall back to the old opt.uploadedFile — that resurrected a removed
      // file. Keep document/OriginalFileName in sync too, otherwise the save's
      // savedOptionToServiceInput falls back to opt.document and re-attaches it.
      opt.uploadedFile = this.draftConfig.uploadedFile || null;
      if (opt.uploadedFile) {
        opt.document = opt.uploadedFile.url;
        opt.OriginalFileName = opt.uploadedFile.name;
      } else {
        opt.document = null;
        opt.OriginalFileName = null;
      }
      // Transient "✓ Added" confirmation on the card in the Editing Services drawer.
      opt.__justAdded = true;
      setTimeout(() => { opt.__justAdded = false; }, 4000);
      if (isNew && this.editingVariant) {
        if (!this.editingVariant.options) this.editingVariant.options = [];
        this.editingVariant.options.push(opt);
      }
    }
    // Saving Cutting invalidates any full-sheet bending already on the variant — drop it
    // so bends get re-added per cut piece (matches the warning shown when adding cutting).
    if ((this.selectedService?.name || '').toLowerCase() === 'cutting' && this.editingVariant?.options) {
      if (invalidatesBends) {
        // Updated cutting → drop all bending so it's re-added per the new cuts.
        this.removeVariantBendingOptions(this.editingVariant);
      } else {
        this.dropFullSheetBendingForCutting(this.editingVariant.options, { name: 'Cutting' });
      }
    }

    // Mark the variant changed so "Save Changes" enables and persists on save.
    if (this.editingVariant) {
      this.editingVariant.servicesChanged = true;
      this.editingVariant.__servicesEditedSession = true;
    }

    this.isSavingService = false;
    // Return to the Editing Services drawer.
    this.draftConfig = null;
    this.addNewConfig = false;
    this.addNewProduct = false;
    this.selectedService = null;
    this.wizardServices = [];
    this.wizardDrafts = {};
    this.wizardPieceSelection = {};
    this.cameFromEditServices = false;
    this.editingVariantServices = true;
  }

  /** Short config summary shown after the service name, e.g. "5 Slits", "5 cuts" or "Z shape". */
  getServiceConfigSummary(option: any): string {
    const name = this.getServiceName(option.productOptionType);
    if (name === 'Bending') {
      // Combined flow stores the preset per piece, not on the option itself, so
      // check the pieces (bendPresetForDraft) before falling back to "Custom".
      const preset = this.bendPresetForDraft(option);
      return preset ? `${preset} shape` : 'Custom shape';
    }
    // Punching has no geometry — a fixed label, not a count.
    if (name === 'Punching') return 'Edge punching';
    const q = option.qty || 0;
    const unit = name === 'Slitting' ? 'Slit' : 'cut';
    return `${q} ${unit}${q === 1 ? '' : 's'}`;
  }

  /** Secondary line under a service, e.g. "3 pieces generated", "2 Bends" or a punching note. */
  getServiceConfigSubLabel(variant: any, option: any): string {
    const name = this.getServiceName(option.productOptionType);
    if (name === 'Bending') {
      const n = option.bendRows?.length || 0;
      return `${n} Bend${n === 1 ? '' : 's'}`;
    }
    if (name === 'Punching') return 'Standard edge punching applied.';
    const p = variant?.qty || 0;
    return `${p} piece${p === 1 ? '' : 's'} generated`;
  }

  /** The variant's configured option for a given service definition, or null if not configured. */
  getVariantOptionForService(variant: any, service: any): any {
    return (variant?.options || []).find(
      (o: any) => o.productOptionType === service.productOptionType
    ) || null;
  }

  /** Tick / untick a not-yet-configured service in the "Editing Services" drawer.
   *  Selecting only marks intent — it does NOT open the configure screen. */
  toggleEditVariantService(service: any) {
    const type = service?.productOptionType;
    if (this.editVariantSelectedTypes.has(type)) {
      this.editVariantSelectedTypes.delete(type);
    } else {
      this.editVariantSelectedTypes.add(type);
    }
  }

  isEditVariantServiceSelected(service: any): boolean {
    return this.editVariantSelectedTypes.has(service?.productOptionType);
  }

  /** Pending (ticked but not-yet-configured) services on the variant being edited,
   *  resolved to full service definitions. */
  private pendingEditVariantServices(): any[] {
    if (!this.editingVariant) return [];
    const options = this.editingVariant.options || [];
    return Array.from(this.editVariantSelectedTypes)
      .filter((type: any) => !options.some((o: any) => o.productOptionType === type))
      .map((type: any) => (this.filterServicesForNewConfig || []).find((s: any) => s.productOptionType === type))
      .filter(Boolean);
  }

  /** Whether the "Editing Services" drawer has anything to apply: a newly-ticked service
   *  to configure, or a service added/edited/removed this session. Drives the enabled
   *  state of the "Update Services" / "Save Services" button — with nothing changed there
   *  is nothing to update, so the button stays disabled. */
  get hasServiceEdits(): boolean {
    return (this.editVariantSelectedTypes?.size || 0) > 0 || !!this.editingVariant?.__servicesEditedSession;
  }

  /** "Update Services" action in the cart "Editing Services" drawer. Routes through the
   *  SAME configurator the product-detail page uses: no-config services (Punching) are
   *  added straight onto the variant, a single configurable service opens its config
   *  screen, and Cutting + Bending together run the combined cut → bend → review wizard.
   *  Everything is persisted back onto the variant's options. */
  onUpdateServicesClick() {
    if (!this.editingVariant) { this.closeVariantEditServices(); return; }
    const pending = this.pendingEditVariantServices();

    // No-config services (e.g. Punching) never open a configure screen — add them now.
    // (This is what made Punching wrongly land on a cut/slit configure view.)
    const noConfig = pending.filter((s: any) => !this.isConfigurableService(s));
    noConfig.forEach((svc: any) => this.addNoConfigOptionToVariant(this.editingVariant, svc));

    // Configurable services use the shared wizard: one = single step; two (Cutting +
    // Bending) = combined cut → bend → review, exactly like the product-detail flow.
    const configurable = pending.filter((s: any) => this.isConfigurableService(s));
    if (configurable.length === 1) {
      this.addVariantServiceConfig(this.editingVariant, configurable[0]);
      return;
    }
    if (configurable.length > 1) {
      this.addVariantServicesCombined(this.editingVariant, configurable);
      return;
    }
    // Only no-config services were pending → stay in the drawer to show them added; if
    // nothing was pending at all, the user is done, so persist + close.
    if (noConfig.length > 0) { this.editingVariantServices = true; return; }
    if (this.quoteMode) { this.saveQuoteServiceChanges(); return; }
    if (this.generatorMode) { this.saveGeneratorServiceChanges(); return; }
    this.closeVariantEditServices();
  }

  /** Open the configure screen to ADD a not-yet-configured service to the variant.
   *  Mirrors the per-service Edit flow but starts from a fresh draft; on save a new
   *  option is created and appended to the variant. */
  addVariantServiceConfig(variant: any, service: any, confirmed = false) {
    // Adding Cutting to a variant that already has configured bends invalidates them.
    if (!confirmed && service?.name === 'Cutting') {
      // Cart options loaded from the backend are keyed by productOptionType (their
      // `name` may be absent), so resolve the service name the same robust way the
      // rest of the file does — otherwise an existing bend goes undetected and the
      // "Cutting Requires Bend Updates" confirm is silently skipped.
      const bending = (variant?.options || []).find(
        (o: any) =>
          (this.getServiceName(o?.productOptionType) || o?.name || '').toLowerCase() === 'bending' &&
          this.hasAnyBends(o)
      );
      if (bending) {
        this.askServiceConfirm({
          title: 'Cutting Requires Bend Updates',
          message: 'Bends are applied to pieces created through cutting. Adding cutting changes the structure of the material, so existing bend configurations will need to be reconfigured.',
          affected: ['Bending'],
          cancelLabel: 'CANCEL',
          confirmLabel: 'ADD CUTTING',
          onConfirm: () => this.addVariantServiceConfig(variant, service, true),
        });
        return;
      }
    }
    this.cameFromEditServices = true;
    this.editingVariant = variant;
    this.editingVariantServices = false;
    this.selectedProductForNewConfig = JSON.parse(JSON.stringify(variant.product || variant));
    this.selectedProductForNewConfig.cartId = variant.cartId;
    this.selectedProductForNewConfig.qty = variant.qty;
    this.selectedProductForNewConfig.options = variant.options || [];
    this.filterServicesForNewConfig = this.getFilteredServicesForConfig(this.selectedProductForNewConfig);
    this.setServiceFlow('together');

    const svc = this.filterServicesForNewConfig.find(
      (s: any) => s.productOptionType === service.productOptionType
    ) || service;

    const draft = this.buildDraft(svc, variant.qty || 1);
    draft.editVariantOption = null;       // new service (no existing option to update)
    draft.editVariantNewService = svc;    // remember which service to create on save
    draft.editVariantCartId = variant.cartId;
    this.calculateTotal(draft);

    this.wizardServices = [svc];
    this.wizardStep = 0;
    this.isReviewStep = false;
    this.selectedPieceIndex = 0;
    this.bendViewMode = 'formed';
    this.activeGroupId = null;
    this.selectedService = svc;
    this.draftConfig = draft;
    this.wizardDrafts = { [svc.name]: draft };
    // Adding Bending after a cut: derive the bend pieces from the variant's existing
    // cut (same as loadWizardStep does in the wizard). Bypassing this left the bend
    // as a standalone full-sheet bend that gets dropped once cuts exist.
    if (svc.name === 'Bending') {
      this.syncBendingPieces(draft);
      this.bendViewMode = this.hasAnyBends(draft) ? 'formed' : 'flat';
    }
    this.addNewConfig = true;
    this.addNewProduct = true;
    this.cameFromVariantEdit = true;
  }

  /** Add a no-config service (e.g. Punching) straight onto the variant's options — no
   *  configure screen. Mirrors the new-option shape saveEditServiceConfig creates. */
  private addNoConfigOptionToVariant(variant: any, svc: any) {
    if (!variant) return;
    if (!variant.options) variant.options = [];
    if (variant.options.some((o: any) => o.productOptionType === svc.productOptionType)) return;
    const opt: any = {
      name: svc.name,
      productOptionType: svc.productOptionType,
      serviceType: svc.serviceType,
      qty: variant.qty || 1,
      measurements: [],
      minimumServiceFee: svc.minimumServiceFee || 0,
      includedQtyInMinimumFee: svc.includedQtyInMinimumFee || 0,
      eachAdditionalPrice: svc.eachAdditionalPrice || 0,
      totalAmount: svc.minimumServiceFee || 0,
      __justAdded: true,
    };
    setTimeout(() => { opt.__justAdded = false; }, 4000);
    variant.options.push(opt);
    variant.servicesChanged = true;
    variant.__servicesEditedSession = true;
    this.editVariantSelectedTypes.delete(svc.productOptionType);
  }

  /** Configure two or more configurable services from the cart drawer using the SAME
   *  combined wizard as the product page (Cutting → Bending → Review). On save the
   *  drafts are written back onto the variant's options (see saveAllWizard). */
  addVariantServicesCombined(variant: any, services: any[]) {
    this.selectedProductForNewConfig = JSON.parse(JSON.stringify(variant.product || variant));
    this.selectedProductForNewConfig.cartId = variant.cartId;
    this.selectedProductForNewConfig.qty = variant.qty;
    this.selectedProductForNewConfig.options = variant.options || [];
    this.filterServicesForNewConfig = this.getFilteredServicesForConfig(this.selectedProductForNewConfig);
    this.editingVariant = variant;
    // Reuse the shared wizard setup (sorting, per-service drafts, stepper).
    this.startConfigureWizard(services, this.selectedProductForNewConfig, variant.qty || 1);
    // Drawer context: "Back" returns to the Editing Services list and the final "Save"
    // writes to variant.options instead of a service group.
    this.cameFromEditServices = true;
    this.cameFromVariantEdit = true;
    this.editingVariantServices = false;
    this.addNewProduct = true;
  }

  /** Write a configured wizard draft back onto the variant's matching option, creating
   *  it when that service wasn't configured yet. Mirrors saveEditServiceConfig's mapping
   *  for the combined cart-edit flow. */
  private applyDraftToVariantOption(variant: any, svc: any, draft: any) {
    let opt = (variant.options || []).find((o: any) => o.productOptionType === svc.productOptionType);
    const isNew = !opt;
    if (isNew) opt = { name: svc.name, productOptionType: svc.productOptionType, serviceType: svc.serviceType };
    opt.qty = draft.internalQty ?? opt.qty ?? 1;
    opt.measurements = JSON.parse(JSON.stringify(draft.measurements || []));
    if (svc.name === 'Bending') {
      const firstBendPiece = (draft.pieces || []).find((p: any) => p.bendRows?.length);
      opt.bendRows = JSON.parse(JSON.stringify(firstBendPiece?.bendRows || draft.bendRows || []));
      opt.bendPreset = this.bendPresetForDraft(draft) || null;
      opt.bendAxis = draft.bendAxis === 'width' ? 'width' : 'length';
      opt.bendOptions = this.cloneBendOptions(firstBendPiece || draft);
      if (draft.pieces) opt.pieces = JSON.parse(JSON.stringify(draft.pieces));
    }
    opt.totalAmount = this.calcServiceTotal(draft);
    opt.uploadedFile = draft.uploadedFile || opt.uploadedFile || null;
    opt.__justAdded = true;
    setTimeout(() => { opt.__justAdded = false; }, 4000);
    if (isNew) {
      if (!variant.options) variant.options = [];
      variant.options.push(opt);
    }
  }

  /** Mirror a just-configured service (config or wizard draft) into the cart variant's
   *  options, so the existing delete-and-re-add in saveVariantChanges sends the real,
   *  complete set. Guards on cartId, so it is a no-op on the product-detail flow and it
   *  never touches the delete-and-re-add itself. Only the saved service is upserted —
   *  untouched options keep their data. */
  private syncConfigToVariantOptions(svc: any, draft: any) {
    const cartId = this.selectedProductForNewConfig?.cartId;
    if (!cartId || !svc || !draft) return;
    const variant = this.editingVariant?.cartId === cartId
      ? this.editingVariant
      : (this.selectedVariantProducts || []).find((v: any) => v.cartId === cartId);
    if (!variant) return;
    this.applyDraftToVariantOption(variant, svc, draft);
    variant.servicesChanged = true;
    variant.__servicesEditedSession = true;
  }

  /** Per-service Remove inside the "Editing Services" drawer. Removes the option from
   *  the variant locally so the list updates; persistence is handled on save. */
  removeVariantServiceOption(variant: any, option: any, confirmed = false) {
    if (!variant?.options) return;

    // Always confirm before removing a configured service. (Service name is derived
    // from productOptionType — hydrated cart/quote options carry no `name`.)
    if (!confirmed) {
      const name = this.getServiceName(option?.productOptionType) || option?.name || 'service';
      // Removing Cutting takes the pieces its bends sit on with it — stronger warning.
      const dependentBending = name.toLowerCase() === 'cutting'
        ? variant.options.find((o: any) =>
            (this.getServiceName(o.productOptionType) || o.name || '').toLowerCase() === 'bending' && this.hasAnyBends(o))
        : null;
      if (dependentBending) {
        this.askServiceConfirm({
          title: 'Remove Cutting?',
          message: 'Bends are currently applied to pieces created through cutting. Removing cutting will also remove all configured bend settings.',
          affected: ['Cutting', 'Bending'],
          cancelLabel: 'KEEP SERVICES',
          confirmLabel: 'REMOVE SERVICES',
          onConfirm: () => this.removeVariantServiceOption(variant, option, true),
        });
      } else {
        this.askServiceConfirm({
          title: 'Remove configured service?',
          message: `This removes the configured ${name} service from this item. You can add it again anytime.`,
          affected: [name],
          cancelLabel: 'KEEP SERVICE',
          confirmLabel: 'REMOVE SERVICE',
          onConfirm: () => this.removeVariantServiceOption(variant, option, true),
        });
      }
      return;
    }

    const idx = variant.options.indexOf(option);
    if (idx > -1) variant.options.splice(idx, 1);
    // Drop any lingering tick for this service so it reverts to unselected.
    this.editVariantSelectedTypes.delete(option?.productOptionType);

    // Bending pieces are derived from Cutting, so a bend can't stand without it.
    // When Cutting is removed (and no other Cutting option remains), also drop the
    // dependent Bending — honoring the "...will also remove all configured bend
    // settings" prompt. Without this the bends were orphaned on the variant.
    const removedName = (this.getServiceName(option?.productOptionType) || option?.name || '').toLowerCase();
    const cuttingRemains = variant.options.some(
      (o: any) => (this.getServiceName(o?.productOptionType) || o?.name || '').toLowerCase() === 'cutting'
    );
    if (removedName === 'cutting' && !cuttingRemains) {
      this.removeVariantBendingOptions(variant);
    }

    // Mark changed so "Save Changes" enables and persists the removal on save.
    variant.servicesChanged = true;
    variant.__servicesEditedSession = true;
  }

  /** Remove all services from a cart variant via the in-place Cart/Update (PUT) endpoint:
   *  send Services:null so the backend clears the options and reprices the line to
   *  material-only, keeping the same line/position. (Was delete + re-add.) */
  async removeVariantServices(variant: any) {
    if (this.isSavingService) return;
    this.util.setLoder(true);
    try {
      await this.api.updateCartItem({
        CartId: variant.cartId,
        Qty: variant.qty,
        ProductSlug: variant.product.urlSlug,
        Services: null,
      });
      const cartData = await this.api.getCartList();
      this.util.CartUpdated(cartData);
      this.cartList = cartData;
      const anchor = this.selectedVariantProducts?.[0] || variant.product;
      this.selectedVariantProducts = this.findItemsWithSamePartName(anchor);
      this.util.PopupCartUpdated(this.selectedVariantProducts || []);
      this.util.showQuotesToast('Services removed', 'success', undefined);
    } catch (e) {
      this.util.showQuotesToast('Failed to remove services', 'error', undefined);
    } finally {
      this.util.setLoder(false);
    }
  }

  onViewVariantServiceConfig(variant: any, option: any) {
    // Leaving the "Editing Services" drawer (if open) to show the config screen.
    // Remember we came from there so Back/Save return to it (not the variant list).
    this.cameFromEditServices = this.editingVariantServices;
    this.editingVariant = variant;
    this.editingVariantServices = false;
    // Reflect the saved leftover-material choice in the radio.
    this.includeRemainingMaterial = option?.includeRemainingMaterial !== undefined
      ? option.includeRemainingMaterial
      : this.orderIncludesRemaining(variant?.services?.order);
    this.selectedProductForNewConfig = JSON.parse(JSON.stringify(variant.product || variant));
    this.selectedProductForNewConfig.cartId = variant.cartId;
    this.selectedProductForNewConfig.qty = variant.qty;
    // carry existing cart service options so add-services-modal can read them
    this.selectedProductForNewConfig.options = variant.options || [];
    this.filterServicesForNewConfig = this.getFilteredServicesForConfig(this.selectedProductForNewConfig);
    this.setServiceFlow('together');

    const service = this.filterServicesForNewConfig.find(
      (s: any) => s.productOptionType === option.productOptionType
    ) || this.services.find(
      (s: any) => s.productOptionType === option.productOptionType
    );
    if (!service) return;

    // Build a draft pre-filled with the existing option so the configure screen opens in edit mode
    const baseQty = variant.qty || 1;
    const draft = this.buildDraft(service, baseQty);
    const savedCuts = option.qty && option.qty > 0 ? option.qty : 1;

    if (option.measurements?.length) {
      draft.measurements = JSON.parse(JSON.stringify(option.measurements));
    } else {
      draft.measurements = [{ width: option.width || 1, length: option.length || 1, qty: savedCuts }];
    }
    draft.internalQty = savedCuts;

    if (service.name === 'Bending') {
      if (option.pieces?.length) draft.pieces = JSON.parse(JSON.stringify(option.pieces));
      if (option.bendRows?.length) draft.bendRows = JSON.parse(JSON.stringify(option.bendRows));
      draft.bendPreset = option.bendPreset || null;
      draft.bendAxis = option.bendAxis === 'width' ? 'width' : 'length';
      draft.bendOptions = this.cloneBendOptions(option);
      if (!draft.bendOptions.mode) {
        draft.bendOptions.mode = !draft.bendPreset && draft.bendRows?.length ? 'custom' : 'preset';
      }
      this.ensureCoverRowsForDraft(draft);
    }

    // Restore ONLY this service's own scoped sketch (option.document is set by
    // hydrateOptionsFromServices strictly from the bending/cutting-scoped attachment,
    // never the order-level 'general' file). Do NOT fall back to variant.uploadedFile:
    // the general "Upload File (Optional)" lives in its own section, and bleeding it
    // into the per-service sketch made an order-level file wrongly appear here on edit.
    if (option.document) {
      draft.uploadedFile = { name: option.OriginalFileName || 'attachment', url: option.document };
    }

    // reference to the source option so a future save can update it
    draft.editVariantOption = option;
    draft.editVariantCartId = variant.cartId;
    this.calculateTotal(draft);

    // single-service configure context (no review step)
    this.wizardServices = [service];
    this.wizardStep = 0;
    this.isReviewStep = false;
    this.selectedPieceIndex = 0;
    this.bendViewMode = 'formed';
    this.activeGroupId = null;
    this.selectedService = service;
    this.draftConfig = draft;
    this.wizardDrafts = { [service.name]: draft };
    this.addNewConfig = true;
    // render the header's Configure stepper screen (not the add-services-modal)
    this.addNewProduct = true;
    this.cameFromVariantEdit = true;
  }

  /** Return from the configure screen to wherever it was opened from:
   *  the "Editing Services" drawer, or the "Variants Already in Cart" list. */
  private restoreVariantEditView() {
    if (this.cameFromEditServices) {
      this.addNewProduct = false;
      this.cameFromEditServices = false;
      this.cameFromVariantEdit = false;
      this.editingVariantServices = true;
      return;
    }
    if (this.cameFromVariantEdit) {
      this.addNewProduct = false;
      this.cameFromVariantEdit = false;
    }
  }

  getActiveValue(variant: any, attrKey: string): string {
    const options = variant.product?.attributeSelector?.[attrKey];
    if (!options) return '';
    const active = options.find((val: any) => this.isAttributeActive(val, variant.product));
    return active?.attributeValue || '';
  }

  async deleteVariant(variant: any) {
    if (this.isDeletingVariant) return;
    this.isDeletingVariant = true;
    try {
      const res = await this.api.removeCart(variant.cartId);
      this.cartList.items = this.cartList.items.filter((v: any) => v.cartId !== variant.cartId);
      this.selectedVariantProducts = this.findItemsWithSamePartName(this.selectedVariantProducts[0]);
      this.util.PopupCartUpdated(this.selectedVariantProducts || []);
      this.util.CartUpdated(this.cartList)
      if (this.selectedVariantProducts.length === 0) {
        this.closeMultipleVarientsPopup();
      }

      if (this.selectedProductForNewConfig?.cartId === variant.cartId) {
        this.selectedProductForNewConfig.cartId = null;
        this.selectedProductForNewConfig.cartQty = 0;
        this.selectedProductForNewConfig.qty = 0;
      }
    } catch (err) {
      this.util.showQuotesToast('Error', 'error', 'Item Not Added to Cart');
    } finally {
      this.isDeletingVariant = false;
    }
  }

  async onVariantOptionClick(variant: any, val: any, attrKey?: string) {
    // Don't do anything if it's already active
    if (this.isAttributeActive(val, variant.product)) return;

    // Block clicks on quotes-only items
    if (this.isOptionQuotesOnly(val)) return;

    // Check if service is not available and variant has existing services
    // if (val.isServiceAvailable === false) {
    //   this.serviceUnavailableVariant = variant;
    //   this.serviceUnavailableVal = val;
    //   this.serviceUnavailableAttrKey = attrKey || '';
    //   this.showServiceUnavailablePopup = true;
    //   return;
    // }
    console.log('Clicked option:', val, variant);
    // Check if variant has services and the target product only supports some of them
    if (variant.options?.length && val.availableServices?.length) {
      const availableSet = val.availableServices.map((s: string) => s.toLowerCase());
      const unavailableOptions = variant.options
        .filter((opt: any) => !availableSet.includes(this.getServiceName(opt.productOptionType)?.toLowerCase()));

      if (unavailableOptions.length > 0) {
        // Store the unavailable services for the popup to display
        this.unavailableServiceOptions = unavailableOptions;
        this.serviceUnavailableVariant = variant;
        this.serviceUnavailableVal = val;
        this.serviceUnavailableAttrKey = attrKey || '';
        this.showServiceUnavailablePopup = true;
        return;
      }
    }



    await this.applyVariantOptionChange(variant, val, attrKey);
  }

  async applyVariantOptionChange(variant: any, val: any, attrKey?: string, skipServices: boolean = false) {
    // Clear previous auto-selection message for this variant
    variant.previousProduct = null;
    variant.previousSelected = false;

    // Store original cart info on first attribute change
    if (!variant.originalCartId) {
      variant.originalCartId = variant.cartId;
      variant.originalProductSlug = variant.product.urlSlug;
      variant.originalOptions = variant.options ? JSON.parse(JSON.stringify(variant.options)) : [];
    }

    // If the option is not the same product (unavailable combo), track previous selection
    if (!val.isSame) {
      const attributeSelector = variant.product?.attributeSelector || this.selectedProductForNewConfig?.attributeSelector;
      if (attributeSelector) {
        const sessionData: { [key: string]: any } = {};
        Object.keys(attributeSelector).forEach((key: string) => {
          const selectedValue =
            key === attrKey
              ? { ...val, isSelected: true }
              : attributeSelector[key].find((filter: any) =>
                  this.checkSlugs(variant.product.urlSlug, filter.productSlug)
                );
          if (selectedValue) {
            sessionData[key] = selectedValue;
          }
        });
        variant.previousSelected = true;
        variant.previousProduct = sessionData;
      }
    }

    this.util.setLoder(true);
    await this.onOptionChange(val.productSlug);
    variant.product = this.selectedProductForNewConfig;
    variant.attributeChanged = this.selectedProductForNewConfig.urlSlug !== variant.originalProductSlug;
    variant.price = this.selectedProductForNewConfig.price ?? this.selectedProductForNewConfig.salePrice ?? variant.price;

    // If services should be skipped, mark variant to not re-add options on save
    if (skipServices) {
      variant.skipServices = true;
      variant.options = [];
    }

    this.util.setLoder(false);

    // Expand all attribute sections and scroll to the changed item
    setTimeout(() => {
      if (!variant.expandedSections) variant.expandedSections = {};
      const keys = Object.keys(this.selectedProductForNewConfig?.attributeSelector || {});
      keys.forEach(key => variant.expandedSections[key] = true);

      setTimeout(() => {
        const note = document.querySelector('.multipleVarients .variant-inline-note');
        const chip = document.querySelector('.multipleVarients .option-chip.previous-option');
        const target = note || chip;
        if (target) {
          target.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }, 100);
    }, 0);
  }

  confirmServiceUnavailable() {
    this.showServiceUnavailablePopup = false;
    if (this.serviceUnavailableVariant && this.serviceUnavailableVal) {
      const variant = this.serviceUnavailableVariant;
      const val = this.serviceUnavailableVal;

      // If there are available services, filter to keep only those
      if (this.unavailableServiceOptions.length > 0 && val.availableServices?.length) {
        const availableSet = val.availableServices.map((s: string) => s.toLowerCase());
        const keepOptions = variant.options
          .filter((opt: any) => availableSet.includes(this.getServiceName(opt.productOptionType)?.toLowerCase()));
        variant.originalOptions = keepOptions;
        variant.options = [...keepOptions];
        // If nothing left to transfer, skip all services
        const skipAll = keepOptions.length === 0;
        this.applyVariantOptionChange(variant, val, this.serviceUnavailableAttrKey, skipAll);
      } else {
        this.applyVariantOptionChange(variant, val, this.serviceUnavailableAttrKey, true);
      }
    }
    this.serviceUnavailableVariant = null;
    this.serviceUnavailableVal = null;
    this.serviceUnavailableAttrKey = '';
    this.unavailableServiceOptions = [];
  }

  cancelServiceUnavailable() {
    this.showServiceUnavailablePopup = false;
    this.serviceUnavailableVariant = null;
    this.serviceUnavailableVal = null;
    this.serviceUnavailableAttrKey = '';
    this.unavailableServiceOptions = [];
  }

  onVariantServiceClick(variant: any) {
    this.selectedProductForNewConfig = JSON.parse(JSON.stringify(variant.product || variant));
    this.selectedProductForNewConfig.cartId = variant.cartId;
    this.selectedProductForNewConfig.qty = variant.qty;
    this.filterServicesForNewConfig = this.getFilteredServicesForConfig(this.selectedProductForNewConfig);
    this.addNewConfig = false;
    this.draftConfig = null;
    this.selectedService = null;
    this.addNewProduct = true;
    this.setServiceFlow('together');

    // Pre-populate configured services from variant.options into the service group
    if (variant.options?.length && this.serviceGroups.length > 0) {
      const configs = variant.options.map((option: any) => {
        const matchedService = this.services.find(
          (s) => s.productOptionType === option.productOptionType
        );
        const matchedOption = this.selectedProductForNewConfig?.productOptionsDTO?.find(
          (o: any) => o.productOptionType?.toLowerCase() === matchedService?.name?.toLowerCase()
        );
        const minimumServiceFee = matchedOption?.minimumServiceFee || 0;
        const includedQtyInMinimumFee = matchedOption?.includedQtyInMinimumFee || 0;
        const eachAdditionalPrice = matchedOption?.eachAdditionalPrice || 0;

        const config: any = {
          name: matchedService?.name || 'Unknown',
          qty: variant.qty || 1,
          piecesQty: variant.qty || 1,
          width: 1,
          length: 1,
          internalQty: option.qty || 1,
          // Carry the option's REAL geometry so editing starts from the saved values
          // (not 1×1) and a re-save can't overwrite them with placeholders.
          measurements: option.measurements?.length
            ? JSON.parse(JSON.stringify(option.measurements))
            : [{ width: 1, length: 1, qty: option.qty || 1 }],
          bendRows: option.bendRows ? JSON.parse(JSON.stringify(option.bendRows)) : [],
          pieces: option.pieces ? JSON.parse(JSON.stringify(option.pieces)) : undefined,
          bendPreset: option.bendPreset || null,
          bendOptions: this.cloneBendOptions(option),
          serviceType: option.serviceType,
          includedQtyInMinimumFee,
          eachAdditionalPrice,
          minimumServiceFee,
          img: matchedService?.img || '',
          msg: matchedService?.msg || '',
          isSaved: true,
          configId: Date.now() + Math.random(),
          totalAmount: 0,
        };
        config.totalAmount = this.calculateTotal(config);
        return config;
      });
      this.serviceGroups[0].configs = configs;
    }
  }

  hasVariantChanges(): boolean {
    return this.selectedVariantProducts?.some((v: any) => v.attributeChanged || v.qtyChanged || v.pendingDelete || v.servicesChanged) ?? false;
  }

  get visibleVariants(): any[] {
    return this.selectedVariantProducts?.filter((v: any) => !v.pendingDelete) || [];
  }

  async saveVariantChanges() {
    const pendingDeleteVariants = this.selectedVariantProducts.filter((v: any) => v.pendingDelete);
    const attributeChangedVariants = this.selectedVariantProducts.filter((v: any) => v.attributeChanged && !v.pendingDelete);
    // Service-only changes are persisted by re-adding the line with its new options;
    // they handle qty too, so keep them out of the qty-only bucket.
    const servicesChangedVariants = this.selectedVariantProducts.filter((v: any) => v.servicesChanged && !v.pendingDelete && !v.attributeChanged);
    const qtyChangedVariants = this.selectedVariantProducts.filter((v: any) => v.qtyChanged && !v.pendingDelete && !v.attributeChanged && !v.servicesChanged);
    const hasAnyChange = pendingDeleteVariants.length > 0 || qtyChangedVariants.length > 0 || attributeChangedVariants.length > 0 || servicesChangedVariants.length > 0;
 
    if (!hasAnyChange) {
      this.forceClosePopup();
      return;
    }

    this.util.setLoder(true);
    try {
      // Delete variants marked for removal
      for (const variant of pendingDeleteVariants) {
        await this.api.removeCart(variant.cartId);
      }

      // Update qty-only changes
      for (const variant of qtyChangedVariants) {
        await this.api.updateCart(variant.cartId, variant.qty);
      }

      // Attribute changes → in-place update: the backend repoints the same line to the
      // new variant slug and reprices, keeping its position/cartId. Services are unchanged
      // here, so re-send the ORIGINAL option set (null when there are none / skipped).
      for (const variant of attributeChangedVariants) {
        const services = (variant.originalOptions?.length > 0 && !variant.skipServices)
          ? this.buildServicesFromSavedOptions(variant.product, variant.qty, variant.originalOptions, variant.originalCartId, variant.uploadedFile)
          : null;
        await this.api.updateCartItem({
          CartId: variant.originalCartId,
          Qty: variant.qty,
          ProductSlug: variant.product.urlSlug,
          Services: services,
        });
      }

      // Service-only changes → in-place update with the new (edited) option set. The
      // backend updates the same line (repricing services against the product) and keeps
      // its position. `Services` is null when every service was removed (backend clears them).
      for (const variant of servicesChangedVariants) {
        const services = variant.options?.length > 0
          ? this.buildServicesFromSavedOptions(variant.product, variant.qty, variant.options, variant.cartId, variant.uploadedFile)
          : null;
        await this.api.updateCartItem({
          CartId: variant.cartId,
          Qty: variant.qty,
          ProductSlug: variant.product.urlSlug,
          Services: services,
        });
      }

      // Refresh cart once for all changes. The backend updates lines in place, so the
      // server order already keeps edited variants in their slot — no client reorder needed.
      const cartData = await this.api.getCartList();
      this.util.CartUpdated(cartData);
      this.cartList = cartData;
      // Refresh selectedVariantProducts from updated cart so pendingDelete flags are cleared
      const anchor = this.selectedVariantProducts[0] || this.selectedProductForNewConfig;
      this.selectedVariantProducts = this.findItemsWithSamePartName(anchor);
      this.util.PopupCartUpdated(this.selectedVariantProducts);
      this.util.showQuotesToast('Changes saved to cart', 'success', undefined);
    } catch (err: any) {
      // Surface the backend's actual message (e.g. a qty/options warning) instead
      // of a generic error, so the user sees why the save was rejected.
      const warning = err?.error?.warnings?.[0] || err?.error?.message || err?.error?.title;
      this.util.showQuotesToast(warning || 'Error saving changes', 'error', undefined);
    } finally {
      this.util.setLoder(false);
      this.forceClosePopup();
    }
  }

  onNewConfigBack(data: any) {
    this.addNewConfig = false;
    const anchor = data?.product ? data.product : (data?.urlSlug ? data : this.selectedVariantProducts[0]);
    this.selectedVariantProducts = this.findItemsWithSamePartName(anchor);
    this.util.PopupCartUpdated(this.selectedVariantProducts);
  }

  onAddNewConfiguration() {
    this.addNewConfig = false;
    this.addNewProduct = true;
    this.setServiceFlow(this.serviceFlow);
  }

  getFilteredServicesForConfig(product: any) {
    const serviceTypeMapping: any = {
      AluminumCutting: 1,
      Cutting: 2,
      Bending: 3,
      Punching: 4,
      Slitting: 5,
    };

    const allowed = this.generatorMode ? this.generatorAllowedServices : null;
    return this.services
      .filter((service) => !allowed || allowed.includes(service.name))
      .filter((service) =>
        product?.productOptionsDTO?.some(
          (option: any) => option.productOptionType?.toLowerCase() === service.name?.toLowerCase()
        )
      )
      .map((service) => {
        const matchedOption = product?.productOptionsDTO?.find(
          (option: any) => option.productOptionType?.toLowerCase() === service.name?.toLowerCase()
        );

        return {
          ...service,
          price: matchedOption ? matchedOption.price : service.price || 0,
          selected: false,
          qty: 1,
          minimumServiceFee: matchedOption ? matchedOption.minimumServiceFee : service.minimumServiceFee || 0,
          includedQtyInMinimumFee: matchedOption ? matchedOption.includedQtyInMinimumFee : service.includedQtyInMinimumFee || 0,
          eachAdditionalPrice: matchedOption ? matchedOption.eachAdditionalPrice : service.eachAdditionalPrice || 0,
          serviceType: matchedOption
            ? serviceTypeMapping[
            matchedOption.productOptionConfigurationServiceType
            ] ?? null
            : null,
        };
      });
  }
  navigateToProductFromPopup() {
    const product = this.selectedVariantProducts[0]?.product;
    if (product?.urlSlug) {
      this.router.navigate(['/product', product.urlSlug]);
    }
    this.closeMultipleVarientsPopup();
  }

  checkToken(): boolean {
    if (isPlatformBrowser(this.platformId)) {
      const token = localStorage.getItem('token');
      if (!token) {
        return false;
      }
      return true;
    } else {
      return false;
    }
  }
  isScrolled = false;
  // True once scrolled past 150px. Drives the sticky header's compact state:
  // the announcement bar hides and the header fill/blur/shadow intensify (Figma spec).
  headerScrolled = false;
  @HostBinding('class.header-scrolled')
  get isHeaderScrolled(): boolean {
    return this.headerScrolled;
  }
  // The top bar is hidden on account pages; zero its sticky offset there (header CSS).
  @HostBinding('class.no-top-bar')
  get hasNoTopBar(): boolean {
    return this.isAccountPage;
  }
  @HostListener('window:resize')
  onResize() {
    this.checkScreenSize();
  }
  /** True for /account and anything under it, ignoring query/fragment. */
  private isAccountUrl(url: string): boolean {
    return url.split(/[?#]/)[0].split('/')[1] === 'account';
  }

  checkScreenSize() {
    if (isPlatformBrowser(this.platformId)) {
      if (window.innerWidth <= 750 && this.router.url.includes('admin')) {
        this.showMainHeader = false;
        return true;
      } else {
        this.showMainHeader = true;
        return false;
      }
    } else {
      return false;
    }
  }

  private removeScrollListener?: () => void;
  private scrollTicking = false;

  // Scroll is handled outside Angular on purpose: this template is large, and a
  // change detection pass on every scroll event was a real source of jank. We only
  // re-enter the zone on the rare event that one of the two flags actually flips.
  private initScrollState(): void {
    if (!isPlatformBrowser(this.platformId)) return;
    this.zone.runOutsideAngular(() => {
      const onScroll = () => {
        if (this.scrollTicking) return;
        this.scrollTicking = true;
        requestAnimationFrame(() => {
          this.scrollTicking = false;
          this.applyScrollState(window.scrollY);
        });
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      this.removeScrollListener = () =>
        window.removeEventListener('scroll', onScroll);
      this.applyScrollState(window.scrollY);
    });
  }

  // 150 in, 120 out: with a single threshold, hovering around 150px (or a trackpad
  // that wobbles a pixel) toggles the state repeatedly and reads as flicker.
  private applyScrollState(y: number): void {
    const isScrolled = y > 0;
    const headerScrolled = this.headerScrolled ? y > 120 : y > 150;
    if (
      isScrolled === this.isScrolled &&
      headerScrolled === this.headerScrolled
    ) {
      return;
    }
    this.zone.run(() => {
      this.isScrolled = isScrolled;
      this.headerScrolled = headerScrolled;
    });
  }
  setParentReferences(categories: any[], parent: any = null): void {
    for (const category of categories) {
      category.parent = parent;
      if (category.childCategories?.length) {
        this.setParentReferences(category.childCategories, category);
      }
    }
  }
  onchangeInput() {
    this.activeIndex = -1;
    this.getSearchQuery(this.searchValue);
  }
  onSearchEnter() {
    if (this.activeIndex >= 0 && this.ShowList) {
      const totalItems = (this.queryList?.length || 0) + (this.pQueryList?.length || 0);
      if (this.activeIndex < totalItems) {
        if (this.activeIndex < this.queryList?.length) {
          const selected = this.queryList[this.activeIndex].highlights[0].snippet;
          this.setSearchVal(selected);
        } else {
          const productIndex = this.activeIndex - this.queryList.length;
          const selectedProduct = this.pQueryList[productIndex].document;
          this.goToProductDetail(selectedProduct.urlSlug);
        }
        this.activeIndex = -1;
        return;
      }
    }
    this.onClickSearch()
  }
  async onClickSearch() {
    this.ShowList = false;
    this.onBlur();
    if (!this.searchValue || this.searchValue.trim() === '') {
      this.searchValue = '';
    }
    const term = this.searchValue.trim();

    // If the term looks like a SKU (single token, no spaces), try to resolve it
    // to a product first. On a match, open the product-detail page directly via
    // the /sku/ route; otherwise fall through to the normal search results.
    if (term && this.looksLikeSku(term)) {
      try {
        const { product } = await this.api.getProductBySku(term);
        // Invalid SKU comes back as HTTP 200 with an empty `data: {}` object
        // (warnings: ["Invalid Product"]), so check for a real product field.
        if (product && (product.urlSlug || product.id)) {
          this.router.navigate(['/sku', term]);
          return;
        }
      } catch {
        // Network/other error — fall back to normal search below.
      }
    }

    const currentQuery = this.activateRoute.snapshot.queryParamMap.get('q');
    if (this.searchValue == currentQuery) {
      this.util.tiggerFetchProduct();
    }
    this.util.triggerSearch(this.searchValue);
    this.router.navigate(['/search'], {
      queryParams: { q: term },
    });
  }

  // A SKU is a single alphanumeric code, e.g. "DBLD483SWSW" — letters + digits
  // with NO hyphens or spaces. That's the key difference from a slug, which is
  // hyphen-separated (e.g. "steel-angle-316-3-x-3-x-20"). Requiring a digit also
  // lets plain word searches ("gloves") skip the SKU lookup entirely.
  private looksLikeSku(value: string): boolean {
    return /^[A-Za-z0-9]+$/.test(value) && /\d/.test(value);
  }
  onClickOrder() {
    this.showAccountPopupVisible = false;
    this.router.navigateByUrl('/account/recent-order');
  }

  onClickWishlist() {
    this.showAccountPopupVisible = false;
    this.router.navigateByUrl('/account/wishlist');
  }

  onClickAccount() {
    if (this.adminWithoutCustomer) {
      this.onClickSecurity();
      return;
    }
    this.showAccountPopupVisible = false;
    this.router.navigateByUrl('/account');
  }

  onClickQuotes() {
    this.showAccountPopupVisible = false;
    this.router.navigateByUrl('/account/quotes');
  }
  onClickAdmin() {
    this.showAccountPopupVisible = false;
    this.router.navigateByUrl('/admin');
  }
  onClickSecurity() {
    this.showAccountPopupVisible = false;
    this.router.navigateByUrl('/account/security');
  }

  logout() {
    if (!isPlatformBrowser(this.platformId)) return;
    this.showAccountPopupVisible = false;

    const clearSession = () => {
      this.isAdmin = false;
      this.util.setCurrentUser(null);
      this.util.setAdminToken(null);
      this.util.CartUpdated([]);
      localStorage.removeItem('token');
      localStorage.removeItem('currentUser');
      localStorage.removeItem('adminToken');
      localStorage.removeItem('token_expiration');
    };

    // Already on home: no route guard to satisfy, log out directly.
    const path = (this.router.url || '/').split('?')[0].split('#')[0];
    if (path === '/' || path === '') {
      clearSession();
      return;
    }

    // Navigate home first; a route's canDeactivate guard (e.g. "Leave without
    // saving?") may cancel this. Only clear the session if the navigation actually
    // completes — so "Keep Editing" keeps the user logged in.
    this.router.navigateByUrl('').then((navigated) => {
      if (navigated) clearSession();
    });
  }
  clearUserDetail() {
    if (isPlatformBrowser(this.platformId)) {
      this.util.setCurrentUser(null);
      this.util.setAdminToken(null);
      localStorage.removeItem('token');
      localStorage.removeItem('currentUser');
      localStorage.removeItem('adminToken');
      localStorage.removeItem('token_expiration');
      this.util.CartUpdated([]);
    }
  }
  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    if (!isPlatformBrowser(this.platformId)) return;
    const target = event.target as HTMLElement;
    this.bendProfileOpen = false;
    const dropdown = document.querySelector('.dropdown-menu');
    const menuList = document.querySelector('.menuList');
    const queryListUl = document.querySelector('.queryListUl');
    const userDropdown = target.closest('.user-dropdown-wrapper');
    const toggleButton = target.closest('.dropdown-toggle-button');
    const searcHeader = target.closest('.outerBox');
    const accountSection = target.closest('.accountSection');
    const multipleVarients = target.closest('.multipleVarients');
    const discardPopup = target.closest('.discardPopup');
    const discardModalOverlay = target.closest('.discard-modal-overlay');
    const customDrawerOverlay = target.closest('.custom-drawer-overlay');
    if (
      dropdown?.contains(target) ||
      menuList?.contains(target) ||
      queryListUl?.contains(target) ||
      multipleVarients ||
      userDropdown ||
      toggleButton ||
      searcHeader ||
      accountSection ||
      target.closest('p-toast') ||
      target.closest('.swal2-container') ||
      discardPopup ||
      discardModalOverlay
    ) {
      return;
    }
    this.visible = false;
    this.ShowList = false;
    this.showLogin = false;
    this.showAccountPopupVisible = false;
    this.piecesQtyDropdownOpen = false;
    this.activeSpecKey = null;
    if (!customDrawerOverlay && !this._variantPopupJustTriggered) {
      this.multipleVarientsPopupOpen = false
    }
  }

  async backToAdmin() {
    if (isPlatformBrowser(this.platformId)) {
      this.loggedAsCustomer = false;
      this.isAdmin = true;
      let adminToken = localStorage.getItem('adminToken');
      localStorage.setItem('token', adminToken!!);
      localStorage.removeItem('adminToken');
      this.util.setAdminToken('');
      this.util.CartUpdated([]);
      await this.util.afterLogin();
      this.router.navigateByUrl('admin/customers');
    }
  }

  async back() {
    this.compareActive = false;
    if (isPlatformBrowser(this.platformId)) {
      window.history.back();
    }
  }

  saveUri() {
    this.api.setPageUri(this.router.url);
    this.router.navigateByUrl('login');
  }

  goBack() {
    if (this.history.length > 1) {
      this.history.pop();
      const previousUrl = this.history[this.history.length - 1];
      const isInternal = previousUrl.startsWith('/');
      if (isInternal) {
        this.location.back();
        this.history.pop();
      } else {
        this.router.navigateByUrl(previousUrl);
      }
    } else {
      this.router.navigate(['/']);
    }
  }

  async getSearchQuery(query: any) {
    if (isPlatformBrowser(this.platformId) && window.innerWidth <= 750) {
      this.util.setBackdrop(true);
    }
    try {
      if (query) {
        let data = await this.api.queryApi(query);
        this.queryList = data[1]?.hits || [];
        this.pQueryList = data[0]?.hits;
        this.ShowList = this.queryList.length > 0;
      } else {
        this.queryList = [];
        this.ShowList = false;
      }
    } catch (err) {
    }
  }
  trackByIndex(index: number) {
    return index;
  }
  onSearchKeyUp(event: KeyboardEvent) {
    const totalItems = (this.queryList?.length || 0) + (this.pQueryList?.length || 0);
    if (!this.ShowList || totalItems === 0) return;

    if (event.key === 'ArrowDown') {
      event.preventDefault();
      if (this.activeIndex === -1) {
        this.activeIndex = 0;
      } else if (this.activeIndex < totalItems - 1) {
        this.activeIndex++;
      }
      this.scrollToActiveItem();
    }

    if (event.key === 'ArrowUp') {
      event.preventDefault();
      if (this.activeIndex > 0) {
        this.activeIndex--;
      }
      this.scrollToActiveItem();
    }
  }

  scrollToActiveItem() {
    if (isPlatformBrowser(this.platformId)) {
      setTimeout(() => {
        const activeItems = this.document.querySelectorAll('.queryListUl li.active');
        activeItems.forEach((activeItem: any) => {
          activeItem.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        });
      });
    }
  }

  getQueryName(name: string) {
    return name?.replaceAll('<mark>', '<b>').replaceAll('</mark>', '</b>');
  }

  setSearchVal(name: string) {
    let query = name?.replaceAll('<mark>', '').replaceAll('</mark>', '');
    this.searchValue = query;
    this.ShowList = false;
    this.onClickSearch();
  }

  goToProductDetail(slug: string) {
    this.router.navigate(['/product', slug]);
    this.ShowList = false;
  }

  async toggleSearch() {
    this.searchEnabled = !this.searchEnabled;
    this.ShowList = false;
    if (this.searchEnabled) {
      setTimeout(() => {
        this.overflowXValue = true;
      }, 500);
    } else {
      this.overflowXValue = false;
    }
  }

  onFocus() {
    if (isPlatformBrowser(this.platformId) && window.innerWidth <= 750) {
      this.util.setBackdrop(true);
    }
  }
  onBlur() {
    setTimeout(() => {
      this.ShowList = false
    }, 500)
    this.util.setBackdrop(false);
  }
  handleClose() {
    this.searchValue = '';
    this.ShowList = false;
    if (this.router.url.includes('search')) {
      this.onClickSearch();
    }
  }

  showAccountPopup() {
    if (!this.user) {
      this.showLogin = !this.showLogin;
    } else {
      this.showAccountPopupVisible = !this.showAccountPopupVisible;
    }
  }

  getMinusIcon(qty: number): string {
    return qty === 1
      ? './remove-qty.svg'
      : './minus-icon-blue.svg';
  }

  getServiceName(productOptionType: number): string {
    const service = this.services.find(
      (service) => service.productOptionType === productOptionType
    );
    return service ? service.name : 'Unknown';
  }

  getServiceImgByType(serviceType: number): string {
    const serviceTypeToImg: { [key: number]: string } = {
      1: '/cutting-img.svg',
      2: '/cutting-img.svg',
      3: '/bending-img.svg',
      4: '/punching-img.svg',
      5: '/slitting-img.svg',
    };
    return serviceTypeToImg[serviceType] || '';
  }

  isAttributeActive(attr: any, product: any) {
    return attr.productSlug === product.urlSlug;
  }

  isOptionQuotesOnly(data: any): boolean {
    return data.inventoryQty === false && data.productStatus === 3;
  }

  isOptionOutOfStockOrQuotes(data: any): boolean {
    if (data.inventoryQty === false && data.productStatus === 3) {
      return true; // quotes only
    }
    if (data.inventoryQty === false &&
      data.productStatus !== 3 &&
      data.productStatus !== 4 &&
      data.productStatus !== 0) {
      return true; // out of stock
    }
    return false;
  }

  isOptionNotAvailable(data: any): boolean {
    return !data.isSame && !this.isOptionOutOfStockOrQuotes(data);
  }

  checkVariantPreviousSelected(variant: any, currentValue: string, item: string): boolean {
    if (!variant.previousSelected || !variant.previousProduct?.[item]) {
      return false;
    }
    if (variant.previousProduct[item]?.isSelected) {
      return false;
    }
    const previousValue = variant.previousProduct[item].attributeValue;
    return previousValue !== currentValue;
  }

  getVariantAutoSelectedMessage(variant: any, item: string): string {
    if (!variant.previousProduct?.[item]) return '';

    const previousValue = variant.previousProduct[item]?.attributeValue;
    if (!previousValue) return '';

    // Find the attribute the user actively selected
    let userSelectedValue = '';
    const attributeSelector = variant.product?.attributeSelector || this.selectedProductForNewConfig?.attributeSelector;
    if (attributeSelector) {
      for (const key of Object.keys(attributeSelector)) {
        if (variant.previousProduct[key]?.isSelected) {
          userSelectedValue = variant.previousProduct[key].attributeValue;
          break;
        }
      }
    }

    if (userSelectedValue) {
      return `${previousValue} is not available in ${userSelectedValue}. We've auto-selected a new combination that's available. You can select your own combination.`;
    }

    return `${previousValue} is not available in the selected combination. We've auto-selected a new combination that's available. You can select your own combination.`;
  }

  findVariantSelectedValue(variant: any, attrKey: string): string {
    const options = variant.product?.attributeSelector?.[attrKey];
    if (!options) return '';
    const selected = options.find((opt: any) => this.checkSlugs(variant.product.urlSlug, opt.productSlug));
    return selected?.attributeValue || '';
  }

  getOptionTooltip(data: any, product: any): string | undefined {
    if (this.isAttributeActive(data, product)) return undefined;
    if (data.inventoryQty === false && data.productStatus === 3) {
      return 'Quotes Only';
    }

    if (!data.isSame) {
      return 'Not Available';
    }
    if (this.isOptionOutOfStockOrQuotes(data)) {
      return 'Out of Stock';
    }

    return undefined;
  }

  bendViewMode: 'formed' | 'flat' = 'formed';
  // Mobile-only: Cross-Section Preview collapse state (desktop always shows it).
  bendPreviewOpen = false;
  // Bend tag (legend chip) the user last clicked — drives a transient glow.
  glowingBendIndex: number | null = null;
  private _bendGlowTimer: any = null;

  /** Click a bend tag to give that bend a soft glow (mirrors the PDP spec-update
   *  emphasis). Clear-then-set so the animation restarts on every click. */
  onBendTagClick(index: number) {
    if (this._bendGlowTimer) clearTimeout(this._bendGlowTimer);
    this.glowingBendIndex = null;
    setTimeout(() => {
      this.glowingBendIndex = index;
      this._bendGlowTimer = setTimeout(() => { this.glowingBendIndex = null; }, 4200);
    }, 20);
  }

  // ── Multi-step configure wizard state ──────────────────────────────
  wizardServices: any[] = [];        // ordered services being configured (Cutting first, Bending next)
  wizardStep: number = 0;            // index into wizardServices currently shown
  isReviewStep: boolean = false;     // showing the Review screen
  wizardDrafts: { [name: string]: any } = {};  // service name -> config draft
  selectedPieceIndex: number = 0;    // which generated piece is selected in the bending step
  // Remembered piece selection per wizard service. Stepping back into an already
  // configured bending step must restore what the user picked instead of forcing
  // them to select a piece again (which also re-disables "Review Services").
  // Kept off the draft so it never reaches the service payload.
  private wizardPieceSelection: { [name: string]: number } = {};
  reviewBendPieceIndex: number = -1;  // which piece's bends are shown on the Review screen (-1 = none until clicked)
  private _wizardQty: number = 1;
  private _wizardItem: any = null;
  // Identifies the wizard session the current drafts belong to (item + group + services).
  // Re-entering the same session resumes those drafts instead of wiping them.
  private _wizardSessionKey: string | null = null;

  // Transient "X has been added automatically" confirmation (no-config services e.g. Punching)
  showAutoAddedBanner: boolean = false;
  autoAddedBannerText: string = '';
  private _bannerTimer: any;

  /** Services that require a configure screen. Others (Punching) are added directly. */
  isConfigurableService(s: any): boolean {
    return ['Cutting', 'Slitting', 'Bending'].includes(s?.name);
  }

  dismissAutoAddedBanner() {
    if (!this.showAutoAddedBanner) return;
    this.showAutoAddedBanner = false;
    if (this._bannerTimer) clearTimeout(this._bannerTimer);
  }

  /** True when the current selection has a configurable service still needing a config screen. */
  get selectedHasConfigurableUnconfigured(): boolean {
    return this.serviceGroups.some(g =>
      (this.groupSelectedServices[g.id] || []).some(
        (s: any) => this.isConfigurableService(s) && !this.hasConfigsForService(g, s.name)
      )
    );
  }

  /** Preset shape for a draft (combined: from first piece that has one; standalone: draft.bendPreset). */
  bendPresetForDraft(d: any): string | null {
    console.log(d, "d pieces")
    if (!d) return null;
    if (d.pieces?.length) {
      const withPreset = d.pieces.find((p: any) => p.bendPreset);
      return withPreset?.bendPreset || null;
    }
    return d.bendPreset || null;
  }

  /** On the combined bending step, the user must pick a generated piece before
   *  they can move on to Review Services. True while no piece is highlighted. */
  get bendingPieceUnselected(): boolean {
    return this.selectedService?.name === 'Bending'
      && !!this.draftConfig?.pieces?.length
      && this.selectedPieceIndex < 0;
  }

  /** The object that currently holds bendRows/bendPreset:
   *  - combined flow (bending after cutting): the selected generated piece
   *  - standalone bending: the draftConfig itself */
  get activeBend(): any {
    if (this.draftConfig?.name === 'Bending' && this.draftConfig?.pieces?.length) {
      // No piece selected yet → no active bend target (user must pick one first).
      if (this.selectedPieceIndex < 0) return null;
      return this.draftConfig.pieces[this.selectedPieceIndex] || null;
    }
    return this.draftConfig;
  }

  /** "Total Length" shown in the Cross-Section Preview: the length of the item/piece
   *  being configured on this page — the selected cut piece's length (combined flow),
   *  or the product's own length (standalone bending). Never the per-bend length or
   *  the original stock's full length. Null hides the chip. */
  get bendTotalLength(): number | null {
    const len = this.activeBendEdgeLength();
    if (len != null && len > 0) return len;
    // Combined flow with no piece selected → hide; standalone → the product length.
    return this.draftConfig?.pieces?.length ? null : this.getProductLengthInInches();
  }

  /** The dimension the active bend target's distances run along — the width when
   *  bent from the width side, otherwise the length. Uses the cut piece's own
   *  dimensions in the combined flow, or the sheet's (product) dimensions when
   *  bending a standalone sheet. Null when unknown. */
  private activeBendEdgeLength(): number | null {
    return this.bendEdgeLengthOf(this.activeBend);
  }

  private bendEdgeLengthOf(target: any, standalone = target === this.draftConfig): number | null {
    if (!target) return null;
    const useWidth = target.bendAxis === 'width';

    const dim = standalone
      ? Number(useWidth ? this.getProductWidthInInches() : this.getProductLengthInInches())
      : Number(useWidth ? target.width : target.length);
    return Number.isFinite(dim) && dim > 0 ? dim : null;
  }

  /** Width/length shown in the Bend Side chooser: the active cut piece's dimensions
   *  in the combined flow, or the sheet's (product) dimensions for standalone bending. */
  get bendSideWidth(): number | null {
    const p = this.activeBend;
    if (p && p !== this.draftConfig) return Number(p.width) || null;
    return this.getProductWidthInInches();
  }
  get bendSideLength(): number | null {
    const p = this.activeBend;
    if (p && p !== this.draftConfig) return Number(p.length) || null;
    return this.getProductLengthInInches();
  }

  /** Both dimensions known, positive, and different (not square). */
  private dimsDiffer(w: number | null, l: number | null): boolean {
    return w != null && Number.isFinite(w) && w > 0
      && l != null && Number.isFinite(l) && l > 0
      && Math.abs(w - l) > 1e-6;
  }

  /** A rectangular piece can be bent from either edge, so offer the choice only when
   *  it isn't square. Applies both to a selected cut piece (combined flow) and to a
   *  standalone sheet bend, using the sheet's own width/length in the latter case. */
  get canChooseBendSide(): boolean {
    const p = this.activeBend;
    if (!p) return false;
    // Combined flow: bends sit on a selected cut piece.
    if (p !== this.draftConfig && this.draftConfig?.pieces?.length) {
      return this.dimsDiffer(Number(p.width), Number(p.length));
    }
    // Standalone: bending the sheet itself — use the product's dimensions.
    if (p === this.draftConfig && (this.draftConfig?.name || '').toLowerCase() === 'bending') {
      return this.dimsDiffer(this.getProductWidthInInches(), this.getProductLengthInInches());
    }
    return false;
  }

  /** Which edge the active piece's bends are measured along. Defaults to 'length'. */
  get bendAxis(): 'length' | 'width' {
    return this.activeBend?.bendAxis === 'width' ? 'width' : 'length';
  }

  /** Switch the edge the bends run along and re-derive the distances against the new
   *  reference dimension (re-apply the preset if one is active, else re-spread). */
  setBendAxis(axis: 'length' | 'width') {
    const p = this.activeBend;
    if (!p || (p.bendAxis === 'width' ? 'width' : 'length') === axis) return;
    p.bendAxis = axis;
    if (p.bendPreset) this.applyBendPreset(p.bendPreset);
    else this.redistributeBendLengths();
  }

  bendProfileOpen = false;
  readonly bendProfileOptions = [
    'L Profile',
    'U Profile',
    'Molding',
    'Siding',
    'Channel Raceway',
    'Z Profile',
  ];

  /** Profiles mapped onto their preset shape recipe (see applyBendPreset). */
  private static readonly BEND_PROFILE_PRESET: Record<string, 'Z' | 'U' | 'L' | 'Siding' | 'Molding' | 'ChannelRaceway'> = {
    'L Profile': 'L',
    'U Profile': 'U',
    'Z Profile': 'Z',
    Siding: 'Siding',
    Molding: 'Molding',
    'Channel Raceway': 'ChannelRaceway',
  };
  private static readonly PRESET_BEND_PROFILE: Record<string, string> = {
    L: 'L Profile',
    U: 'U Profile',
    Z: 'Z Profile',
    Siding: 'Siding',
    Molding: 'Molding',
    ChannelRaceway: 'Channel Raceway',
  };

  /** Display text for the per-profile pills, reused by the Quick Summary. */
  private static readonly BEND_OPTION_LABELS: Record<string, string> = {
    '5x5': '5 in X 5 in',
    '5x8': '5 in X 8 in',
    '1in': '1 in',
    '2in': '2 in',
    lightbox: 'Light Box',
    reverse: 'Reverse',
    regular: 'Regular',
    chaser: 'Chaser',
    '5in': '5 in',
    '7in': '7 in',
    '9in': '9 in',
  };

  private static readonly SIDING_SIZES: Record<string, string[]> = {
    regular: ['5in', '7in', '9in'],
    chaser: ['7in', '9in'],
  };

  private static readonly SIDING_RETURN = 1;

  /** Handed out when there is no active bend target, so the template never sees a
   *  fresh array reference on every change-detection pass. */
  private static readonly NO_BEND_ROWS: any[] = [];

  /** Preset/Custom mode and the per-profile options (siding type & sides, common size,
   *  cover) live ON the bend target — the selected cut piece, or the draft itself for a
   *  standalone sheet bend — exactly like bendPreset/bendAxis. That way they follow
   *  piece switching and are saved and restored with the config instead of leaking from
   *  one piece to the next. */
  private get bendOpts(): any {
    const t = this.activeBend;
    if (!t) return {};
    if (!t.bendOptions) t.bendOptions = {};
    return t.bendOptions;
  }
  private setBendOpt(key: string, value: any) {
    if (this.activeBend) this.bendOpts[key] = value;
  }

  get bendProfileMode(): 'preset' | 'custom' {
    return this.bendOpts.mode === 'custom' ? 'custom' : 'preset';
  }

  get sidingType(): 'regular' | 'chaser' | null { return this.bendOpts.sidingType ?? null; }
  set sidingType(v: 'regular' | 'chaser' | null) { this.setBendOpt('sidingType', v); }

  get sidingSides(): 1 | 2 | null { return this.bendOpts.sidingSides ?? null; }
  set sidingSides(v: 1 | 2 | null) { this.setBendOpt('sidingSides', v); }

  get sidingSize(): string | null { return this.bendOpts.sidingSize ?? null; }
  set sidingSize(v: string | null) { this.setBendOpt('sidingSize', v); }

  get endFlange(): number | null {
    const v = this.bendOpts.endFlange;
    return v == null || v === '' ? null : Number(v);
  }
  set endFlange(v: number | null) { this.setBendOpt('endFlange', v); }

  get showEndFlange(): boolean {
    return this.endFlange != null && !!this.activeBend?.bendRows?.length;
  }

  onEndFlangeChange(value: any) {
    const n = Number(value);
    this.endFlange = Number.isFinite(n) && n > 0 ? n : null;
  }

  get bendLineCount(): number {
    return (this.activeBend?.bendRows?.length || 0) + 1;
  }

  /** The cover's own closing line - same "N bends = N+1 lines" rule as the channel. */
  get coverEndFlange(): number | null {
    const v = this.bendOpts.coverEndFlange;
    return v == null || v === '' ? null : Number(v);
  }
  set coverEndFlange(v: number | null) { this.setBendOpt('coverEndFlange', v); }

  get showCoverEndFlange(): boolean {
    return this.coverEndFlange != null && !!this.coverBendRows.length;
  }

  onCoverEndFlangeChange(value: any) {
    const n = Number(value);
    this.coverEndFlange = Number.isFinite(n) && n > 0 ? n : null;
  }

  get coverLineCount(): number { return this.coverBendRows.length + 1; }

  get isSiding(): boolean {
    return this.selectedBendProfile === 'Siding';
  }

  get sidingSizeOptions(): string[] {
    return HeaderComponent.SIDING_SIZES[this.sidingType || ''] || [];
  }

  setSidingType(type: 'regular' | 'chaser') {
    if (!this.activeBend) return;
    this.sidingType = type;
    if (this.sidingSize && !this.sidingSizeOptions.includes(this.sidingSize)) {
      this.sidingSize = null;
    }
    this.applyCommonSizeSegments();
  }

  setSidingSides(sides: 1 | 2) {
    if (!this.activeBend) return;
    this.sidingSides = sides;
    if (this.bendPreset === 'Siding') this.applyBendPreset('Siding');
  }

  get moldingSize(): '1in' | '2in' | 'lightbox' | 'reverse' | null { return this.bendOpts.moldingSize ?? null; }
  set moldingSize(v: '1in' | '2in' | 'lightbox' | 'reverse' | null) { this.setBendOpt('moldingSize', v); }

  get racewaySize(): '5x5' | '5x8' | null { return this.bendOpts.racewaySize ?? null; }
  set racewaySize(v: '5x5' | '5x8' | null) { this.setBendOpt('racewaySize', v); }


  private static readonly COMMON_SIZE_FLANGES: Record<string, number[]> = {
    '1in': [1, 1, 0.25],
    '2in': [1.5, 2, 0.375],
    lightbox: [1.5, 1.5, 1.5],
    reverse: [0.75, 1],
    // Channel Raceway is NOT a plain U: each wall top turns 1" inward and then 1"
    // back up, forming the lips the cover clips into (client's 1D sketch + Figma
    // 14857-282542). Read as lip, return, wall, FACE, wall, return, lip — six bends,
    // seven lines, 19 in of flat stock for a 5x5. First number = wall depth.
    '5x5': [1, 1, 5, 5, 5, 1, 1],
    '5x8': [1, 1, 5, 8, 5, 1, 1],
  };

  /** Height of the raceway's return/upstand, and of the cover's own legs. */
  private static readonly RACEWAY_LIP = 1;

  private static readonly RACEWAY_DIRECTIONS =
    ['up', 'down', 'down', 'down', 'down', 'up'];

  private static readonly COMMON_SIZE_DIRECTIONS: Record<string, string[]> = {
    reverse: ['up'],
    '5x5': HeaderComponent.RACEWAY_DIRECTIONS,
    '5x8': HeaderComponent.RACEWAY_DIRECTIONS,
  };

  private get commonSizeKey(): string | null {
    if (this.isChannelRaceway) return this.racewaySize;
    if (this.isSiding) return this.sidingSize;
    return this.moldingSize;
  }


  private commonSizeFlangesFor(key: string | null): number[] | null {
    if (!key) return null;
    const tabled = HeaderComponent.COMMON_SIZE_FLANGES[key];
    if (tabled) return tabled;
    if (!this.isSiding) return null;
    const wall = parseFloat(key);
    if (!Number.isFinite(wall) || wall <= 0) return null;

    const r = HeaderComponent.SIDING_RETURN;
    return this.sidingSides === 2 ? [r, wall, r] : [r, wall];
  }


  /** The cover for a picked raceway size: a 1" leg, a top spanning the gap between
   *  the channel's two lips (face - 2 lips, so 3" on a 5x5) and a 1" closing leg.
   *  Null with no size picked - the cover then falls back to the proportional recipe. */
  private coverFlangesFor(key: string | null): number[] | null {
    if (!key) return null;
    const f = HeaderComponent.COMMON_SIZE_FLANGES[key];
    if (!f || f.length < 5) return null;
    const lip = HeaderComponent.RACEWAY_LIP;
    return [lip, Math.max(lip, this.roundLen(f[3] - 2 * lip)), lip];
  }

  static hasCommonSize(target: any): boolean {
    const opts = target?.bendOptions;
    return !!(opts && (opts.moldingSize || opts.racewaySize || opts.sidingSize));
  }

  setCommonSize(kind: 'molding' | 'raceway' | 'siding', size: any) {
    if (!this.activeBend) return;
    if (kind === 'molding') this.moldingSize = size;
    else if (kind === 'siding') this.sidingSize = size;
    else this.racewaySize = size;
    this.applyCommonSizeSegments();
    // The cover is cut to the channel it caps, so a size change re-derives it too.
    if (kind === 'raceway' && this.showCoverSection) this.seedCoverBendRows();
  }


  private commonSizeFlatWidth(key: string | null): number | null {
    const flanges = this.commonSizeFlangesFor(key);
    return flanges ? flanges.reduce((a, b) => a + b, 0) : null;
  }


  get commonSizeFitWarning(): string | null {
    const key = this.commonSizeKey;
    const need = this.commonSizeFlatWidth(key);
    const have = this.bendDistributableLength();
    if (need == null || have == null || need <= have + 1e-6) return null;
    const stock = this.draftConfig?.pieces?.length ? 'cut piece' : 'sheet';
    return `A ${this.optionLabel(key)} profile needs ${this.roundLen(need)} in across the `
      + `${this.bendAxis}; this ${stock} is ${this.roundLen(have)} in. `
      + 'Use a larger size or edit the measurements below.';
  }


  private applyCommonSizeSegments() {
    const t = this.activeBend;
    const flanges = this.commonSizeFlangesFor(this.commonSizeKey);
    const segs = flanges ? flanges.slice(0, -1) : null;
    if (!t || !segs || !flanges) return;

    this.endFlange = flanges[flanges.length - 1];

    if ((t.bendRows?.length || 0) < segs.length && t.bendPreset) {
      this.applyBendPreset(t.bendPreset);
      return; 
    }
    if (!t.bendRows?.length) return;
    if (t.bendRows.length > segs.length) t.bendRows.length = segs.length;

    const dirs = HeaderComponent.COMMON_SIZE_DIRECTIONS[this.commonSizeKey || ''];
    t.bendRows.forEach((r: any, i: number) => {
      if (segs[i] != null) { r.distance = segs[i]; r.userSet = true; }
      if (dirs?.[i]) r.direction = dirs[i];
    });
    this.bendViewMode = 'formed';
  }

  /** Cover is on by default for a Channel Raceway (opt-out, per design). */
  get includeCover(): boolean { return this.bendOpts.includeCover !== false; }
  set includeCover(v: boolean) { this.setBendOpt('includeCover', !!v); }

  get coverBendRows(): any[] {
    const t = this.activeBend;
    if (!t) return HeaderComponent.NO_BEND_ROWS;
    const opts = this.bendOpts;
    if (!opts.coverRows) opts.coverRows = [];
    return opts.coverRows;
  }
  set coverBendRows(rows: any[]) { this.setBendOpt('coverRows', rows || []); }

  get isChannelRaceway(): boolean {
    return this.selectedBendProfile === 'Channel Raceway';
  }

  /** Cover bends only exist while the cover is included. */
  get showCoverSection(): boolean {
    return this.isChannelRaceway && this.includeCover;
  }

  setIncludeCover(on: boolean) {
    if (!this.activeBend) return;
    this.includeCover = on;
    if (on && !this.coverBendRows.length) this.seedCoverBendRows();
  }

  private seedCoverBendRows() {
    this.coverBendRows = this.buildCoverRows(this.bendDistributableLength() ?? 0, this.bendOpts);
  }

  /** The cover's own bends. With a common size picked it is the size's cap - both
   *  bends the SAME way so the legs point down into the channel (1 / 3 / 1 on a 5x5,
   *  per the client's 1D sketch); the closing leg is stored on the target's options,
   *  so `opts` is passed in rather than read off activeBend (this also runs for
   *  pieces that aren't on screen). Without a size it stays the old proportional pair. */
  private buildCoverRows(length: number, opts: any): any[] {
    const mk = (direction: string) => ({
      distance: null as number | null, direction, angle: 90,
      useCustom: false, customAngle: null, userSet: false,
    });

    const flanges = this.coverFlangesFor(opts?.racewaySize ?? null);
    if (flanges) {
      const rows = flanges.slice(0, -1).map(() => mk('down'));
      rows.forEach((r, i) => { r.distance = flanges[i]; r.userSet = true; });
      if (opts) opts.coverEndFlange = flanges[flanges.length - 1];
      return rows;
    }

    const rows = [mk('down'), mk('up')];
    const segs = this.presetBendSegments('ChannelRaceway', length);
    rows.forEach((r, i) => { if (segs[i] != null) { r.distance = segs[i]; r.userSet = true; } });
    if (opts) opts.coverEndFlange = null;
    return rows;
  }

  /** Cover rows are stored with the config now, but a raceway saved before that (or one
   *  rebuilt from an order payload, which carries no cover) comes back without them —
   *  seed once on open so the Cover section isn't an empty heading. */
  private ensureCoverRows(target: any, standalone = target === this.draftConfig) {
    if (!target || target.bendPreset !== 'ChannelRaceway') return;
    const opts = target.bendOptions || (target.bendOptions = {});
    if (opts.includeCover === false || opts.coverRows?.length) return;
    opts.coverRows = this.buildCoverRows(this.bendEdgeLengthOf(target, standalone) ?? 0, opts);
  }

  /** Seed the cover on a whole draft (standalone bend + every generated piece). Called
   *  on restore, before the draft is the one on screen, so the standalone flag is
   *  passed explicitly rather than derived from draftConfig. */
  private ensureCoverRowsForDraft(draft: any) {
    if (!draft) return;
    this.ensureCoverRows(draft, true);
    (draft.pieces || []).forEach((p: any) => this.ensureCoverRows(p, false));
  }

  /** Deep copy of a bend target's profile options, always an object so callers can
   *  read/patch it without a null check. */
  private cloneBendOptions(source: any): any {
    return source?.bendOptions ? JSON.parse(JSON.stringify(source.bendOptions)) : {};
  }

  onCoverDistanceChange(row: any) {
    if (row) row.userSet = true;
  }

  selectCoverBendAngle(i: number, angle: number | 'custom') {
    const row = this.coverBendRows[i];
    if (!row) return;
    if (angle === 'custom') {
      row.useCustom = true;
    } else {
      row.useCustom = false;
      row.angle = angle;
    }
  }

  removeCoverBendRow(i: number) {
    if (this.bendRowsLocked) return;
    this.coverBendRows.splice(i, 1);
  }

  /** Complete cover bends, for the Quick Summary. */
  get coverBendCount(): number {
    return this.coverBendRows.filter((r: any) => this.isBendRowComplete(r)).length;
  }

  /** What the picker shows. Derived from the active piece's own preset, so it follows
   *  piece switching and restores with a saved config. */
  get selectedBendProfile(): string | null {
    const preset = this.bendPreset;
    return preset ? HeaderComponent.PRESET_BEND_PROFILE[preset] ?? null : null;
  }

  /** Preset mode with nothing picked yet. The table stays on screen in its empty state
   *  (per spec) — this only drives the hint above it. */
  get showBendProfilePrompt(): boolean {
    return this.bendProfileMode === 'preset' && !this.selectedBendProfile;
  }

  /** In Preset mode the rows (and their count) are generated BY the profile and its
   *  common size — a 5x5 raceway is three bends, not "three until you delete one" — so
   *  the table is read-only there: per Figma, the row delete icon, + ADD BEND and
   *  CLEAR ALL are hidden and only Custom mode shows them. Editing the shape means
   *  switching the mode to Custom, which resets the table anyway. */
  get bendRowsLocked(): boolean {
    return this.bendProfileMode === 'preset';
  }

  // ---- Quick Summary labels (live, so they read the same as the pills) ----
  get bendProfileLabel(): string {
    return this.selectedBendProfile || (this.bendProfileMode === 'custom' ? 'Custom' : '—');
  }
  private optionLabel(v: string | null): string | null {
    return v ? HeaderComponent.BEND_OPTION_LABELS[v] ?? v : null;
  }
  /** Same, for pills rendered from a list (the siding sizes). */
  optionText(v: string): string {
    return this.optionLabel(v) || v;
  }
  get commonSizeLabel(): string | null {
    return this.optionLabel(this.commonSizeKey);
  }
  get sidingTypeLabel(): string | null { return this.optionLabel(this.sidingType); }
  get sidingSidesLabel(): string | null {
    return this.sidingSides ? this.sidingSides + '-sided' : null;
  }

  setBendProfileMode(mode: 'preset' | 'custom') {
    this.bendProfileOpen = false;
    if (!this.activeBend || mode === this.bendProfileMode) return;
    this.setBendOpt('mode', mode);
    if (mode !== 'custom') return;

    // Custom starts from a clean slate: the profile and its per-profile options are
    // dropped and the table resets to a single blank bend, so none of the preset's
    // rows carry over. Only when a profile was actually applied — toggling back and
    // forth must not wipe bends the user entered by hand.
    if (!this.bendPreset) return;
    this.resetBendProfileOptions();
    this.clearBendRows();
  }

  /** Drop every per-profile option, keeping the mode. */
  private resetBendProfileOptions() {
    this.sidingType = null;
    this.sidingSides = null;
    this.sidingSize = null;
    this.moldingSize = null;
    this.racewaySize = null;
    this.endFlange = null;
    this.coverBendRows = [];
  }

  selectBendProfile(profile: string) {
    this.bendProfileOpen = false;
    if (!this.activeBend) return;
    // Per-profile options only belong to their own profile.
    if (profile !== 'Siding') {
      this.sidingType = null;
      this.sidingSides = null;
      this.sidingSize = null;
    }
    if (profile !== 'Molding') this.moldingSize = null;
    if (profile !== 'Channel Raceway') {
      this.racewaySize = null;
      this.coverBendRows = [];
    }

    const preset = HeaderComponent.BEND_PROFILE_PRESET[profile];
    if (!preset) return;
    // Same result as the old Z/U/L shape buttons: builds the bend rows from the recipe.
    this.applyBendPreset(preset);
    if (profile === 'Channel Raceway' && this.includeCover) this.seedCoverBendRows();
  }

  /** Preset shape of the active bend target (drives the profile picker + Quick Summary). */
  get bendPreset(): 'Z' | 'U' | 'J' | 'L' | 'Siding' | 'Molding' | 'ChannelRaceway' | null {
    return this.activeBend?.bendPreset ?? null;
  }
  set bendPreset(v: 'Z' | 'U' | 'J' | 'L' | 'Siding' | 'Molding' | 'ChannelRaceway' | null) {
    if (this.activeBend) this.activeBend.bendPreset = v;
  }

  /** True when both Cutting and Bending are part of the current wizard. */
  get isWizardCombined(): boolean {
    return this.wizardServices.length > 1;
  }

  /** True when the configure flow should use the multi-step Review (cut+bend together,
   *  OR bending derived from an existing cut). Only standalone bending — and a single
   *  cutting — keep the one-step "Save" footer. The cart-variant edit drawer saves per
   *  service (saveEditServiceConfig), so it always stays single-step. */
  get usesWizardReviewFlow(): boolean {
    // A single service edited from the drawer stays one-step (saveEditServiceConfig);
    // a combined Cutting + Bending edit uses the same review wizard as everywhere else.
    if (this.cameFromEditServices && !this.isWizardCombined) return false;
    if (this.isWizardCombined) return true;
    return this.selectedService?.name === 'Bending' && !!this.draftConfig?.pieces?.length;
  }

  get nextWizardServiceName(): string {
    return this.wizardServices[this.wizardStep + 1]?.name || '';
  }

  get isLastWizardService(): boolean {
    return this.wizardStep >= this.wizardServices.length - 1;
  }

  buildDraft(service: any, baseQty: number): any {
    const draft: any = {
      name: service.name,
      qty: baseQty,
      piecesQty: baseQty,
      width: 1,
      length: 1,
      internalQty: 1,
      measurements: [{ width: null, length: null, qty: 1 }],
      // Bending starts with one empty row (distance blank + toggles unselected); a
      // preset shape replaces it. Non-bending services don't use bendRows.
      bendRows: service.name === 'Bending' ? [this.blankBendRow()] : [],
      bendPreset: null,
      editIndex: -1,
      productOptionType: service.productOptionType,
      serviceType: service.serviceType,
      includedQtyInMinimumFee: service.includedQtyInMinimumFee,
      eachAdditionalPrice: service.eachAdditionalPrice,
      minimumServiceFee: service.minimumServiceFee,
      img: service.img,
      msg: service.msg,
      notes: ''
    };
    this.calculateTotal(draft);
    return draft;
  }

  onSelectItemAndConfigure(item: any, service: any, groupQty?: number, groupId?: number) {
    // Single-service entry (kept for callers that pass one service)
    this.startConfigureWizard([service], item, groupQty, groupId);
  }

  /** Entry point for the configure flow. Auto-adds no-config services, then runs the
   *  configure wizard for the rest (Cutting → Bending → Review). */
  startConfigureWizard(services: any[], item: any, groupQty?: number, groupId?: number) {
    // Captured before any state is reassigned — used to decide whether this call
    // re-enters the wizard the user just stepped out of (see resuming below).
    const prevSessionKey = this._wizardSessionKey;
    const prevHadWizard = this.wizardServices.length > 0 && Object.keys(this.wizardDrafts).length > 0;
    const prevStep = this.wizardStep;
    const prevWasReview = this.isReviewStep;

    this.activeGroupId = groupId || null;
    this.selectedProductForNewConfig = item.product || item;
    this._wizardItem = item;
    this._wizardQty = groupQty !== undefined ? groupQty : (item.qty || item.cartQty || 1);

    const configurable = services.filter(s => this.isConfigurableService(s));
    const noConfig = services.filter(s => !this.isConfigurableService(s));

    // Add no-config services (e.g. Punching) immediately
    const addedNames = this.autoAddNoConfigServices(noConfig, groupId ?? null);

    // Nothing to configure → stay on the selection screen (added services now show as cards)
    if (configurable.length === 0) {
      this.showAutoAddedBanner = false;
      return;
    }

    // Show transient confirmation for what we auto-added
    if (addedNames.length) {
      const verb = addedNames.length > 1 ? 'have' : 'has';
      this.autoAddedBannerText = `${addedNames.join(', ')} ${verb} been added automatically.`;
      this.showAutoAddedBanner = true;
      if (this._bannerTimer) clearTimeout(this._bannerTimer);
      this._bannerTimer = setTimeout(() => { this.showAutoAddedBanner = false; }, 4000);
    } else {
      this.showAutoAddedBanner = false;
    }

    const order = ['Cutting', 'Bending'];
    const ordered = [...configurable].sort((a, b) => {
      const ia = order.indexOf(a.name); const ib = order.indexOf(b.name);
      return (ia === -1 ? 99 : ia) - (ib === -1 ? 99 : ib);
    });

    // Stepping back to "Units & Services" (via the first stepper circle) leaves the
    // drafts in place and comes back through here when the user presses CONFIGURE
    // SERVICES again. Same item + group + services => resume those drafts and the step
    // they left, instead of restarting from blank and losing everything they filled in.
    const sessionKey = this.wizardSessionKey(item, this.activeGroupId, ordered);
    const resuming = prevHadWizard && sessionKey === prevSessionKey;

    this.wizardServices = ordered;
    this._wizardSessionKey = sessionKey;
    if (!resuming) {
      this.wizardDrafts = {};
      this.wizardPieceSelection = {};
    }
    this.wizardStep = 0;
    this.isReviewStep = false;
    this.bendViewMode = 'formed';
    this.selectedPieceIndex = 0;
    this.reviewBendPieceIndex = -1;
    const startStep = resuming ? Math.min(Math.max(prevStep, 0), ordered.length - 1) : 0;
    this.loadWizardStep(startStep);
    // They were on Review when they stepped out → put them back on Review.
    if (resuming && prevWasReview) this.goToReviewStep();
    this.addNewConfig = true;
  }

  /** Stable identity for a wizard session: same item, same group and same set of
   *  services means the drafts already in memory belong to this run. */
  private wizardSessionKey(item: any, groupId: number | null, services: any[]): string {
    const itemId = item?.cartId ?? item?.variantId ?? item?.slug ?? item?.id ?? '';
    return [groupId ?? '', itemId, services.map((s: any) => s.name).sort().join(',')].join('|');
  }

  /** Push minimal configs for services that have no configure screen (Punching).
   *  Returns the names actually added (skips ones already configured). */
  autoAddNoConfigServices(noConfig: any[], groupId: number | null): string[] {
    const added: string[] = [];
    noConfig.forEach((svc, idx) => {
      const group = groupId !== null ? this.serviceGroups.find(g => g.id === groupId) : null;
      if (group) {
        if (!group.configs) group.configs = [];
        if (this.hasConfigsForService(group, svc.name)) return;
        group.configs.push(this.buildNoConfigEntry(svc, idx));
        added.push(svc.name);
      } else {
        if (!svc.configs) svc.configs = [];
        if (svc.configs.length) return;
        svc.configs.push(this.buildNoConfigEntry(svc, idx));
        added.push(svc.name);
      }
    });
    return added;
  }

  buildNoConfigEntry(svc: any, idx: number): any {
    return {
      name: svc.name,
      isSaved: true,
      configId: Date.now() + idx,
      editIndex: -1,
      qty: this._wizardQty,
      piecesQty: this._wizardQty,
      measurements: [],
      productOptionType: svc.productOptionType,
      serviceType: svc.serviceType,
      img: svc.img,
      msg: svc.msg,
      minimumServiceFee: svc.minimumServiceFee || 0,
      includedQtyInMinimumFee: svc.includedQtyInMinimumFee || 0,
      eachAdditionalPrice: svc.eachAdditionalPrice || 0,
      totalAmount: svc.minimumServiceFee || 0
    };
  }

  loadWizardStep(i: number) {
    const service = this.wizardServices[i];
    if (!service) return;
    this.wizardStep = i;
    this.isReviewStep = false;
    this.selectedService = service;
    this.selectedPieceIndex = 0;

    let draft = this.wizardDrafts[service.name];
    const isRevisit = !!draft;
    if (!draft) {
      draft = this.buildDraft(service, this._wizardQty);
      this.wizardDrafts[service.name] = draft;
    }
    if (service.name === 'Bending') {
      // syncBendingPieces re-derives the pieces from the cut and clears the
      // selection (correct on a first visit). On a revisit the user has already
      // configured this step, so put their piece back — otherwise activeBend is
      // null, the bend panel looks empty and they must re-pick the piece.
      this.syncBendingPieces(draft);
      if (isRevisit) this.selectedPieceIndex = this.rememberedPieceIndex(service.name, draft);
    }
    this.draftConfig = draft;
    // Default to FLAT when no bends are configured yet; FORMED once bends exist.
    this.bendViewMode = this.hasAnyBends(draft) ? 'formed' : 'flat';
  }

  /** True when the bend config (or any of its pieces) has at least one bend the user has
   *  actually entered. Counts COMPLETE rows only (a distance) — the empty starter row
   *  that both standalone bending and a freshly-picked piece open with is not a bend.
   *  Row count alone would make an untouched step read as "already has bends", which
   *  flips the preview to FORMED and fires the "existing bends will be removed" confirm
   *  when cutting is edited. */
  hasAnyBends(config: any): boolean {
    if (!config) return false;
    const anyComplete = (rows: any[]) => (rows || []).some((r: any) => this.isBendRowComplete(r));
    if (config.pieces?.length) {
      return config.pieces.some((p: any) => anyComplete(p.bendRows));
    }
    return anyComplete(config.bendRows);
  }

  // ---- Reusable cutting/bending confirmation popup --------------------------
  // Rule: whenever cutting changes, existing bending becomes invalid. A single
  // data-driven modal (rendered in header.component.html, reusing the existing
  // .service-unavailable-modal styling) covers every scenario. The gated action
  // is captured in onConfirm and replayed when the user confirms.
  serviceConfirm: {
    title: string;
    message: string;
    affected: string[];
    cancelLabel: string;
    confirmLabel: string;
    onConfirm: () => void;
  } | null = null;

  private askServiceConfirm(cfg: {
    title: string; message: string; affected: string[];
    cancelLabel: string; confirmLabel: string; onConfirm: () => void;
  }) {
    this.serviceConfirm = cfg;
  }

  cancelServiceConfirm() {
    this.serviceConfirm = null;
  }

  confirmServiceConfirm() {
    const action = this.serviceConfirm?.onConfirm;
    this.serviceConfirm = null;
    action?.();
  }

  /** Bending config that already carries bends, inside a specific group. */
  private groupBendingWithBends(group: any): any {
    return (group?.configs || []).find(
      (c: any) => (c.name || '').toLowerCase() === 'bending' && this.hasAnyBends(c)
    ) || null;
  }

  /** Bending config (with bends) in the current cutting context — group or non-group. */
  private contextBendingWithBends(): any {
    if (this.activeGroupId !== null) {
      const group = this.serviceGroups.find(g => g.id === this.activeGroupId);
      return group ? this.groupBendingWithBends(group) : null;
    }
    const svc = this.services.find((s: any) => (s.name || '').toLowerCase() === 'bending');
    return (svc?.configs || []).find((c: any) => this.hasAnyBends(c)) || null;
  }

  /** Bending option (already carrying bends) on the cart variant being edited. */
  private variantBendingWithBends(): any {
    const cartId = this.draftConfig?.editVariantCartId;
    const variant = this.editingVariant?.cartId === cartId
      ? this.editingVariant
      : (this.selectedVariantProducts || []).find((v: any) => v.cartId === cartId) || this.editingVariant;
    // Hydrated cart/quote options carry no `name`, only productOptionType, so resolve
    // the service name from the type (falling back to name) — otherwise bending on a
    // variant already in cart isn't detected and its bends survive a cutting change.
    return (variant?.options || []).find(
      (o: any) => (this.getServiceName(o.productOptionType) || o.name || '').toLowerCase() === 'bending'
        && this.hasAnyBends(o)
    ) || null;
  }

  /** Bending config whose pieces derive from the cutting draft currently open. */
  private bendingForCuttingDraft(): any {
    if (this.wizardDrafts?.['Bending']) return this.wizardDrafts['Bending'];
    // Cart-variant edit: bending lives as an option on the variant being edited.
    // Hydrated cart/quote options carry no `name`, so resolve it from productOptionType.
    if (this.draftConfig?.editVariantCartId != null) {
      const variantBend = (this.editingVariant?.options || []).find(
        (o: any) => (this.getServiceName(o.productOptionType) || o.name || '').toLowerCase() === 'bending'
          && o.pieces?.length
      );
      if (variantBend) return variantBend;
    }
    if (this.activeGroupId !== null) {
      const group = this.serviceGroups.find(g => g.id === this.activeGroupId);
      return (group?.configs || []).find(
        (c: any) => (c.name || '').toLowerCase() === 'bending' && c.pieces?.length
      ) || null;
    }
    const svc = this.services.find((s: any) => (s.name || '').toLowerCase() === 'bending');
    return (svc?.configs || []).find((c: any) => c.pieces?.length) || null;
  }

  /** Piece to re-highlight when returning to an already-configured bending step: the one
   *  the user last selected, else the first piece that carries bends. -1 when nothing has
   *  been configured yet, so a step the user only passed through still asks for a pick.
   *  The remembered index is bounds-checked because editing the cut can drop pieces. */
  private rememberedPieceIndex(serviceName: string, draft: any): number {
    const pieces = draft?.pieces || [];
    if (!pieces.length) return -1;
    const remembered = this.wizardPieceSelection[serviceName];
    if (remembered != null && remembered > -1 && remembered < pieces.length) return remembered;
    // Land on the first piece that actually carries a bend, not merely one holding the
    // empty starter row that selecting a piece leaves behind.
    return pieces.findIndex((p: any) =>
      (p.bendRows || []).some((r: any) => this.isBendRowComplete(r)));
  }

  /** Select a generated piece on the bending step, remembering it for when the user
   *  steps away and comes back (via Back or a stepper circle). */

  selectBendPiece(pi: number) {
    const current = this.draftConfig?.pieces?.[this.selectedPieceIndex];
    if (pi !== this.selectedPieceIndex && current) {
      this.askServiceConfirm({
        title: 'Finish configuring this piece?',
        message: `Your bend configuration for Piece ${current.label} isn't complete yet. `
          + 'Finish configuring before switching to another generated piece.',
        affected: [],
        cancelLabel: 'STAY ON THIS PIECE',
        confirmLabel: 'FINISH CONFIGURING',
        onConfirm: () => this.applyBendPieceSelection(pi),
      });
      return;
    }
    this.applyBendPieceSelection(pi);
  }

  private applyBendPieceSelection(pi: number) {
    this.selectedPieceIndex = pi;
    if (this.selectedService?.name) this.wizardPieceSelection[this.selectedService.name] = pi;
    // Open the piece with one empty bend row to fill in, the same way standalone bending
    // opens (buildDraft seeds bendRows: [blankBendRow()]). Pieces derived from a cut
    // start with no rows at all, so picking one used to show nothing until you pressed
    // "+ Add bend". A row that is left blank is ignored by isBendDraftValid/hasAnyBends,
    // so seeding it can't make the step look configured or block Confirm.
    const piece = this.draftConfig?.pieces?.[pi];
    if (piece && !piece.bendRows?.length) piece.bendRows = [this.blankBendRow()];
    // A raceway piece restored without its cover rows gets them back on open.
    this.ensureCoverRows(piece, false);
  }

  /** Build/refresh the per-piece bend list from the cutting step's generated pieces. */
  syncBendingPieces(bendingDraft: any) {
    this.syncBendPiecesFromCutting(bendingDraft, this.getCuttingSourceForBend());
    this.selectedPieceIndex = -1; // no piece selected on landing — user picks one to apply bends
  }

  /** Cutting config the bending pieces derive from: the in-wizard Cutting draft when
   *  both are configured together, otherwise a Cutting config already saved in the
   *  active group / service. This makes "add Bending after Cutting" open the same
   *  piece-selection flow as configuring them together. Null → standalone bending. */
  private getCuttingSourceForBend(): any {
    if (this.wizardDrafts['Cutting']) return this.wizardDrafts['Cutting'];
    // Cart-variant edit: the cut lives as an option on the variant being edited
    // (mirrors bendingForCuttingDraft). Hydrated cart/quote options carry no `name`,
    // so resolve the service from productOptionType. Without this, "add Bending after
    // a cut" in the cart finds no source and the bend falls back to a standalone
    // full-sheet bend — which the payload builder then drops once cuts exist.
    if (this.draftConfig?.editVariantCartId != null) {
      const variantCut = (this.editingVariant?.options || []).find((o: any) => {
        const n = (this.getServiceName(o.productOptionType) || o.name || '').toLowerCase();
        return (n === 'cutting' || n === 'slitting') && o.measurements?.length;
      });
      if (variantCut) return variantCut;
    }
    if (this.activeGroupId !== null) {
      const group = this.serviceGroups.find(g => g.id === this.activeGroupId);
      return (group?.configs || []).find((c: any) => (c.name || '').toLowerCase() === 'cutting') || null;
    }
    const cuttingSvc = this.services.find((s: any) => (s.name || '').toLowerCase() === 'cutting');
    return (cuttingSvc?.configs || [])[0] || null;
  }

  /** Re-derive a bending config's pieces from a cutting config's current cuts,
   *  preserving each piece's bends/preset by label. Used by the wizard
   *  (wizardDrafts) and when editing a saved bending config in a group — so a cut
   *  that was added/removed/resized is reflected in the bends. */
  private syncBendPiecesFromCutting(bendingConfig: any, cuttingConfig: any) {
    if (!cuttingConfig) { bendingConfig.pieces = null; return; }  // standalone bending
    const pieces = this.generatedPiecesFor(cuttingConfig);
    const prev = bendingConfig.pieces || [];
    bendingConfig.pieces = pieces.map((p: any) => {
      const old = prev.find((o: any) => o.label === p.label);
      const bendPreset = old?.bendPreset || null;
      let bendRows = old?.bendRows || [];
      // A piece still on a preset re-derives its bends for the (possibly new) cut
      // length, so the shape stays proportional when the size changes. A piece pinned
      // to a catalog common size keeps those exact dimensions instead.
      if (bendPreset && !HeaderComponent.hasCommonSize(old) && Number(p?.length) > 0) {
        const segs = this.presetBendSegments(bendPreset, Number(p.length));
        if (segs.length) {
          bendRows = bendRows.map((r: any, i: number) =>
            segs[i] != null ? { ...r, distance: segs[i], userSet: true } : r
          );
        }
      }
      // The piece keeps its profile options (siding/common size/cover) across a
      // re-sync, the same way it keeps its preset.
      return { ...p, bendRows, bendPreset, bendOptions: old?.bendOptions ?? null };
    });
  }

  generatedPiecesFor(config: any): any[] {
    return (config?.measurements || []).map((m: any, i: number) => ({
      label: this.getLetter(i),
      width: m.width,
      length: m.length,
      qty: m.qty
    }));
  }

  /** After a Cutting config is edited/saved, re-derive the pieces of any sibling
   *  Bending config in the same list (combined cutting+bending flow). Removing a
   *  cut drops its generated piece — and the bends on it — from the bending config,
   *  and the bending price is recomputed for the new piece count. */
  private resyncBendingFromCutting(configs: any[], cuttingConfig: any) {
    if (!cuttingConfig || (cuttingConfig.name || '').toLowerCase() !== 'cutting') return;
    (configs || []).forEach((c: any) => {
      if (c !== cuttingConfig && (c.name || '').toLowerCase() === 'bending' && c.pieces) {
        this.syncBendPiecesFromCutting(c, cuttingConfig);
        c.totalAmount = this.calcServiceTotal(c);
      }
    });
  }

  /** When Cutting is saved, any Bending that was configured against the FULL SHEET
   *  (standalone bends — `bendRows` but no per-piece `pieces`) no longer applies: bends
   *  must now be defined per cut piece. Drop those stale full-sheet bend configs in place
   *  so the user re-adds bends based on the new cut pieces. Piece-based bending is left
   *  for resyncBendingFromCutting to keep in sync. No-op unless `cuttingConfig` is Cutting. */
  private dropFullSheetBendingForCutting(configs: any[], cuttingConfig: any) {
    if (!Array.isArray(configs)) return;
    if (!cuttingConfig || (cuttingConfig.name || '').toLowerCase() !== 'cutting') return;
    for (let i = configs.length - 1; i >= 0; i--) {
      const c = configs[i];
      if (c !== cuttingConfig && (c?.name || '').toLowerCase() === 'bending' && !(c?.pieces?.length)) {
        configs.splice(i, 1);
      }
    }
  }

  /** Editing an existing Cutting config can change the pieces its bends sit on, so the
   *  dependent Bending is dropped entirely instead of being re-synced — the user re-adds
   *  bends against the updated cuts. Honors the "Bend Configuration Needs Updating" prompt
   *  ("...will be removed and will need to be reconfigured"). Removes every Bending entry. */
  private removeBendingForCuttingUpdate(configs: any[]) {
    if (!Array.isArray(configs)) return;
    for (let i = configs.length - 1; i >= 0; i--) {
      if ((configs[i]?.name || '').toLowerCase() === 'bending') {
        configs.splice(i, 1);
      }
    }
  }

  /** Remove every Bending option from a cart variant (and clear its checkbox tick).
   *  Used when Cutting is removed, or a Cutting edit invalidates the pieces its bends
   *  were built on, so the user re-adds bends against the updated cuts. */
  private removeVariantBendingOptions(variant: any) {
    const opts = variant?.options;
    if (!Array.isArray(opts)) return;
    for (let i = opts.length - 1; i >= 0; i--) {
      const o = opts[i];
      const name = (this.getServiceName(o?.productOptionType) || o?.name || '').toLowerCase();
      if (name === 'bending') {
        this.editVariantSelectedTypes.delete(o?.productOptionType);
        opts.splice(i, 1);
      }
    }
  }

  /** Count of bends for a config: sum across pieces (combined) or bendRows (standalone). */
  /** Bends actually entered on one target — a piece, or the whole config for standalone
   *  bending. COMPLETE rows only: the empty starter row that opens with a picked piece
   *  is not a bend, so it must not earn a blue tick or count towards "N Bends". */
  bendCount(target: any): number {
    return (target?.bendRows || []).filter((r: any) => this.isBendRowComplete(r)).length;
  }

  /** Bends shown on the preview chip. Unlike bendCount() this INCLUDES the cover's
   *  own bends, per the Channel Raceway mockup (6 channel + 2 cover = "8 Bends").
   *  Billing counts them too (v2.1) — see totalBendsFor()/coverBendsOf(). */
  get previewBendCount(): number {
    const n = this.bendCount(this.activeBend);
    if (!this.showCoverSection) return n;
    return n + this.coverBendRows.filter((r: any) => this.isBendRowComplete(r)).length;
  }

  totalBendsFor(config: any): number {
    if (config?.pieces?.length) {
      return config.pieces.reduce((s: number, p: any) => s + this.bendCount(p) + this.coverBendsOf(p), 0);
    }
    return this.bendCount(config) + this.coverBendsOf(config);
  }

  /** The raceway cover a target sends as its own piece (v2.1), or null when it has
   *  none, it is switched off, or no cover bend is complete yet. */
  private coverInputFor(target: any): CoverInput | null {
    const opts = target?.bendOptions;
    if (target?.bendPreset !== 'ChannelRaceway' || !opts || opts.includeCover === false) return null;
    const rows = (opts.coverRows || []).filter((r: any) => this.isBendRowComplete(r));
    return rows.length ? { bendRows: rows, endFlange: opts.coverEndFlange ?? null } : null;
  }

  /** Cover bends bill with the channel's (backend 2.1 sample: 4 body + 2 cover = 6). */
  private coverBendsOf(target: any): number {
    return this.coverInputFor(target)?.bendRows.length ?? 0;
  }

  /** Billable bend count = Σ(bends × piece quantity), matching the v1.1
   *  bending.quantity rule so the UI preview equals the persisted billing. */
  weightedBendCountFor(config: any): number {
    if (config?.pieces?.length) {
      return config.pieces.reduce(
        (s: number, p: any) => s + ((p.bendRows?.length || 0) + this.coverBendsOf(p)) * (Number(p.qty) || 1),
        0
      );
    }
    const bends = (config?.bendRows?.length || 0) + this.coverBendsOf(config);
    // Standalone bend-only: the whole stock is bent, so multiply by the units qty.
    const pieceQty = Number(config?.qty) || Number(config?.internalQty) || 1;
    return bends * pieceQty;
  }

  /** Pricing per service: bends counted for Bending, cuts for everything else. */
  calcServiceTotal(config: any): number {
    if (!config) return 0;
    if (config.name === 'Bending') {
      const totalBends = this.weightedBendCountFor(config);
      const inc = config.includedQtyInMinimumFee || 0;
      const fee = config.minimumServiceFee || 0;
      const each = config.eachAdditionalPrice || 0;
      return fee + Math.max(0, totalBends - inc) * each;
    }
    return this.calculateTotal(config);
  }

  bendBadge(piece: any): string {
    const n = this.bendCount(piece);
    if (n === 0) return 'No Bend';
    return `${n} Bend${n > 1 ? 's' : ''}`;
  }

  selectAllPieces() {
    const src = this.activeBend;
    if (!src || !this.draftConfig?.pieces?.length) return;
    const clone = () => JSON.parse(JSON.stringify(src.bendRows || []));
    this.draftConfig.pieces.forEach((p: any) => {
      p.bendRows = clone();
      p.bendPreset = src.bendPreset || null;
      // Own copy, so editing one piece's cover/siding options doesn't move the others.
      p.bendOptions = this.cloneBendOptions(src);
    });
  }

  // ── Wizard navigation ──────────────────────────────────────────────
  wizardNext() {
    if (this.wizardStep < this.wizardServices.length - 1) {
      this.loadWizardStep(this.wizardStep + 1);
    } else {
      this.isReviewStep = true;
      this.reviewBendPieceIndex = 0; // highlight the first piece by default on the Review screen
    }
  }

  wizardBack() {
    if (this.isReviewStep) {
      this.loadWizardStep(this.wizardServices.length - 1);
      return;
    }
    if (this.wizardStep > 0) {
      this.loadWizardStep(this.wizardStep - 1);
      return;
    }
    this.goBackFromConfigure();
  }

  editWizardService(name: string) {
    const idx = this.wizardServices.findIndex((s: any) => s.name === name);
    if (idx > -1) this.loadWizardStep(idx);
  }

  /** Is this wizard service's data complete enough to count as configured? */
  isWizardStepConfigured(si: number): boolean {
    const svc = this.wizardServices[si];
    if (!svc) return false;
    const draft = this.wizardDrafts[svc.name];
    if (!draft) return false;
    return svc.name === 'Bending'
      ? this.isBendDraftValid(draft)
      : this.areMeasurementsValid(draft, svc.name);
  }

  /** Visual state of a wizard step circle — mutually exclusive by construction, and
   *  driven purely by where the user is, never by whether a step holds data:
   *   - the step on screen  -> current (hollow dark ring)
   *   - steps already passed -> filled (black)
   *   - steps still ahead    -> outline (grey), exactly like Review looks from here,
   *                             even when they were configured earlier.
   *  Being configured only affects whether the circle is *clickable*
   *  (see canJumpToWizardStep) — the saved data is still there when you jump back in. */
  wizardCircleState(si: number): 'current' | 'filled' | 'outline' {
    if (si === this.wizardStep && !this.isReviewStep) return 'current';
    if (si < this.wizardStep || this.isReviewStep) return 'filled';
    return 'outline';
  }

  /** The step on screen is complete (same rule the footer's Confirm button uses). */
  get isCurrentWizardStepConfigured(): boolean {
    return this.isWizardStepConfigured(this.wizardStep) && !this.bendingPieceUnselected;
  }

  /** A step circle is clickable when it's the current step, one already passed, or a
   *  LATER step that's already configured — so once cutting and bending are both filled
   *  in, the circles jump straight between them without pressing Confirm again.
   *  Jumping forward still needs the current step valid, and needs every step in between
   *  configured, so a jump can't skip past an empty step or strand a half-filled one. */
  canJumpToWizardStep(si: number): boolean {
    if (si === this.wizardStep && !this.isReviewStep) return false;  // already here
    if (this.isReviewStep || si < this.wizardStep) return true;      // going back
    if (!this.isCurrentWizardStepConfigured) return false;
    for (let i = this.wizardStep + 1; i <= si; i++) {
      if (!this.isWizardStepConfigured(i)) return false;
    }
    return true;
  }

  /** The Review circle is clickable once every service in the wizard is configured. */
  get canJumpToReview(): boolean {
    if (this.isReviewStep || !this.wizardServices.length) return false;
    if (!this.isCurrentWizardStepConfigured) return false;
    return this.wizardServices.every((_s: any, i: number) => this.isWizardStepConfigured(i));
  }

  /** Jump to Review from a step circle (same end state as wizardNext on the last step). */
  goToReviewStep() {
    if (!this.canJumpToReview) return;
    this.isReviewStep = true;
    this.reviewBendPieceIndex = 0;
  }

  /** Total across every service draft in the wizard (used on Review). */
  get wizardGrandTotal(): number {
    return this.wizardServices.reduce((sum: number, s: any) => {
      const d = this.wizardDrafts[s.name];
      return sum + (d ? this.calcServiceTotal(d) : 0);
    }, 0);
  }

  /** Save every configured service draft to the active group, then exit the wizard. */
  async saveAllWizard() {
    if (this.isSavingService) return;
    this.isSavingService = true;
    await new Promise(resolve => setTimeout(resolve, 1200));

    const savedIds: any[] = [];

    // Cart "Editing Services" drawer: persist each configured draft back onto the
    // variant's options (same target as the single-service save), then return to the drawer.
    if (this.editingVariant && this.cameFromEditServices) {
      this.wizardServices.forEach((svc: any) => {
        const draft = this.wizardDrafts[svc.name];
        if (draft) this.applyDraftToVariantOption(this.editingVariant, svc, draft);
      });
      this.editingVariant.servicesChanged = true;
      this.editingVariant.__servicesEditedSession = true;
      this.isSavingService = false;
      this.addNewConfig = false;
      this.addNewProduct = false;
      this.isReviewStep = false;
      this.draftConfig = null;
      this.selectedService = null;
      this.wizardServices = [];
      this.wizardDrafts = {};
      this.wizardPieceSelection = {};
      this.activeGroupId = null;
      this.cameFromEditServices = false;
      this.cameFromVariantEdit = false;
      this.editingVariantServices = true;
      return;
    }

    this.wizardServices.forEach((svc: any, idx: number) => {
      const draft = this.wizardDrafts[svc.name];
      if (!draft) return;
      const configId = draft.configId || (Date.now() + idx);
      savedIds.push(configId);
      const target = {
        ...draft,
        isSaved: true,
        configId,
        bendPreset: this.bendPresetForDraft(draft),
        totalBends: this.totalBendsFor(draft),
        totalAmount: this.calcServiceTotal(draft)
      };
      if (this.activeGroupId !== null) {
        const group = this.serviceGroups.find(g => g.id === this.activeGroupId);
        if (group) {
          if (!group.configs) group.configs = [];
          if (draft.editIndex > -1) group.configs[draft.editIndex] = target;
          else group.configs.push(target);
        }
      } else {
        if (!svc.configs) svc.configs = [];
        if (draft.editIndex > -1) svc.configs[draft.editIndex] = target;
        else svc.configs.push(target);
      }
      // Cart-edit (inline card combined cut+bend): mirror each configured service into
      // the variant's options so saveVariantChanges' re-add sends the full set.
      this.syncConfigToVariantOptions(svc, draft);
    });

    this.markJustSaved(savedIds);

    this.isSavingService = false;
    this.addNewConfig = false;
    this.isReviewStep = false;
    this.draftConfig = null;
    this.wizardServices = [];
    this.wizardDrafts = {};
    this.wizardPieceSelection = {};
    this.activeGroupId = null;
  }

  /** A fresh, unconfigured bend row: empty distance + nothing selected on the toggles
   *  (per design — the user picks direction & angle). userSet keeps the empty distance
   *  from being auto-overwritten until they type one. */
  blankBendRow() {
    return { distance: null, direction: null, angle: null, useCustom: false, customAngle: null, userSet: true };
  }

  /** A bend row counts once the user has entered a distance. Direction and angle are
   *  optional toggles (they default to up / 90 on save — e.g. an L-shape shouldn't force
   *  a direction choice), so they're NOT required here. Used for validation and to keep
   *  the empty default row out of the preview. */
  isBendRowComplete(r: any): boolean {
    return r?.distance != null && r.distance !== '' && Number(r.distance) > 0;
  }

  addBendRow() {
    const t = this.activeBend;
    if (!t || this.bendRowsLocked) return;
    if (!t.bendRows) t.bendRows = [];
    // Adding a bend deviates from the preset → it's now a custom shape. Keep the
    // existing bends where they are (lock them) so only the new row auto-fills.
    if (t.bendPreset) {
      t.bendPreset = null;
      t.bendRows.forEach((r: any) => { if (r.distance != null) r.userSet = true; });
    }
    t.bendRows.push(this.blankBendRow());
    // Adding a bend forms the shape → switch the preview to the FORMED view.
    this.bendViewMode = 'formed';
    // One more segment now shares the total length → re-spread the auto segments.
    this.redistributeBendLengths();
  }

  removeBendRow(i: number) {
    const t = this.activeBend;
    if (!t?.bendRows || this.bendRowsLocked) return;
    // Removing a bend breaks the preset shape → it's now custom.
    if (t.bendPreset) {
      t.bendPreset = null;
      t.bendRows.forEach((r: any) => { if (r.distance != null) r.userSet = true; });
    }
    t.bendRows.splice(i, 1);
    // No bends left → the shape is flat, so switch the preview back to FLAT.
    if (!t.bendRows.length) this.bendViewMode = 'flat';
    // Fewer segments → re-spread the total length across what's left.
    this.redistributeBendLengths();
  }

  clearBendRows() {
    const t = this.activeBend;
    // Locked while a preset profile owns the rows. setBendProfileMode() also calls this
    // when switching to Custom — by then the mode has already flipped, so it's unlocked.
    if (!t || this.bendRowsLocked) return;
    // Reset to a single empty row (the table always keeps one default row) rather
    // than an empty table.
    t.bendRows = [this.blankBendRow()];
    t.bendPreset = null;
    // The cleared shape no longer has a stated closing line.
    this.endFlange = null;
    // No bends configured → the shape is flat, so switch the preview back to FLAT.
    this.bendViewMode = 'flat';
  }

  /** Round a length to 2 decimals for clean display in the inputs/labels. */
  private roundLen(n: number): number {
    return Math.round(n * 100) / 100;
  }

  /** Bend positions for each preset, as fractions of the piece length (cumulative
   *  from the start). One entry per bend. A shape splits the length into parts:
   *   - U: bottom is half a side → parts 2:1:2 → bends at 2/5 and 3/5
   *   - Z: equal thirds → 1/3, 2/3
   *   - J: tall back, short return → 1/2, 3/4
   *   - L: equal legs → 1/2
   *  (Z/J/L are defaults and easy to tweak; U is the client's rule.) */
  private static readonly BEND_PRESET_FRACTIONS: Record<string, number[]> = {
    U: [2 / 5, 3 / 5],
    Z: [35.5 / 120, 84.5 / 120], // original Z proportions (≈0.30 / 0.70), not equal thirds
    J: [1 / 2, 3 / 4],
    L: [1 / 2],
    Molding: [1 / 3, 2 / 3],
    ChannelRaceway: [1 / 3, 2 / 3],
  };

  private static readonly BEND_PRESET_SEGMENTS: Record<string, number[]> = {
    
    Siding: [HeaderComponent.SIDING_RETURN, 5],
  };

  /** Segment distances (gap between consecutive bends) for a preset on a given
   *  piece length. The data model stores segments; buildBends() sums them back
   *  into absolute positions. e.g. U on 24" → positions 9.6 & 14.4 → [9.6, 4.8]. */
  private presetBendSegments(shape: string, length: number): number[] {
    const fixed = HeaderComponent.BEND_PRESET_SEGMENTS[shape];
    if (fixed) return fixed.slice();
    const fractions = HeaderComponent.BEND_PRESET_FRACTIONS[shape];
    if (!fractions || !(length > 0)) return [];
    const segs: number[] = [];
    let prev = 0;
    for (const f of fractions) {
      const pos = this.roundLen(length * f);
      segs.push(this.roundLen(pos - prev));
      prev = pos;
    }
    return segs;
  }

  /** Total length to spread across the bend segments. In the combined flow the
   *  bends sit on the SELECTED cut piece, so we distribute over that piece's
   *  length (a 24" cut → bends must fit within 24"); standalone bending uses the
   *  product length. Null when no usable length exists (fields left untouched). */
  private bendDistributableLength(): number | null {
    // activeBendEdgeLength is axis-aware for both a selected cut piece and a
    // standalone sheet bend, so it already resolves to the right reference edge.
    const edge = this.activeBendEdgeLength();
    if (edge != null) return edge;
    const len = this.getProductLengthInInches();
    return len != null && len > 0 ? len : null;
  }

  /** Spread the product's total length across all segments so they sum to it.
   *  A shape with N bends has N+1 segments (N rows + 1 trailing flange).
   *  Rows the user has explicitly typed (row.userSet) keep their value; the
   *  remaining length is split evenly across the untouched rows AND the trailing
   *  flange. Untouched shares are clamped at 0 so they never go negative. */
  redistributeBendLengths() {
    const rows = this.activeBend?.bendRows;
    if (!rows?.length) return;
    const total = this.bendDistributableLength();
    if (total == null) return; // unknown length → don't auto-fill

    // Length locked by user-set rows, clamped so it can't exceed the total.
    let fixed = 0;
    rows.forEach((r: any) => { if (r.userSet) fixed += Math.max(0, Number(r.distance) || 0); });
    fixed = Math.min(fixed, total);

    // The trailing flange (+1) is always auto, plus every untouched row.
    const autoRows = rows.filter((r: any) => !r.userSet);
    const share = this.roundLen(Math.max(0, (total - fixed) / (autoRows.length + 1)));
    autoRows.forEach((r: any) => { r.distance = share; });
  }

  /** A bend distance was edited. Any manual edit — including clearing the field —
   *  marks the row as user-controlled so redistribute won't overwrite it: a cleared
   *  field stays empty (counts as 0) and the remaining segments split the total. */
  onBendDistanceChange(row: any) {
    if (!row) return;
    row.userSet = true;
    // Editing a distance KEEPS the preset (client rule: only ADDING a bend makes
    // it custom). The typed value stays until the next size change re-derives it.
    this.redistributeBendLengths();
  }

  selectBendAngle(i: number, angle: number | 'custom') {
    const row = this.activeBend?.bendRows?.[i];
    if (!row) return;
    if (angle === 'custom') {
      row.useCustom = true;
    } else {
      row.useCustom = false;
      row.angle = angle;
    }
  }

  /** Custom bend angle is limited to 35°–135°. Clamp on blur; empty/invalid → null. */
  clampCustomAngle(row: any) {
    if (!row) return;
    const v = Number(row.customAngle);
    if (row.customAngle === null || row.customAngle === '' || isNaN(v)) {
      row.customAngle = null;
      return;
    }
    row.customAngle = Math.min(135, Math.max(35, v));
  }

  /** One traced outline in raw units: the corner points, the drawn length of each
   *  segment and the length to LABEL it with (null = not user-entered, so unlabelled).
   *  `startDir` is the heading of the first segment in screen radians (+y downward),
   *  so an upright profile starts pointing down. */
  private traceBendOutline(
    rows: any[], startDir: number, trailing: number, trailingLabel: number | null
  ): { pts: { x: number; y: number }[]; dists: number[]; userDists: (number | null)[] } {
    const DEFAULT_SEG = 80;
    let x = 0, y = 0, dir = startDir;
    const pts = [{ x, y }];
    const dists: number[] = [];
    const userDists: (number | null)[] = [];

    for (const row of rows) {
      const entered = row.distance && Number(row.distance) > 0 ? Math.min(Number(row.distance), 100) : null;
      const dist = entered ?? DEFAULT_SEG;
      dists.push(dist);
      userDists.push(entered);
      x += dist * Math.cos(dir);
      y += dist * Math.sin(dir);
      pts.push({ x, y });
      // "Angle" is the deflection of the next segment from the current heading
      // (a 45° bend tilts the line 45°). UP tilts upward, DOWN tilts downward
      // (screen y is downward, so DOWN adds to the heading and UP subtracts).
      const angle = (row.useCustom ? Number(row.customAngle) || 90 : Number(row.angle)) || 45;
      const turn = (angle * Math.PI) / 180;
      dir += row.direction === 'down' ? turn : -turn;
    }

    dists.push(trailing);
    userDists.push(trailingLabel);
    x += trailing * Math.cos(dir);
    y += trailing * Math.sin(dir);
    pts.push({ x, y });

    return { pts, dists, userDists };
  }

  private static bbox(pts: { x: number; y: number }[]) {
    const xs = pts.map(p => p.x), ys = pts.map(p => p.y);
    return {
      minX: Math.min(...xs), maxX: Math.max(...xs),
      minY: Math.min(...ys), maxY: Math.max(...ys),
    };
  }

  get bendSVGData(): {
    path: string;
    flatPath: string;
    bendPoints: { x: number; y: number; label: string; tag: string; key: number; dir: string; angle: number | string; lx: number; ly: number; anchor: string }[];
    segLabels: { x: number; y: number; dist: string }[];
    flatSegLabels: { x: number; y: number; dist: string }[];
    flatBendPoints: { x: number; y: number; ly: number; label: string; tag: string; key: number; dir: string; angle: number | string }[];
    coverPath: string | null;
    coverBendPoints: { x: number; y: number; label: string; tag: string; key: number; dir: string; angle: number | string; lx: number; ly: number; anchor: string }[];
    coverSegLabels: { x: number; y: number; dist: string }[];
    flatCoverPath: string | null;
    flatCoverBendPoints: { x: number; y: number; ly: number; label: string; tag: string; key: number; dir: string; angle: number | string }[];
    flatCoverSegLabels: { x: number; y: number; dist: string }[];
    shapeLabels: { text: string; tx: number; ty: number; x1: number; x2: number; y: number }[];
    flatShapeLabels: { text: string; x: number; y: number }[];
    hasCover: boolean;
    viewBox: string;
    height: number;
    flatViewBox: string;
    flatHeight: number;
  } | null {
    // Only draw rows that are actually configured (direction + angle chosen) — an
    // empty/half-filled row shouldn't render a phantom bend in the preview.
    const rows = (this.activeBend?.bendRows || []).filter((r: any) => this.isBendRowComplete(r));
    if (!rows.length) return null;

    const DEFAULT_SEG = 80;

    // ── CHANNEL (the piece itself) ──
    // U/J/L and the Channel Raceway are drawn standing up, so their first line runs
    // downward; the flat profiles (Z, Molding, Siding) start running to the right.
    const uprightPreset = ['U', 'J', 'L', 'ChannelRaceway'].includes(this.activeBend?.bendPreset);

    // Trailing flange: the leftover of the CUT PIECE length after the typed
    // segments (so all N+1 segments sum to the piece length, e.g. a 24" cut, not
    // the full product). The drawn length is capped like the rows; the label shows
    // the true remainder. Without a known length, mirror the last entered distance.
    const total = this.bendDistributableLength();
    let trailing: number, trailingLabel: number | null;
    const stated = this.endFlange;
    if (stated != null && stated > 0) {
      // The profile states its closing line, so draw that rather than the leftover.
      trailing = Math.min(stated, 100);
      trailingLabel = this.roundLen(stated);
    } else if (total != null && total > 0) {
      const sumRows = rows.reduce(
        (a: number, r: any) => a + (Number(r.distance) > 0 ? Number(r.distance) : 0), 0);
      const rem = Math.max(0, total - sumRows);
      trailing = Math.min(rem, 100);
      trailingLabel = Math.round(rem * 100) / 100;
    } else {
      const lastEntered = rows.map((r: any) => Number(r.distance) > 0 ? Number(r.distance) : null)
        .reverse().find((d: number | null) => d != null) ?? null;
      trailing = lastEntered ?? DEFAULT_SEG;
      trailingLabel = lastEntered;
    }

    const chan = this.traceBendOutline(rows, uprightPreset ? Math.PI / 2 : 0, trailing, trailingLabel);

    // ── COVER (its own outline above the channel, per Figma 14857-282542) ──
    const coverRows = this.showCoverSection
      ? this.coverBendRows.filter((r: any) => this.isBendRowComplete(r))
      : [];
    let cover: { pts: { x: number; y: number }[]; dists: number[]; userDists: (number | null)[] } | null = null;
    if (coverRows.length) {
      const cStated = this.coverEndFlange;
      const cLast = coverRows.map((r: any) => Number(r.distance) > 0 ? Number(r.distance) : null)
        .reverse().find((d: number | null) => d != null) ?? null;
      const cTrail = cStated != null && cStated > 0 ? cStated : (cLast ?? DEFAULT_SEG);
      const cLabel = cStated != null && cStated > 0 ? this.roundLen(cStated) : cLast;
      // The cover caps the channel, so it starts running UPWARD — its two same-way
      // bends then turn the legs back down into the channel's lips.
      cover = this.traceBendOutline(coverRows, -Math.PI / 2, Math.min(cTrail, 100), cLabel);
    }

    // Stack the cover above the channel, centred on it, at the SAME scale so a 3"
    // cover reads narrower than the 5" channel it caps.
    let coverPts = cover?.pts ?? null;
    const cb = HeaderComponent.bbox(chan.pts);
    if (coverPts) {
      const vb = HeaderComponent.bbox(coverPts);
      const gap = Math.max(1, 0.22 * (cb.maxY - cb.minY));
      const dx = (cb.minX + cb.maxX) / 2 - (vb.minX + vb.maxX) / 2;
      const dy = cb.minY - gap - vb.maxY;
      coverPts = coverPts.map(p => ({ x: p.x + dx, y: p.y + dy }));
    }

    const hasCover = !!coverPts;
    const g = HeaderComponent.bbox(hasCover ? chan.pts.concat(coverPts!) : chan.pts);
    const rangeX = g.maxX - g.minX || 1, rangeY = g.maxY - g.minY || 1;

    // Fit the composite, then let the CANVAS grow to it. The viewBox is 600 units
    // wide — roughly its rendered width — so one unit is about one pixel and the
    // label font sizes stay in the same proportion to the drawing that Figma uses
    // (node 15099-280909: a 180-wide outline on a 600-wide canvas, 16px labels).
    // Only the height is variable: a tall profile like the Channel Raceway gets a
    // tall box (~440) rather than being crushed into the short one a flat Z needs.
    const VB_W = 600;
    const MARGIN_Y = 70;                  // headroom for the bend labels above/below
    const MAX_DRAW_W = 180, MAX_DRAW_H = 380;
    const MIN_VB_H = 236, MAX_VB_H = MAX_DRAW_H + 2 * MARGIN_Y;
    const scale = Math.min(MAX_DRAW_W / rangeX, MAX_DRAW_H / rangeY);
    const drawnW = rangeX * scale, drawnH = rangeY * scale;
    const VB_H = Math.min(MAX_VB_H, Math.max(MIN_VB_H, Math.round(drawnH + 2 * MARGIN_Y)));
    const offsetX = (VB_W - drawnW) / 2, offsetY = (VB_H - drawnH) / 2;
    const place = (pts: { x: number; y: number }[]) =>
      pts.map(p => ({ x: (p.x - g.minX) * scale + offsetX, y: (p.y - g.minY) * scale + offsetY }));

    const toPath = (pts: { x: number; y: number }[]) =>
      pts.map((p, i) => `${i === 0 ? 'M' : 'L'}${p.x.toFixed(1)},${p.y.toFixed(1)}`).join(' ');

    const mkBendPoints = (src: any[], norm: { x: number; y: number }[], keyOffset: number) =>
      src.map((row: any, i: number) => {
        const pt = norm[i + 1];
        const prev = norm[i];
        const next = norm[i + 2] || pt;
        // Place the label on the OUTSIDE of the bend — the direction opposite the
        // two adjacent segments — so it never sits on top of the lines.
        const aLen = Math.hypot(prev.x - pt.x, prev.y - pt.y) || 1;
        const bLen = Math.hypot(next.x - pt.x, next.y - pt.y) || 1;
        let ox = -((prev.x - pt.x) / aLen + (next.x - pt.x) / bLen);
        let oy = -((prev.y - pt.y) / aLen + (next.y - pt.y) / bLen);
        const oLen = Math.hypot(ox, oy);
        if (oLen < 0.001) { ox = 0; oy = -1; } else { ox /= oLen; oy /= oLen; }
        const off = 24;
        return {
          x: pt.x, y: pt.y,
          label: `Bend ${i + 1}`,
          tag: `B${i + 1}`,
          key: keyOffset + i,
          dir: row.direction,
          angle: row.useCustom ? (row.customAngle ?? '?') : row.angle,
          lx: pt.x + ox * off,
          ly: pt.y + oy * off,
          anchor: ox > 0.3 ? 'start' : (ox < -0.3 ? 'end' : 'middle')
        };
      });

    // Everything written on the canvas is placed against one growing list of taken
    // boxes, so a dimension never lands on another dimension or under a bend label.
    type Box = { x1: number; x2: number; y1: number; y2: number };
    const taken: Box[] = [];
    const free = (b: Box) => !taken.some(q => b.x1 < q.x2 && b.x2 > q.x1 && b.y1 < q.y2 && b.y2 > q.y1);

    // Dimensions stay UPRIGHT and sit just off the line. Figma (15099-280917) keeps
    // every one of them horizontal — including those beside the vertical walls — and
    // rotating them with the segment printed the raceway's 1" lip measurements
    // straight onto the strokes. Preferred side is away from the middle of the shape,
    // but on a tight corner (a 1" lip next to its 1" return) that puts two of them on
    // top of each other, so fall back to the inner side and then to a wider offset.
    const DIM_HW = 20;
    const mkSegLabels = (norm: { x: number; y: number }[], userDists: (number | null)[]) => {
      const b = HeaderComponent.bbox(norm);
      const cx = (b.minX + b.maxX) / 2, cy = (b.minY + b.maxY) / 2;
      return norm.slice(0, -1).map((p, i) => {
        const next = norm[i + 1];
        const mx = (p.x + next.x) / 2;
        const my = (p.y + next.y) / 2;
        let px = -(next.y - p.y), py = next.x - p.x;
        const len = Math.hypot(px, py) || 1;
        px /= len; py /= len;
        if (px * (mx - cx) + py * (my - cy) < 0) { px = -px; py = -py; }

        // How far to clear the stroke depends on which way the text runs into it: a
        // vertical segment is cleared sideways, so it has to clear HALF THE TEXT
        // WIDTH, not a token few pixels (a flat offset printed "9.6 IN" across the
        // wall it measures). A horizontal one only has to clear the text's height.
        const base = Math.abs(px) * (DIM_HW + 6) + Math.abs(py) * 13;
        const ud = userDists[i];
        const dist = ud != null ? `${ud} IN` : '';
        const at = (off: number) => ({ x: mx + px * off, y: my + py * off + 4 });
        const boxAt = (q: { x: number; y: number }) =>
          ({ x1: q.x - DIM_HW, x2: q.x + DIM_HW, y1: q.y - 11, y2: q.y + 3 });

        let pos = at(base);
        if (dist) {
          for (const off of [base, -base, base + 14, -(base + 14), base + 28, -(base + 28)]) {
            const cand = at(off);
            if (free(boxAt(cand))) { pos = cand; break; }
          }
          taken.push(boxAt(pos));
        }
        return { x: pos.x, y: pos.y, dist };
      });
    };

    const chanNorm = place(chan.pts);
    const coverNorm = coverPts ? place(coverPts) : null;

    const segLabels = mkSegLabels(chanNorm, chan.userDists);
    const coverSegLabels = coverNorm ? mkSegLabels(coverNorm, cover!.userDists) : [];
    const bendPoints = mkBendPoints(rows, chanNorm, 0);
    const coverBendPoints = coverNorm ? mkBendPoints(coverRows, coverNorm, rows.length) : [];

    // Each label is pushed to the OUTSIDE of its bend, but on a tight profile that
    // can aim two of them at each other — the raceway's two lips face inward across
    // a 3" gap, so "Bend 1" and "Bend 6" landed on top of one another. Drop any
    // label that still overlaps an already-placed one onto the next line down.
    const LABEL_W = 58, LABEL_H = 34;
    const labelBox = (p: { lx: number; ly: number; anchor: string }): Box => {
      const left = p.anchor === 'end' ? p.lx - LABEL_W : (p.anchor === 'middle' ? p.lx - LABEL_W / 2 : p.lx);
      return { x1: left, x2: left + LABEL_W, y1: p.ly - 13, y2: p.ly + 21 };
    };
    for (const pt of [...bendPoints, ...coverBendPoints]) {
      let box = labelBox(pt);
      if (!free(box)) {
        // Centre it over its own dot instead of leaning inward — that is how Figma
        // separates the raceway's two lip labels, and it keeps each one next to the
        // bend it names rather than pushing it off into the opening.
        pt.anchor = 'middle';
        pt.lx = pt.x;
        box = labelBox(pt);
      }
      for (let guard = 0; guard < 3 && !free(box); guard++) {
        pt.ly += LABEL_H;
        box = labelBox(pt);
      }
      taken.push(box);
    }

    // Leader labels — only worth drawing when there are two outlines to tell apart.
    const leader = (text: string, norm: { x: number; y: number }[]) => {
      const b = HeaderComponent.bbox(norm);
      const y = b.minY + (b.maxY - b.minY) * 0.7;
      return { text, tx: b.minX - 78, ty: y + 3.5, x1: b.minX - 70, x2: b.minX, y };
    };
    const shapeLabels = coverNorm
      ? [leader('COVER', coverNorm), leader((this.selectedBendProfile || 'Piece').toUpperCase(), chanNorm)]
      : [];

    // ── FLAT PATHS (unfolded, all segments horizontal) ──
    // Unfolded, the strips are wide and short, so the flat view keeps its own canvas
    // rather than inheriting the formed view's height.
    const FLAT_VB_H = hasCover ? 340 : 210;
    const chanSum = chan.dists.reduce((a, b) => a + b, 0);
    const coverSum = cover ? cover.dists.reduce((a, b) => a + b, 0) : 0;
    const flatScale = 420 / Math.max(chanSum, coverSum, 1);
    const mkFlat = (dists: number[], centerY: number) => {
      const sum = dists.reduce((a, b) => a + b, 0);
      let fx = (VB_W - sum * flatScale) / 2;
      const pts = [{ x: fx, y: centerY }];
      for (const d of dists) { fx += d * flatScale; pts.push({ x: fx, y: centerY }); }
      return pts;
    };
    const mkFlatBendPoints = (src: any[], pts: { x: number; y: number }[], keyOffset: number) =>
      src.map((row: any, i: number) => ({
        x: pts[i + 1].x, y: pts[i + 1].y, ly: pts[i + 1].y + 20,
        label: `Bend ${i + 1}`,
        tag: `B${i + 1}`,
        key: keyOffset + i,
        dir: row.direction,
        angle: row.useCustom ? (row.customAngle ?? '?') : row.angle
      }));
    const mkFlatSegLabels = (pts: { x: number; y: number }[], userDists: (number | null)[], centerY: number) =>
      pts.slice(0, -1).map((p, i) => ({
        x: (p.x + pts[i + 1].x) / 2,
        y: centerY - 12,
        dist: userDists[i] != null ? `${userDists[i]}"` : ''
      }));

    const chanFlatY = hasCover ? 95 : 100;
    const coverFlatY = 250;
    const chanFlat = mkFlat(chan.dists, chanFlatY);
    const coverFlat = cover ? mkFlat(cover.dists, coverFlatY) : null;

    const flatBendPoints = mkFlatBendPoints(rows, chanFlat, 0);
    const flatCoverBendPoints = coverFlat ? mkFlatBendPoints(coverRows, coverFlat, rows.length) : [];
    const flatPlaced: { x1: number; x2: number; y1: number; y2: number }[] = [];
    for (const pt of [...flatBendPoints, ...flatCoverBendPoints]) {
      const box = () => ({ x1: pt.x - LABEL_W / 2, x2: pt.x + LABEL_W / 2, y1: pt.ly - 13, y2: pt.ly + 21 });
      let b = box();
      for (let guard = 0; guard < 3; guard++) {
        const hit = flatPlaced.some(q => b.x1 < q.x2 && b.x2 > q.x1 && b.y1 < q.y2 && b.y2 > q.y1);
        if (!hit) break;
        pt.ly += LABEL_H;
        b = box();
      }
      flatPlaced.push(b);
    }

    const flatShapeLabels = coverFlat
      ? [
        { text: (this.selectedBendProfile || 'Piece').toUpperCase(), x: chanFlat[0].x, y: chanFlatY - 30 },
        { text: 'COVER', x: coverFlat[0].x, y: coverFlatY - 30 },
      ]
      : [];

    return {
      path: toPath(chanNorm),
      flatPath: toPath(chanFlat),
      bendPoints,
      segLabels,
      flatBendPoints,
      flatSegLabels: mkFlatSegLabels(chanFlat, chan.userDists, chanFlatY),
      coverPath: coverNorm ? toPath(coverNorm) : null,
      coverBendPoints,
      coverSegLabels,
      flatCoverPath: coverFlat ? toPath(coverFlat) : null,
      flatCoverBendPoints,
      flatCoverSegLabels: coverFlat ? mkFlatSegLabels(coverFlat, cover!.userDists, coverFlatY) : [],
      shapeLabels,
      flatShapeLabels,
      hasCover,
      viewBox: `0 0 ${VB_W} ${VB_H}`,
      height: VB_H,
      flatViewBox: `0 0 ${VB_W} ${FLAT_VB_H}`,
      flatHeight: FLAT_VB_H,
    };
  }

  applyBendPreset(shape: string) {
    const t = this.activeBend;
    if (!t) return;
    t.bendPreset = shape as 'Z' | 'U' | 'J' | 'L' | 'Siding' | 'Molding' | 'ChannelRaceway';

    // The preset rows carry the shape's direction/angle; their distances come from
    // the shape recipe applied to the CUT PIECE length (presetBendSegments).
    const mk = (direction: string, angle: number, useCustom = false) =>
      ({ distance: null as number | null, direction, angle, useCustom, customAngle: useCustom ? angle : null, userSet: false });
    const presets: Record<string, any[]> = {
      // Z = the slanted letter-Z: 135° bends, opposite directions, with a LONGER
      // middle segment (see BEND_PRESET_FRACTIONS) and shorter end flanges.
      Z: [mk('down', 135, true), mk('up', 135, true)],
      // U = channel: two 90° bends the SAME way (down, down).
      U: [mk('down', 90), mk('down', 90)],
      J: [mk('down', 90), mk('down', 90)],
      L: [mk('up',   90)],
      Siding: [mk('down', 90), mk('down', 90)],
      Molding: [mk('down', 90), mk('down', 90)],
      // A sized Channel Raceway is six bends (lips + walls + face), not two — the
      // row COUNT has to come from the size here, otherwise applyCommonSizeSegments
      // sees too few rows and bounces straight back into applyBendPreset.
      ChannelRaceway: (HeaderComponent.COMMON_SIZE_DIRECTIONS[this.racewaySize || ''] ??
        ['down', 'down']).map(d => mk(d, 90)),
    };
    t.bendRows = presets[shape] ? presets[shape].map(r => ({ ...r })) : [];
    this.endFlange = null;

    if (shape === 'Siding' && this.sidingSides !== 2) t.bendRows.length = 1;

    // Place each bend by the recipe (fractions of the cut piece length, or fixed
    // segments). The rows are marked userSet so they stay put if the user later edits
    // or adds a bend; a pure preset is re-derived on size change in syncBendingPieces().
    const segs = this.presetBendSegments(shape, this.bendDistributableLength() ?? 0);
    t.bendRows.forEach((r: any, i: number) => {
      if (segs[i] != null) { r.distance = segs[i]; r.userSet = true; }
    });

    this.applyCommonSizeSegments();

    // Picking a shape forms bends → switch the preview to the FORMED view.
    if (t.bendRows.length) {
      this.bendViewMode = 'formed';
      // Fill any rows the recipe didn't set (unknown length) evenly.
      this.redistributeBendLengths();
    }
  }

  toggleGroupService(group: any, service: any, confirmed = false) {
    // Groups flow: only one group may hold a pending selection at a time. Ignore
    // attempts to select a service in a different group until the active one is
    // configured.
    if (this.isGroupServiceLocked(group)) return;
    if (!this.groupSelectedServices[group.id]) {
      this.groupSelectedServices[group.id] = [];
    }
    const selected = this.groupSelectedServices[group.id];
    const idx = selected.findIndex((s: any) => s.name === service.name);
    if (idx === -1) {
      // Adding Cutting on top of already-configured Bending: confirm first, since
      // the new cut structure invalidates those bends.
      if (!confirmed && service.name === 'Cutting' && this.groupBendingWithBends(group)) {
        this.askServiceConfirm({
          title: 'Cutting Requires Bend Updates',
          message: 'Bends are applied to pieces created through cutting. Adding cutting changes the structure of the material, so existing bend configurations will need to be reconfigured.',
          affected: ['Bending'],
          cancelLabel: 'CANCEL',
          confirmLabel: 'ADD CUTTING',
          onConfirm: () => this.toggleGroupService(group, service, true),
        });
        return;
      }
      selected.push(service);
    } else {
      selected.splice(idx, 1);
    }
  }

  isGroupServiceSelected(groupId: number, serviceName: string): boolean {
    return !!(this.groupSelectedServices[groupId]?.some((s: any) => s.name === serviceName));
  }

  /** Groups flow only: id of the group that currently has a pending (selected but
   *  not-yet-configured) service, or null. Only one group may be actively
   *  selecting services at a time. */
  get activeServiceGroupId(): number | null {
    if (this.serviceFlow !== 'groups') return null;
    const active = this.serviceGroups.find(g =>
      (this.groupSelectedServices[g.id] || []).some(
        (s: any) => !this.hasConfigsForService(g, s.name)
      )
    );
    return active ? active.id : null;
  }

  /** True when this group's service selection must be locked because another
   *  group already has a pending selection being configured. */
  isGroupServiceLocked(group: any): boolean {
    const activeId = this.activeServiceGroupId;
    return activeId !== null && activeId !== group.id;
  }

  hasAnyGroupServiceSelected(): boolean {
    return Object.values(this.groupSelectedServices).some((services: any[]) => services.length > 0);
  }

  /** Any group has a selected service that hasn't been configured yet. */
  hasUnconfiguredSelectedServices(): boolean {
    return this.serviceGroups.some(g =>
      (this.groupSelectedServices[g.id] || []).some((s: any) => !this.hasConfigsForService(g, s.name))
    );
  }

  /** Show the "Add to cart with services" CTA: something is configured and nothing selected is still pending. */
  get canAddToCartWithServices(): boolean {
    return this.hasSavedServices && !this.hasUnconfiguredSelectedServices();
  }

  hasConfigsForService(group: any, serviceName: string): boolean {
    return (group.configs || []).some((c: any) => c.name === serviceName);
  }

  /** Contextual note under the service picker explaining how Bending relates to Cutting.
   *  Only shown when the product offers both services and Bending is part of the plan:
   *   - Cutting also planned  -> bends follow the cut pieces (define cuts first).
   *   - Cutting not planned    -> bends fall back to the full sheet (configure cutting first). */
  private bendContextNote(
    offersCutting: boolean,
    offersBending: boolean,
    cuttingPlanned: boolean,
    bendingPlanned: boolean
  ): string | null {
    if (!offersCutting || !offersBending || !bendingPlanned) return null;
    return cuttingPlanned
      ? "Bends are applied to pieces created during cutting. You'll define cuts first, then configure bend per pieces."
      : 'Bends are currently being applied to the full sheet. To apply bends to specific cut pieces, configure cutting first.';
  }

  /** Bend-context note for the group-based flows (together / groups / separately).
   *  Only shown while the user is first selecting Bending — once Bending has been
   *  configured/saved for the group the note is hidden (it's already been read). */
  groupBendNote(group: any): string | null {
    // Hide once Bending is saved; the hint only matters during initial selection.
    if (this.hasConfigsForService(group, 'Bending')) return null;

    const services = this.getFilteredServicesForConfig(group?.unitRef || this.selectedProductForNewConfig) || [];
    const offersCutting = services.some((s: any) => s.name === 'Cutting');
    const offersBending = services.some((s: any) => s.name === 'Bending');
    const cutting = this.isGroupServiceSelected(group.id, 'Cutting') || this.hasConfigsForService(group, 'Cutting');
    const bending = this.isGroupServiceSelected(group.id, 'Bending');
    return this.bendContextNote(offersCutting, offersBending, cutting, bending);
  }

  /** Bend-context note for the "Editing Services" variant drawer.
   *  Only shown while the user is first selecting Bending — once Bending is already
   *  saved on the variant the note is hidden (it's already been read). */
  editVariantBendNote(): string | null {
    const services = this.getFilteredServicesForConfig(this.selectedProductForNewConfig) || [];
    const cuttingSvc = services.find((s: any) => s.name === 'Cutting');
    const bendingSvc = services.find((s: any) => s.name === 'Bending');
    // Hide once Bending is saved on the variant; the hint only matters during selection.
    if (bendingSvc && !!this.getVariantOptionForService(this.editingVariant, bendingSvc)) return null;
    const cutting = !!cuttingSvc &&
      (this.isEditVariantServiceSelected(cuttingSvc) || !!this.getVariantOptionForService(this.editingVariant, cuttingSvc));
    const bending = !!bendingSvc && this.isEditVariantServiceSelected(bendingSvc);
    return this.bendContextNote(!!cuttingSvc, !!bendingSvc, cutting, bending);
  }

  getConfigsWithIndexForService(group: any, serviceName: string): { config: any; idx: number }[] {
    return (group.configs || [])
      .map((config: any, idx: number) => ({ config, idx }))
      .filter(({ config }: { config: any }) => config.name === serviceName);
  }

  configureGroupServices() {
    for (const group of this.serviceGroups) {
      // Only configure services that are selected AND not yet configured.
      // A selection stays in groupSelectedServices after it's saved, so without this
      // filter selecting Bending after Cutting would re-run Cutting + Bending together.
      // Now: only Cutting → Cutting wizard, only Bending → Bending wizard,
      // both ticked fresh → combined Cutting + Bending wizard.
      const selected = (this.groupSelectedServices[group.id] || [])
        .filter((s: any) => !this.hasConfigsForService(group, s.name));
      if (selected.length > 0) {
        this.startConfigureWizard(
          selected,
          group.unitRef || this.selectedProductForNewConfig,
          group.qty,
          group.id
        );
        return;
      }
    }
  }

  onClickConfigure(service: any) {
    this.selectedService = service;

    // In split mode, the base quantity is the number of selected items
    let baseQty = 1;
    if (this.splitItemsIndividually && this.isConfiguringSplit) {
      baseQty = this.selectedSplitIndices.size;
    } else {
      baseQty = this.selectedProductForNewConfig?.cartQty || 1;
    }

    this.draftConfig = {
      name: this.selectedService.name,
      qty: baseQty,
      piecesQty: baseQty,
      internalQty: 1,
      measurements: [{ width: null, length: null, qty: 1 }],
      uploadedFile: null,
      editIndex: -1,
      width: 1,
      length: 1,
      isSaved: false,
      productOptionType: this.selectedService.productOptionType,
      minimumServiceFee: this.selectedService.minimumServiceFee,
      includedQtyInMinimumFee: this.selectedService.includedQtyInMinimumFee,
      eachAdditionalPrice: this.selectedService.eachAdditionalPrice,
    };

    this.addNewConfig = true;
  }

  calculateTotal(config: any) {
    if (!config) return 0;

    // Sum up internalQty from all measurements
    const totalInternalQty = config.measurements?.reduce((sum: number, m: any) => sum + (m.qty || 0), 0) || config.internalQty || 1;

    let total = 0;
    if (totalInternalQty > config.includedQtyInMinimumFee) {
      total = config.minimumServiceFee + (totalInternalQty - config.includedQtyInMinimumFee) * config.eachAdditionalPrice;
    } else {
      total = config.minimumServiceFee;
    }
    return total;
  }

  /** Read the product's "Length" spec and normalize to inches.
   *  Unit notation: (') = feet → ×12; (") or ('') = inches → as-is; no unit → assumed inches.
   *  Also handles combined feet+inches like 8'6". Null if absent/unparseable. */
  getProductLengthInInches(): number | null {
    return productAttrInches(this.selectedProductForNewConfig, 'length');
  }

  getProductWidthInInches(): number | null {
    return productAttrInches(this.selectedProductForNewConfig, 'width');
  }

  addMeasurement() {
    if (this.draftConfig) {
      // New cut/slit rows default to qty 1, matching the first row.
      this.draftConfig.measurements.push({ width: null, length: null, qty: 1 });
    }
  }

  removeMeasurement(index: number, confirmed = false) {
    if (!(this.draftConfig && this.draftConfig.measurements.length >= 1)) return;

    // Removing any cut piece now drops ALL bending (bends are reconfigured per the new
    // pieces after saving), so confirm whenever the linked bending carries bends — not
    // only when THIS piece does — otherwise other pieces' bends would be lost silently.
    if (!confirmed && (this.draftConfig?.name || '').toLowerCase() === 'cutting'
        && this.hasAnyBends(this.bendingForCuttingDraft())) {
      this.askServiceConfirm({
        title: 'Remove Cut Piece?',
        message: 'Removing this cut piece removes all configured bend settings, which you\'ll need to reconfigure after saving.',
        affected: ['Cutting', 'Bending'],
        cancelLabel: 'CANCEL',
        confirmLabel: 'REMOVE PIECE',
        onConfirm: () => this.removeMeasurement(index, true),
      });
      return;
    }

    this.draftConfig.measurements.splice(index, 1);
    // A cut-piece removal drops all bending on save; the "Remove Cut Piece?" prompt above
    // already warned, so flag it to skip the redundant save-time "Bend Configuration Needs
    // Updating" confirm in saveService / saveEditServiceConfig.
    this.draftConfig.__cutRemoved = true;
  }

  adjustMeasurement(index: number, field: string, amount: number) {
    if (this.draftConfig && this.draftConfig.measurements[index]) {
      const m = this.draftConfig.measurements[index];
      m[field] = Math.max(1, (m[field] || 0) + amount);
    }
  }

  // ── Width / Length inputs: inches, decimals + fractions (e.g. 60, 36.5, 1/2, 5 1/2) ──

  /** Parse a numeric / decimal / fraction string into a number. Returns null if invalid. */
  parseMeasurementValue(raw: any): number | null {
    if (raw === null || raw === undefined) return null;
    const s = String(raw).trim();
    if (s === '') return null;
    let m: RegExpMatchArray | null;
    // Mixed fraction: "5 1/2"
    if ((m = s.match(/^(\d+)\s+(\d+)\/(\d+)$/))) {
      const den = +m[3];
      if (!den) return null;
      return +m[1] + (+m[2]) / den;
    }
    // Simple fraction: "1/2"
    if ((m = s.match(/^(\d+)\/(\d+)$/))) {
      const den = +m[2];
      if (!den) return null;
      return (+m[1]) / den;
    }
    // Decimal / integer: "60", "36.5", ".5"
    if (/^(\d+(\.\d+)?|\.\d+)$/.test(s)) {
      const n = parseFloat(s);
      return isNaN(n) ? null : n;
    }
    return null;
  }

  /** Round to 3 decimals and stringify (used for display normalization). */
  formatMeasurement(n: number): string {
    if (n === null || n === undefined || isNaN(n)) return '';
    return String(Math.round(n * 1000) / 1000);
  }

  /** Text shown in the input: the raw string while editing, else the stored number. */
  getMeasurementDisplay(m: any, field: 'width' | 'length'): string {
    const key = field + 'Display';
    if (m[key] !== undefined && m[key] !== null) return m[key];
    return m[field] != null ? String(m[field]) : '';
  }

  /** On each keystroke: remember the raw text and update the numeric value if it parses. */
  onMeasurementInput(event: Event, m: any, field: 'width' | 'length') {
    const raw = (event.target as HTMLInputElement).value;
    m[field + 'Display'] = raw;
    const val = this.parseMeasurementValue(raw);
    if (val !== null) m[field] = val;
  }

  /** On blur: commit a valid value, or revert to the last good number. Keeps fraction text as typed. */
  onMeasurementBlur(m: any, field: 'width' | 'length') {
    const val = this.parseMeasurementValue(m[field + 'Display']);
    if (val === null || val <= 0) {
      m[field] = (m[field] && m[field] > 0) ? m[field] : 1;
      m[field + 'Display'] = this.formatMeasurement(m[field]);
    } else {
      m[field] = val;
      const typed = (m[field + 'Display'] ?? '').toString().trim();
      m[field + 'Display'] = typed || this.formatMeasurement(val);
    }
  }

  /** Arrow keys step by 1; block any non numeric/fraction characters. */
  onMeasurementKeydown(event: KeyboardEvent, m: any, field: 'width' | 'length') {
    if (event.key === 'ArrowUp' || event.key === 'ArrowDown') {
      event.preventDefault();
      const cur = this.parseMeasurementValue(m[field + 'Display']) ?? Number(m[field]) ?? 0;
      let next = cur + (event.key === 'ArrowUp' ? 1 : -1);
      if (next < 0) next = 0;
      m[field] = next;
      m[field + 'Display'] = this.formatMeasurement(next);
      return;
    }
    if (event.ctrlKey || event.metaKey) return;
    const nav = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab', 'Home', 'End', 'Enter'];
    if (nav.includes(event.key)) return;
    // Allow digits, dot, slash and space (for fractions); block everything else.
    if (!/^[0-9./ ]$/.test(event.key)) {
      event.preventDefault();
    }
  }

  get totalInternalQty(): number {
    return this.draftConfig?.measurements?.reduce((sum: number, m: any) => sum + (m.qty || 0), 0) || 0;
  }

  handleApplyToQtyPlus() {
    if (this.draftConfig) {
      this.draftConfig.qty++;
    }
  }

  handleApplyToQtyMinus() {
    if (this.draftConfig && this.draftConfig.qty > 1) {
      this.draftConfig.qty--;
      if (this.draftConfig.piecesQty > this.draftConfig.qty) {
        this.draftConfig.piecesQty = this.draftConfig.qty;
      }
    }
  }

  handlePiecesQtyPlus() {
    if (this.draftConfig && this.draftConfig.piecesQty < this.draftConfig.qty) {
      this.draftConfig.piecesQty++;
    }
  }

  handlePiecesQtyMinus() {
    if (this.draftConfig && this.draftConfig.piecesQty > 1) {
      this.draftConfig.piecesQty--;
    }
  }

  getPiecesQtyOptions(): number[] {
    if (!this.draftConfig || !this.draftConfig.qty) {
      return [1];
    }
    return Array.from({ length: this.draftConfig.qty }, (_, i) => i + 1);
  }

  togglePiecesQtyDropdown() {
    this.piecesQtyDropdownOpen = !this.piecesQtyDropdownOpen;
  }

  selectPiecesQty(value: number) {
    if (this.draftConfig) {
      this.draftConfig.piecesQty = value;
    }
    this.piecesQtyDropdownOpen = false;
  }

  onFileDropped(event: any) {
  }

  async onFileSelected(event: any, target?: any) {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files[0]) {
      const file = input.files[0];
      const formData = new FormData();
      formData.append('file', file);

      this.util.setLoder(true);
      try {
        let res = await this.api.uploadFile(formData);
        const targetObj = target || this.draftConfig;
        if (res && targetObj) {
          targetObj.uploadedFile = {
            name: res.fileName,
            url: res.fileURL
          };
          // Uploading a file while editing a cart variant is a change → enable
          // "Save Changes". The file itself stays on its own target (the variant's
          // general diagram, or the draftConfig's bending sketch) — don't conflate them.
          if (this.editingVariant && (targetObj === this.editingVariant || targetObj === this.draftConfig)) {
            this.editingVariant.servicesChanged = true;
            this.editingVariant.__servicesEditedSession = true;
          }
          this.util.showQuotesToast(`File uploaded successfully`, 'success', undefined);
        }
      } catch (err) {
        this.util.showQuotesToast('Failed to upload file', 'error', undefined);
      } finally {
        this.util.setLoder(false);
      }
    }
  }

  adjustValue(field: string, delta: number) {
    if (!this.draftConfig) return;
    const current = this.draftConfig[field] || 0;
    const newValue = current + delta;
    if (newValue >= 0) {
      this.draftConfig[field] = newValue;
    }
  }

  lastSavedConfigId: number | null = null;
  // Every config saved in the last action — so saving Cutting AND Bending together
  // shows the "Added" badge on BOTH, not just the last one.
  lastSavedConfigIds = new Set<any>();
  private highlightTimer: any;

  /** Flag one or more freshly-saved configs so their "Added" badge + highlight show. */
  private markJustSaved(ids: any[]) {
    const valid = ids.filter(id => id != null);
    this.lastSavedConfigIds = new Set(valid);
    this.lastSavedConfigId = valid.length ? valid[valid.length - 1] : null;
    if (this.highlightTimer) clearTimeout(this.highlightTimer);
    this.highlightTimer = setTimeout(() => {
      this.lastSavedConfigIds = new Set();
      this.lastSavedConfigId = null;
    }, 4000);
  }

  /** True while the given config's just-saved badge/highlight should be shown. */
  isJustSaved(configId: any): boolean {
    return this.lastSavedConfigIds.has(configId);
  }

  onContinueFromConfigure() {
    if (this.selectedService) {
      this.markJustSaved([this.draftConfig?.configId]);
      this.addNewConfig = false;
      this.selectedService = null;
    }
  }

  async saveService(confirmed = false) {
    if (!this.selectedService || this.isSavingService) return;

    // Editing an existing Cutting config re-derives the pieces bending sits on, so
    // confirm before applying when bends already exist. (Cart-variant edits save via
    // saveEditServiceConfig, which gates separately.)
    if (!confirmed && (this.draftConfig?.name || '').toLowerCase() === 'cutting'
        && this.draftConfig?.editIndex > -1 && this.contextBendingWithBends()
        && !this.draftConfig?.__cutRemoved) {
      this.askServiceConfirm({
        title: 'Bend Configuration Needs Updating',
        message: 'Changes to cutting affect the pieces available for bending. Existing bend configurations will be removed and will need to be reconfigured.',
        affected: ['Cutting', 'Bending'],
        cancelLabel: 'CANCEL',
        confirmLabel: 'UPDATE CUTTING',
        onConfirm: () => this.saveService(true),
      });
      return;
    }

    // Editing an existing Cutting that already carries bends invalidates the pieces
    // those bends sit on. Drop the dependent Bending entirely so the user re-adds it
    // against the new cuts. Removing a single cut piece (__cutRemoved) does the same —
    // its own "Remove Cut Piece?" prompt already warned, so __cutRemoved only skips the
    // duplicate save-time confirm above, it no longer spares the bending.
    const invalidatesBends =
      (this.draftConfig?.name || '').toLowerCase() === 'cutting'
      && this.draftConfig?.editIndex > -1
      && !!this.contextBendingWithBends();

    this.isSavingService = true;
    await new Promise(resolve => setTimeout(resolve, 2000));

    const targetConfig = {
      ...this.draftConfig,
      isSaved: true,
      configId: this.draftConfig.configId || Date.now(),
      bendPreset: this.bendPreset,
      totalAmount: this.calculateTotal(this.draftConfig)
    };
    // Session-only flag — must not persist onto the saved config, or the next edit of
    // this cutting would wrongly suppress the bend-update confirm.
    delete targetConfig.__cutRemoved;

    if (this.activeGroupId !== null) {
      const group = this.serviceGroups.find(g => g.id === this.activeGroupId);
      if (group) {
        if (!group.configs) group.configs = [];
        if (this.draftConfig.editIndex > -1) {
          group.configs[this.draftConfig.editIndex] = targetConfig;
        } else {
          group.configs.push(targetConfig);
        }
        if (invalidatesBends) {
          // Updated cutting → drop the bending so it's re-added per the new cuts,
          // and clear its tick so it shows as removed on the services page.
          this.removeBendingForCuttingUpdate(group.configs);
          this.clearGroupServiceSelection(group, 'Bending');
        } else {
          // Editing Cutting can add/remove pieces → keep the sibling Bending in sync.
          this.resyncBendingFromCutting(group.configs, targetConfig);
          // Bending configured against the full sheet (before cutting) is now invalid →
          // drop it so bends get re-added per cut piece.
          this.dropFullSheetBendingForCutting(group.configs, targetConfig);
        }
      }
    } else {
      if (!this.selectedService.configs) this.selectedService.configs = [];
      if (this.draftConfig.editIndex > -1) {
        this.selectedService.configs[this.draftConfig.editIndex] = targetConfig;
      } else {
        this.selectedService.configs.push(targetConfig);
      }
      // Non-group flow: Bending lives on its own service entry.
      const bendingSvc = this.services.find((s: any) => (s.name || '').toLowerCase() === 'bending');
      if (invalidatesBends) {
        // Updated cutting → drop the bending so it's re-added per the new cuts.
        if (bendingSvc) this.removeBendingForCuttingUpdate(bendingSvc.configs);
      } else {
        this.resyncBendingFromCutting([targetConfig, ...(bendingSvc?.configs || [])], targetConfig);
        // Drop any full-sheet bending now that cutting defines the pieces.
        if (bendingSvc) this.dropFullSheetBendingForCutting(bendingSvc.configs, targetConfig);
      }
    }

    this.isSavingService = false;

    // Highlight the freshly-saved service when we land back on the list.
    this.markJustSaved([targetConfig.configId]);

    // Cart-edit: mirror the configured service into the variant's options so the
    // delete-and-re-add in saveVariantChanges sends the real, complete set. No-op on the
    // product-detail flow (no cartId) — saveVariantChanges itself is left untouched.
    this.syncConfigToVariantOptions(this.selectedService, targetConfig);

    if (this.cameFromVariantEdit) {
      // Editing a variant already in cart keeps the saved-cut summary view.
      this.addNewConfig = true;
      this.draftConfig = targetConfig;
      this.showSavedState = true;
      setTimeout(() => {
        this.showSavedState = false;
      }, 4000);
      return;
    }

    // All add-service flows (all units / groups / each unit separately): return to
    // the first "S&F Services" step with the saved service shown as an "Added" card.
    this.addNewConfig = false;
    this.isReviewStep = false;
    this.draftConfig = null;
    this.selectedService = null;
    this.wizardServices = [];
    this.wizardDrafts = {};
    this.wizardPieceSelection = {};
    this.activeGroupId = null;
  }


  onEditCut() {
    if (this.draftConfig) {
      this.draftConfig.isSaved = false;
    }
  }

  onRemoveCut(confirmed = false) {
    // Always confirm before removing a configured service from the edit screen.
    if (!confirmed) {
      const name = this.draftConfig?.name || this.getServiceName(this.draftConfig?.productOptionType) || 'service';
      // Removing a Cutting config invalidates any bends derived from it — stronger warning.
      if (name.toLowerCase() === 'cutting' && this.contextBendingWithBends()) {
        this.askServiceConfirm({
          title: 'Remove Cutting?',
          message: 'Bends are currently applied to pieces created through cutting. Removing cutting will also remove all configured bend settings.',
          affected: ['Cutting', 'Bending'],
          cancelLabel: 'KEEP SERVICES',
          confirmLabel: 'REMOVE SERVICES',
          onConfirm: () => this.onRemoveCut(true),
        });
      } else {
        this.askServiceConfirm({
          title: 'Remove configured service?',
          message: `This removes the configured ${name} service. You can add it again anytime.`,
          affected: [name],
          cancelLabel: 'KEEP SERVICE',
          confirmLabel: 'REMOVE SERVICE',
          onConfirm: () => this.onRemoveCut(true),
        });
      }
      return;
    }

    if (this.activeGroupId !== null) {
      const group = this.serviceGroups.find(g => g.id === this.activeGroupId);
      if (group && group.configs) {
        const index = group.configs.findIndex((c: any) => c === this.draftConfig);
        if (index > -1) {
          group.configs.splice(index, 1);
        }
      }
    } else if (this.selectedService && this.selectedService.configs) {
      const index = this.selectedService.configs.findIndex((c: any) => c === this.draftConfig);
      if (index > -1) {
        this.selectedService.configs.splice(index, 1);
      }
    }
    this.draftConfig = null;
    this.addNewConfig = false;
    this.activeGroupId = null;
  }

  addAnotherCut() {
    const baseQty = this.draftConfig?.qty || 1;
    this.draftConfig = {
      ...this.draftConfig,
      isSaved: false,
      editIndex: -1,
      width: 1,
      length: 1,
      internalQty: 1,
      uploadedFile: null,
      totalAmount: 0
    };
    this.calculateTotal(this.draftConfig);
    this.addNewConfig = true;
  }

  continueToMain() {
    this.addNewConfig = false;
    this.draftConfig = null;
    this.activeGroupId = null;
  }

  goBackFromConfigure() {
    if (this.draftConfig && !this.draftConfig.isSaved && this.isDraftDirty()) {
      this.discardType = 'config';
      this.showDiscardPopup = true;
      return;
    }
    this.draftConfig = null;
    this.addNewConfig = false;
    this.restoreVariantEditView();
  }

  getServiceAttribute(slug: string, key: any) {
    if (!this.selectedProductForNewConfig || !this.selectedProductForNewConfig.attributeSelector) {
      return '';
    }
    let data = this.selectedProductForNewConfig?.attributeSelector[key].find((item: any) => {
      return item.productSlug == slug
    })
    return data?.attributeValue
  }

  onFileRemove(target?: any) {
    const targetObj = target || this.draftConfig;
    if (targetObj) {
      targetObj.uploadedFile = null;
    }
    // Removing a file while editing a cart variant is a change → enable "Save Changes".
    if (this.editingVariant && (targetObj === this.editingVariant || targetObj === this.draftConfig)) {
      this.editingVariant.servicesChanged = true;
      this.editingVariant.__servicesEditedSession = true;
    }
  }

  closeMultipleVarientsPopup() {
    // Prompt to discard when there's something unsaved to lose:
    //  - saved pending services (product-detail "Add Services" flow),
    //  - a configure screen the user actually edited, or
    //  - a service add/edit/remove made in the "Editing Services" drawer but not yet
    //    persisted via "Update Services" / "Save Services".
    // An untouched configure screen (opened via "Edit" but not changed) still closes
    // without a prompt.
    const hasUnsavedDrawerEdits = !!this.editingVariant?.__servicesEditedSession;
    if (this.hasSavedServices
        || (this.addNewConfig && this.draftConfig && !this.draftConfig.isSaved && this.isDraftDirty())
        || hasUnsavedDrawerEdits) {
      this.discardType = 'modal';
      this.showDiscardPopup = true;
      return;
    }
    this.forceClosePopup();
  }

  /** Distinct names of all configured services (e.g. "Cutting & Bending"). */
  getConfiguredServiceNames(): string[] {
    const names = new Set<string>();
    this.serviceGroups.forEach((g: any) => (g.configs || []).forEach((c: any) => c?.name && names.add(c.name)));
    this.services.forEach((s: any) => (s.configs || []).length && s?.name && names.add(s.name));
    return Array.from(names);
  }

  /**
   * Product-detail "Add Services" mode: keep the configured services pending and hand a
   * summary back to the product page instead of adding to cart now. The drawer is only
   * hidden (state retained) so the product page can later commit / edit / remove them.
   */
  /** Drop the named services from the configured set (e.g. after a spec change made
   *  them incompatible), keep the rest, and re-emit the pending services for the
   *  current product. Called from the product page's "Remove services" action. */
  removeConfiguredServicesByName(names: string[], product?: any) {
    const lower = (names || []).map((n) => (n || '').toLowerCase());
    const keep = (configs: any[]) => (configs || []).filter((c: any) => !lower.includes((c?.name || '').toLowerCase()));
    (this.serviceGroups || []).forEach((g: any) => { if (g.configs) g.configs = keep(g.configs); });
    (this.services || []).forEach((s: any) => { if (s.configs) s.configs = keep(s.configs); });
    // Point the saved services at the current variant so the product page keeps them,
    // and refresh the captured product's options so the Edit drawer only offers the
    // services the NEW variant actually supports (e.g. drop Bending after a spec change).
    if (product?.urlSlug) this.syncPendingServiceProductSlug(product);
    if (product?.productOptionsDTO) {
      if (this.selectedProductForNewConfig) {
        this.selectedProductForNewConfig.productOptionsDTO = product.productOptionsDTO;
      }
      (this.serviceGroups || []).forEach((g: any) => {
        if (g.unitRef) {
          g.unitRef.productOptionsDTO = product.productOptionsDTO;
          if (g.unitRef.product) g.unitRef.product.productOptionsDTO = product.productOptionsDTO;
        }
      });
      this.filterServicesForNewConfig = this.getFilteredServicesForConfig(this.selectedProductForNewConfig);
    }
    const remaining = this.getConfiguredServiceNames();
    if (remaining.length) {
      this.util.emitSavedProductServices({
        product: this.selectedProductForNewConfig,
        serviceNames: remaining,
        serviceFee: this.getConfiguredServiceFee(),
      });
    } else {
      this.util.emitSavedProductServices(null);
    }
  }

  /** Sum of the configured service fees (drives the product-page price breakdown). */
  getConfiguredServiceFee(): number {
    let total = 0;
    this.serviceGroups.forEach((g: any) => (g.configs || []).forEach((c: any) => (total += this.calculateTotal(c))));
    this.services.forEach((s: any) => (s.configs || []).forEach((c: any) => (total += this.calculateTotal(c))));
    return total;
  }

  // ── Service-compatibility validation (runs on "Save Services") ──────────────
  // Validates Cutting / Slitting / Bending (NOT Punching) against the selected
  // product size + quantity, and prompts the user before committing the services.
  showServiceQtyPopup = false;        // Scenario 1: quantity adjustment
  showServiceSizePopup = false;       // Scenario 2: size adjustment (a fit exists)
  showServiceNoSizePopup = false;     // Scenario 3: no compatible size
  validationCurrentQty = 0;
  validationRequiredQty = 0;
  validationCurrentSize = '';
  validationSuggestedSize: { label: string; slug: string } | null = null;

  /** Service names that participate in compatibility validation (Punching excluded). */
  private readonly VALIDATED_SERVICE_NAMES = ['Cutting', 'Slitting', 'Bending'];

  /** All configured service configs across groups/services, limited to validated kinds. */
  private collectValidatedConfigs(): any[] {
    const all: any[] = [];
    (this.serviceGroups || []).forEach((g: any) => (g.configs || []).forEach((c: any) => all.push(c)));
    (this.services || []).forEach((s: any) => (s.configs || []).forEach((c: any) => all.push(c)));
    return all.filter((c: any) =>
      this.VALIDATED_SERVICE_NAMES.some((n) => (c?.name || '').toLowerCase() === n.toLowerCase())
    );
  }

  /** Pieces a single config requests (cut piece qtys, or bent piece count). */
  private configPieceQty(cfg: any): number {
    const name = (cfg?.name || '').toLowerCase();
    if (name.includes('bend')) {
      if (cfg.pieces?.length) return cfg.pieces.reduce((s: number, p: any) => s + (Number(p.qty) || 1), 0);
      return Number(cfg.internalQty) || Number(cfg.qty) || 1;
    }
    return (cfg.measurements || []).reduce((s: number, m: any) => s + (Number(m.qty) || 0), 0);
  }

  /**
   * Centralized, reusable compatibility check. Returns the first failing rule:
   *  - 'quantity'  → requested pieces exceed the selected unit quantity.
   *  - 'size'      → a requested cut exceeds the stock size, but a larger size fits.
   *  - 'no-size'   → a requested cut exceeds every available size.
   *  - 'ok'        → safe to commit.
   */
  validateServiceConfiguration():
    | { type: 'ok' }
    | { type: 'quantity'; current: number; required: number }
    | { type: 'size'; current: string; suggested: { label: string; slug: string } }
    | { type: 'no-size' } {
    const product = this.selectedProductForNewConfig;
    const configs = this.collectValidatedConfigs();
    if (!product || !configs.length) return { type: 'ok' };

    // Scenario 1 — quantity: total requested pieces vs available units.
    const currentQty = Number(product?.qty) || this.flattenedSplitItems.length || 1;
    const requiredQty = configs.reduce((s, c) => s + this.configPieceQty(c), 0);
    if (requiredQty > currentQty) {
      return { type: 'quantity', current: currentQty, required: requiredQty };
    }

    // Scenario 2/3 — size: a requested cut dimension exceeds the stock size.
    const stockW = productAttrInches(product, 'width');
    const stockL = productAttrInches(product, 'length');
    let maxW = 0, maxL = 0;
    configs.forEach((c) => {
      if ((c?.name || '').toLowerCase().includes('bend')) return;
      (c.measurements || []).forEach((m: any) => {
        maxW = Math.max(maxW, Number(m.width) || 0);
        maxL = Math.max(maxL, Number(m.length) || 0);
      });
    });
    const wExceeds = stockW != null && maxW > stockW + 1e-6;
    const lExceeds = stockL != null && maxL > stockL + 1e-6;
    if (wExceeds || lExceeds) {
      const suggested = this.findCompatibleSize(product, maxW, maxL);
      if (suggested) return { type: 'size', current: this.currentSizeLabel(product), suggested };
      return { type: 'no-size' };
    }
    return { type: 'ok' };
  }

  /** The product's currently-selected size label (Size / Length / Width attribute). */
  private currentSizeLabel(product: any): string {
    const sel = product?.attributeSelector || {};
    const key = Object.keys(sel).find((k) => /size|length|width/i.test(k));
    if (!key) return '';
    const cur = (sel[key] || []).find((o: any) => this.checkSlugs(product?.urlSlug, o.productSlug));
    return cur?.attributeValue || '';
  }

  /** Nearest larger size variant (from attributeSelector) whose dimension fits the cut. */
  private findCompatibleSize(product: any, maxW: number, maxL: number): { label: string; slug: string } | null {
    const sel = product?.attributeSelector || {};
    const keys = Object.keys(sel);
    const tryAttr = (key: string | undefined, need: number) => {
      if (!key || need <= 0) return null;
      const fitting = (sel[key] || [])
        .map((o: any) => ({ o, val: parseLengthToInches(o.attributeValue) }))
        .filter((x: any) => x.val != null && x.val >= need)
        .sort((a: any, b: any) => a.val - b.val);
      return fitting.length ? { label: fitting[0].o.attributeValue, slug: fitting[0].o.productSlug } : null;
    };
    const lengthKey = keys.find((k) => /length/i.test(k));
    const widthKey = keys.find((k) => /width/i.test(k));
    const sizeKey = keys.find((k) => /size/i.test(k));
    return tryAttr(lengthKey, maxL) || tryAttr(widthKey, maxW) || tryAttr(sizeKey, Math.max(maxW, maxL));
  }

  saveServicesAndReturn() {
    // ── Service-compatibility validation temporarily DISABLED ──
    // Pending design sign-off. Re-enable by uncommenting the block below (and it
    // will route to the quantity / size / no-size popups). For now, commit directly.
    // const result = this.validateServiceConfiguration();
    // if (result.type === 'quantity') {
    //   this.validationCurrentQty = result.current;
    //   this.validationRequiredQty = result.required;
    //   this.showServiceQtyPopup = true;
    //   return;
    // }
    // if (result.type === 'size') {
    //   this.validationCurrentSize = result.current;
    //   this.validationSuggestedSize = result.suggested;
    //   this.showServiceSizePopup = true;
    //   return;
    // }
    // if (result.type === 'no-size') {
    //   this.showServiceNoSizePopup = true;
    //   return;
    // }
    this.commitSavedServices();
  }

  /** Emit the configured services to the product page and close the drawer.
   *  `extra` carries any auto-adjustment (quantity / size) for the PDP to apply. */
  private commitSavedServices(extra: any = {}) {
    const serviceNames = this.getConfiguredServiceNames();
    this.util.emitSavedProductServices({
      product: this.selectedProductForNewConfig,
      serviceNames,
      serviceFee: this.getConfiguredServiceFee(),
      ...extra,
    });
    // Hide the drawer but keep serviceGroups/configs so "Edit" can reopen and
    // "Add to cart" can commit via onDone().
    this.multipleVarientsPopupOpen = false;
  }

  /** Scenario 1 → "Update Quantity": bump the PDP quantity to the required amount. */
  serviceValidationUpdateQuantity() {
    this.showServiceQtyPopup = false;
    this.commitSavedServices({ adjustQty: this.validationRequiredQty });
  }

  /** Scenario 2 → "Update Size": switch the PDP to the nearest compatible size. */
  serviceValidationUpdateSize() {
    this.showServiceSizePopup = false;
    this.commitSavedServices({
      adjustSizeSlug: this.validationSuggestedSize?.slug,
      adjustSizeLabel: this.validationSuggestedSize?.label,
    });
  }

  /** Any "Edit Services": dismiss the popup and stay in the services flow. */
  serviceValidationEditServices() {
    this.showServiceQtyPopup = false;
    this.showServiceSizePopup = false;
    this.showServiceNoSizePopup = false;
  }

  // ── v2.0 services payload assembly ─────────────────────────────────────

  private serviceKindFromName(name: string): ServiceKind {
    const n = (name || '').toLowerCase();
    if (n.includes('bend')) return 'bending';
    if (n.includes('punch')) return 'punching';
    if (n.includes('slit')) return 'slitting';
    return 'cutting';
  }

  /** Map a saved configurator config (rich geometry) to a v1.1 ServiceInput. */
  private configToServiceInput(cfg: any): ServiceInput {
    // Slitting only slits along the width — the length is the full stock, so the user
    // doesn't enter it. Default it to a positive value so the builder still produces a
    // cut per slit (slitting bills by slit count, not length).
    const isSlitting = (cfg?.name || '').toLowerCase() === 'slitting';
    return {
      kind: this.serviceKindFromName(cfg?.name),
      pricing: {
        basePrice: Number(cfg?.minimumServiceFee) || 0,
        includedQuantity: Number(cfg?.includedQtyInMinimumFee) || 0,
        additionalUnitPrice: Number(cfg?.eachAdditionalPrice) || 0,
      },
      measurements: (cfg?.measurements || []).map((m: any) => ({
        width: m?.width,
        length: isSlitting && !(Number(m?.length) > 0) ? 1 : m?.length,
        qty: m?.qty,
      })),
      pieces: (cfg?.pieces || []).map((p: any) => ({
        label: p?.label, width: p?.width, length: p?.length, qty: p?.qty,
        bendRows: p?.bendRows, bendPreset: p?.bendPreset,
        bendAxis: p?.bendAxis === 'width' ? 'width' : 'length',
        cover: this.coverInputFor(p),
      })),
      bendRows: cfg?.bendRows,
      bendPreset: cfg?.bendPreset,
      bendAxis: cfg?.bendAxis === 'width' ? 'width' : 'length',
      cover: this.coverInputFor(cfg),
      notes: cfg?.notes,
      attachment: cfg?.uploadedFile?.url
        ? { name: cfg.uploadedFile.name, url: cfg.uploadedFile.url }
        : null,
    };
  }

  /** Map a previously-saved cart option (re-add flows) to a v1.1 ServiceInput,
   *  preserving any persisted geometry; synthesize from qty when absent so the
   *  billed quantity is not lost. */
  private savedOptionToServiceInput(opt: any, product: any): ServiceInput {
    const name = this.getServiceName(opt?.productOptionType);
    const kind = this.serviceKindFromName(name);
    const matched = product?.productOptionsDTO?.find(
      (o: any) => o.productOptionType?.toLowerCase() === name?.toLowerCase()
    );
    const qty = Math.max(1, Math.round(Number(opt?.qty) || 1));

    let measurements = opt?.measurements;
    let bendRows = opt?.bendRows;
    const pieces = opt?.pieces;
    if (!measurements?.length && !pieces?.length && !bendRows?.length) {
      if (kind === 'bending') {
        bendRows = Array.from({ length: qty }, () => ({ distance: null, direction: 'up', angle: 90 }));
      } else {
        measurements = [{ width: null, length: 1, qty }];
      }
    }

    // Slitting only slits along the width — the length is the full stock, so the user
    // never enters it. Default it to a positive value (mirrors configToServiceInput) so
    // the builder still produces a cut per slit; otherwise its length<=0 rows are
    // filtered out and the whole slitting service is silently dropped from the payload.
    const isSlitting = kind === 'slitting';
    const mappedMeasurements = (measurements || []).map((m: any) => ({
      width: m?.width,
      length: isSlitting && !(Number(m?.length) > 0) ? 1 : m?.length,
      qty: m?.qty,
    }));

    return {
      kind,
      pricing: {
        basePrice: Number(matched?.minimumServiceFee ?? opt?.minimumServiceFee) || 0,
        includedQuantity: Number(matched?.includedQtyInMinimumFee ?? opt?.includedQtyInMinimumFee) || 0,
        additionalUnitPrice: Number(matched?.eachAdditionalPrice ?? opt?.eachAdditionalPrice) || 0,
      },
      measurements: mappedMeasurements,
      pieces: (pieces || []).map((p: any) => ({ ...p, bendPreset: p?.bendPreset ?? null, cover: this.coverInputFor(p) })),
      bendRows: bendRows || [],
      // Top-level shape for a standalone bend. The payload builder reads
      // bendingSvc.bendPreset off this, so omitting it silently drops the shape
      // (mirrors configToServiceInput on the wizard path).
      bendPreset: opt?.bendPreset ?? null,
      bendAxis: opt?.bendAxis === 'width' ? 'width' : 'length',
      // Options hydrated from an order carry the preset on their pieces only.
      cover: this.coverInputFor({ bendPreset: opt?.bendPreset ?? opt?.pieces?.[0]?.bendPreset, bendOptions: opt?.bendOptions }),
      notes: opt?.notes,
      // This service's own scoped file (e.g. the bending sketch). The order-level
      // (general) diagram is attached separately in buildServicesFromSavedOptions.
      attachment: opt?.uploadedFile?.url
        ? { name: opt.uploadedFile.name, url: opt.uploadedFile.url }
        : (opt?.document ? { name: opt?.OriginalFileName || 'attachment', url: opt.document } : null),
    };
  }

  /** order.customerId from the logged-in user (informational; backend uses the cart line). */
  private currentCustomerId(): string {
    const u: any = this.user;
    return u?.id || u?.customerId || u?.userId || u?.userGuid || '';
  }

  /** Build the full v2.0 services object from a list of configurator configs. */
  private buildServicesFromConfigs(product: any, qty: number, configs: any[], cartId?: string, groupUploadedFile?: any) {
    const input: ServiceOrderInput = {
      product: buildProductContext(product),
      qty: qty || 1,
      notes: (configs || []).find((c: any) => c?.notes)?.notes,
      services: (configs || []).map((c: any) => this.configToServiceInput(c)),
      attachment: groupUploadedFile?.url ? { name: groupUploadedFile.name, url: groupUploadedFile.url } : null,
      now: new Date().toISOString(),
      orderId: cartId,
      customerId: this.currentCustomerId(),
      includeRemainingMaterial: this.includeRemainingMaterial,
    };
    return buildServicesPayloadV11(input);
  }

  /** Build the full v2.0 services object from previously-saved cart options. */
  private buildServicesFromSavedOptions(product: any, qty: number, options: any[], cartId?: string, uploadedFile?: any) {
    // The order-level (general) diagram. Per-service files like the bending sketch
    // are attached on their own ServiceInput by savedOptionToServiceInput.
    const att = uploadedFile?.url ? { name: uploadedFile.name, url: uploadedFile.url } : null;
    const input: ServiceOrderInput = {
      product: buildProductContext(product),
      qty: qty || 1,
      notes: (options || []).find((o: any) => o?.notes)?.notes,
      services: (options || []).map((o: any) => this.savedOptionToServiceInput(o, product)),
      attachment: att,
      now: new Date().toISOString(),
      orderId: cartId,
      customerId: this.currentCustomerId(),
      // Preserve the saved leftover-material choice across re-add (round-trip) flows.
      includeRemainingMaterial: (options || []).find((o: any) => o?.includeRemainingMaterial !== undefined)?.includeRemainingMaterial,
    };
    return buildServicesPayloadV11(input);
  }

  /** Rewrite the captured product's slug — and each service group's unit reference —
   *  to the latest selected product. Used when the user changes size on the product
   *  page AFTER saving services: onDone() both groups cart items by slug and attaches
   *  the service options by matching that slug to the new cart item, so every slug
   *  reference must move together or the latest size is added without its services. */
  private syncPendingServiceProductSlug(latest: any) {
    const newSlug = latest?.urlSlug;
    if (!newSlug) return;
    // Remember the full latest product so the post-add popup shows its details.
    this.pendingServiceLatestProduct = latest;
    if (this.selectedProductForNewConfig) {
      this.selectedProductForNewConfig.urlSlug = newSlug;
    }
    (this.serviceGroups || []).forEach((g: any) => {
      if (g?.unitRef) {
        g.unitRef.urlSlug = newSlug;
        if (g.unitRef.product) g.unitRef.product.urlSlug = newSlug;
      }
    });
  }

  /** True when a cart/quote line already carries S&F services. We must never
   *  re-attach options onto such a line — the backend rejects updating an
   *  already-serviced line with a larger qty ("use the same or less qty…"). So a
   *  serviced add always targets a service-null line. Mirrors shopping-cart's
   *  hasServices check (services live in item.services.order.billing.services). */
  private cartLineHasServices(item: any): boolean {
    const services = item?.services?.order?.billing?.services;
    if (!services) return false;
    return Object.keys(services).some((k) => k !== 'material');
  }

  async onDone() {
    // Quotes page opened this configurator → save via the Quotes API (delete the
    // original quote line and re-add one line per group/unit, mirroring the cart).
    if (this.quoteMode) { return this.onDoneQuote(); }
    if (this.generatorMode) { return this.onDoneGenerator(); }
    let currentCart = null;
    if (this.serviceFlow === 'groups') {
      const hasError = this.serviceGroups.some((group, i) => group.qty > this.getGroupMaxQty(i));
      if (hasError) {
        this.util.showQuotesToast('Quantity exceeds available units', 'error', undefined);
        return;
      }
    }

    this.util.setLoder(true);

    try {
      // Adding/replacing services on a SINGLE existing cart line that stays one line
      // (serviceFlow 'together') → update it in place via PUT instead of
      // delete + re-add + addoption, so the line keeps its position and the backend
      // reprices. A split into groups/each-unit still uses the delete+re-add path below
      // (one PUT can't fan a single line into several). Configs for the 'together' flow
      // live in this.services[].configs (same source the this.services loop below uses).
      if (this.isEditVariantMode && this.selectedProductForNewConfig?.cartId
          && this.serviceFlow !== 'groups' && this.serviceFlow !== 'separately') {
        const editCartId = this.selectedProductForNewConfig.cartId;
        const editProduct = this.selectedProductForNewConfig;
        const editQty = Number(this.selectedProductForNewConfig.qty) || 1;
        // Configs live in the active group (serviceGroups[0] = 'ALL UNITS' for the
        // together flow) OR on this.services[].configs — depending on activeGroupId at
        // save time. Collect from BOTH, deduped by reference, so none are missed.
        const seenCfg = new Set<any>();
        const editConfigs = [
          ...(this.serviceGroups || []).flatMap((g: any) => g.configs || []),
          ...(this.services || []).flatMap((s: any) => s.configs || []),
        ].filter((c: any) => c && !seenCfg.has(c) && seenCfg.add(c));
        const editServices = editConfigs.length
          ? this.buildServicesFromConfigs(editProduct, editQty, editConfigs, editCartId, (this.serviceGroups || [])[0]?.uploadedFile)
          : null;
        await this.api.updateCartItem({
          CartId: editCartId, Qty: editQty,
          ProductSlug: editProduct.urlSlug, Services: editServices,
        });
        editConfigs.forEach((c: any) => c.isSavedToBackend = true);

        this.util.setLoder(false);
        if (isPlatformBrowser(this.platformId)) { document.body.classList.remove('no-scroll'); }
        const cartAfter = await this.api.getCartList();
        this.cartList = cartAfter;
        const popupProduct = this.pendingServiceLatestProduct || this.selectedProductForNewConfig;
        this.util.PopupCartUpdated(this.findItemsInCart(popupProduct));
        this.util.CartUpdated(cartAfter);
        this.forceClosePopup();
        this.util.emitSavedProductServices(null);
        this.util.showCartNotification(popupProduct);
        this.pendingServiceLatestProduct = null;
        return;
      }

      // If editing variant from "view & edit all variants", remove old cart item first
      if (this.isEditVariantMode && this.selectedProductForNewConfig?.cartId) {
        await this.api.removeCart(this.selectedProductForNewConfig.cartId);
      }

      const productToCartId = new Map<string, any>();

      if (this.serviceFlow === 'groups' || this.serviceFlow === 'separately') {
        // Each group/unit becomes its OWN cart line so different services on the
        // same product never collide on one cartId.
        //
        // Backend behaviour (confirmed): a plain /cart/add merges into the existing
        // plain line for that slug (same cartId, qty accumulates); once a line has
        // services attached it is a distinct line. So we add the SERVICED groups
        // first — each add + immediate addCartOptions locks a fresh line before the
        // next add — then the plain groups (which merge into a single plain line).
        const preCart = await this.api.getCartList();
        let knownCartIds = new Set<any>((preCart?.items || []).map((i: any) => i.cartId));

        const groupsWithQty = this.serviceGroups.filter((g: any) => (g.qty || 0) > 0);
        const servicedGroups = groupsWithQty.filter((g: any) => g.configs?.length > 0);
        const plainGroups = groupsWithQty.filter((g: any) => !(g.configs?.length > 0));

        for (const group of servicedGroups) {
          const qty = group.qty || 1;
          const product = group.unitRef?.product || group.unitRef || this.selectedProductForNewConfig;
          const slug = product?.urlSlug || group.unitRef?.urlSlug || this.selectedProductForNewConfig?.urlSlug || '';
          const addTarget = product?.urlSlug ? product : { ...product, urlSlug: slug };

          currentCart = await this.performAddToCart(addTarget, qty, false);
          const items = currentCart?.items || [];
          // The serviced group creates a brand-new line: the cartId that wasn't in
          // the cart before this add. Fall back to the newest line for this slug.
          // Only ever target a line whose service is null — never a line that
          // already has services, or the backend rejects the qty update.
          const newItem = items.find((i: any) => !knownCartIds.has(i.cartId) && !this.cartLineHasServices(i))
            || items.slice().reverse().find((i: any) => (i.product?.urlSlug || i.urlSlug) === slug && !this.cartLineHasServices(i));
          const cartId = newItem?.cartId;
          if (!cartId) {
            knownCartIds = new Set<any>(items.map((i: any) => i.cartId));
            continue;
          }
          productToCartId.set(slug, cartId);

          const services = this.buildServicesFromConfigs(product, qty, group.configs, cartId, group.uploadedFile);
          await this.api.addCartOptions({ cartId, qty, services });
          group.configs.forEach((cfg: any) => cfg.isSavedToBackend = true);

          // Attaching services may re-key the line's cartId, so re-read the cart to
          // capture the true post-service state before diffing the next group's add.
          const after = await this.api.getCartList();
          knownCartIds = new Set<any>((after?.items || []).map((i: any) => i.cartId));
        }

        // Plain groups — no services, so the backend merges them into a single line.
        for (const group of plainGroups) {
          const product = group.unitRef?.product || group.unitRef || this.selectedProductForNewConfig;
          const slug = product?.urlSlug || group.unitRef?.urlSlug || this.selectedProductForNewConfig?.urlSlug || '';
          const addTarget = product?.urlSlug ? product : { ...product, urlSlug: slug };
          currentCart = await this.performAddToCart(addTarget, group.qty || 1, false);
        }

        // Groups flow: add any unassigned remainder as a plain line so no unit is dropped.
        const unassigned = this.unassignedUnitsCount;
        if (this.serviceFlow === 'groups' && unassigned > 0 && this.selectedProductForNewConfig) {
          currentCart = await this.performAddToCart(this.selectedProductForNewConfig, unassigned, false);
        }
      } else {
        // Together / non-split. A product that receives services must land on its
        // OWN new line rather than merging the services onto an existing plain line
        // of that product, so serviced products go through the same add → new-line →
        // addCartOptions flow as the groups path; plain-only units merge by slug.
        const preCart = await this.api.getCartList();
        let knownCartIds = new Set<any>((preCart?.items || []).map((i: any) => i.cartId));

        // Units per product slug (drives qty; lets us skip serviced slugs when adding plain).
        const unitsBySlug = new Map<string, { product: any, qty: number }>();
        this.flattenedSplitItems.forEach((unit: any) => {
          const product = unit.product || unit;
          const slug = product.urlSlug || '';
          if (!unitsBySlug.has(slug)) {
            unitsBySlug.set(slug, { product, qty: 0 });
          }
          unitsBySlug.get(slug)!.qty += 1;
        });

        const servicedSlugs = new Set<string>();
        for (const group of this.serviceGroups) {
          if (!(group.configs?.length > 0)) continue;
          const product = group.unitRef?.product || group.unitRef || this.selectedProductForNewConfig;
          const slug = product?.urlSlug || this.selectedProductForNewConfig?.urlSlug || '';
          const qty = unitsBySlug.get(slug)?.qty || group.qty || 1;
          servicedSlugs.add(slug);
          const addTarget = product?.urlSlug ? product : { ...product, urlSlug: slug };

          currentCart = await this.performAddToCart(addTarget, qty, false);
          const items = currentCart?.items || [];
          // Only ever target a line whose service is null — never a line that
          // already has services, or the backend rejects the qty update.
          const newItem = items.find((i: any) => !knownCartIds.has(i.cartId) && !this.cartLineHasServices(i))
            || items.slice().reverse().find((i: any) => (i.product?.urlSlug || i.urlSlug) === slug && !this.cartLineHasServices(i));
          const cartId = newItem?.cartId;
          if (!cartId) {
            knownCartIds = new Set<any>(items.map((i: any) => i.cartId));
            continue;
          }
          productToCartId.set(slug, cartId);

          const services = this.buildServicesFromConfigs(product, qty, group.configs, cartId, group.uploadedFile);
          await this.api.addCartOptions({ cartId, qty, services });
          group.configs.forEach((cfg: any) => cfg.isSavedToBackend = true);

          const after = await this.api.getCartList();
          knownCartIds = new Set<any>((after?.items || []).map((i: any) => i.cartId));
        }

        // Plain units for slugs that didn't receive services (merge by slug).
        for (const [slug, data] of unitsBySlug.entries()) {
          if (servicedSlugs.has(slug)) continue;
          currentCart = await this.performAddToCart(data.product, data.qty, false);
          const matchingItem = currentCart?.items
            ?.slice()
            .reverse()
            .find((i: any) => (i.product?.urlSlug || i.urlSlug) === slug);
          if (matchingItem) {
            productToCartId.set(slug, matchingItem.cartId);
          }
        }

        for (const svc of this.services) {
          if (svc.configs && svc.configs.length > 0) {
            const pendingConfigs = svc.configs.filter((c: any) => !c.isSavedToBackend);
            if (pendingConfigs.length > 0) {
              const product = this.selectedProductForNewConfig;
              const cartId = productToCartId.get(product?.urlSlug || '');
              if (cartId) {
                const qty = pendingConfigs[0].qty || 1;
                const services = this.buildServicesFromConfigs(product, qty, pendingConfigs, cartId);
                await this.api.addCartOptions({ cartId, qty, services });
              }
            }
          }
        }
      }

      this.util.setLoder(false);
      if (isPlatformBrowser(this.platformId)) {
        document.body.classList.remove('no-scroll');
      }
      let data = await this.api.getCartList();
      this.cartList = data;
      // Prefer the latest product from the product page (covers a size change made
      // after services were saved) so the popup reflects the item actually added.
      const product = this.pendingServiceLatestProduct || this.selectedProductForNewConfig;
      this.util.PopupCartUpdated(this.findItemsInCart(product));
      this.util.CartUpdated(data);
      this.forceClosePopup();
      // clear the pending-services card on the product-detail page
      this.util.emitSavedProductServices(null);
      this.util.showCartNotification(product);
      this.pendingServiceLatestProduct = null;
    } catch (err: any) {
      this.util.showQuotesToast('Failed to add options', 'error', undefined);
    } finally {
      this.util.setLoder(false);
    }
  }

  /** Quote equivalent of onDone(): add the product(s) to Quotes, then attach the
   *  configured services to each quote line via Quotes/addoption. */
  async onDoneQuote() {
    if (this.serviceFlow === 'groups') {
      const hasError = this.serviceGroups.some((group, i) => group.qty > this.getGroupMaxQty(i));
      if (hasError) {
        this.util.showQuotesToast('Quantity exceeds available units', 'error', undefined);
        return;
      }
    }

    this.util.setLoder(true);
    try {
      // Reconfiguring an existing quote line (opened from the Quotes page): remove the
      // original line first so the split REPLACES it instead of duplicating units.
      if (this.isEditVariantMode && this.selectedProductForNewConfig?.quoteId) {
        await this.api.removeQuote(this.selectedProductForNewConfig.quoteId);
      }

      const productToQuoteId = new Map<string, any>();

      if (this.serviceFlow === 'groups' || this.serviceFlow === 'separately') {
        // Each group/unit becomes its OWN quote line so different services on the
        // same product never collide on one quoteId. Add the SERVICED groups first
        // (add + immediate addOptions locks each distinct line before the next add),
        // then the plain groups (which merge into a single line).
        const preQuotes = await this.api.getQuotes();
        let knownQuoteIds = new Set<any>((preQuotes?.items || []).map((i: any) => i.quoteId));

        const groupsWithQty = this.serviceGroups.filter((g: any) => (g.qty || 0) > 0);
        const servicedGroups = groupsWithQty.filter((g: any) => g.configs?.length > 0);
        const plainGroups = groupsWithQty.filter((g: any) => !(g.configs?.length > 0));

        for (const group of servicedGroups) {
          const qty = group.qty || 1;
          const product = group.unitRef?.product || group.unitRef || this.selectedProductForNewConfig;
          const slug = product?.urlSlug || group.unitRef?.urlSlug || this.selectedProductForNewConfig?.urlSlug || '';

          const quoteRes = await this.api.addToQuote({ qty, productSlug: slug });
          const items = quoteRes?.items || [];
          // The serviced group creates a brand-new line: the quoteId that wasn't in
          // the quotes before this add. Fall back to the newest line for this slug.
          // Only ever target a line whose service is null — never a line that
          // already has services, or the backend rejects the qty update.
          const newItem = items.find((i: any) => !knownQuoteIds.has(i.quoteId) && !this.cartLineHasServices(i))
            || items.slice().reverse().find((i: any) => (i.product?.urlSlug || i.urlSlug) === slug && !this.cartLineHasServices(i));
          const quoteId = newItem?.quoteId;
          if (!quoteId) {
            knownQuoteIds = new Set<any>(items.map((i: any) => i.quoteId));
            continue;
          }
          productToQuoteId.set(slug, quoteId);

          const services = this.buildServicesFromConfigs(product, qty, group.configs, quoteId, group.uploadedFile);
          await this.api.addOptions({ QuoteId: quoteId, qty, services });
          group.configs.forEach((cfg: any) => cfg.isSavedToBackend = true);

          // Attaching services may re-key the line, so re-read quotes to capture the
          // true post-service state before diffing the next group's add.
          const after = await this.api.getQuotes();
          knownQuoteIds = new Set<any>((after?.items || []).map((i: any) => i.quoteId));
        }

        // Plain groups — no services, so the backend merges them into a single line.
        for (const group of plainGroups) {
          const product = group.unitRef?.product || group.unitRef || this.selectedProductForNewConfig;
          const slug = product?.urlSlug || group.unitRef?.urlSlug || this.selectedProductForNewConfig?.urlSlug || '';
          await this.api.addToQuote({ qty: group.qty || 1, productSlug: slug });
        }

        // Groups flow: add any unassigned remainder as a plain line so no unit is dropped.
        const unassigned = this.unassignedUnitsCount;
        if (this.serviceFlow === 'groups' && unassigned > 0 && this.selectedProductForNewConfig?.urlSlug) {
          await this.api.addToQuote({ qty: unassigned, productSlug: this.selectedProductForNewConfig.urlSlug });
        }
      } else {
        // Together / non-split: one quote line per product (by slug), then attach
        // the shared services to each.
        const itemTotals = new Map<string, { product: any, qty: number }>();
        this.flattenedSplitItems.forEach((unit: any) => {
          const product = unit.product || unit;
          const slug = product.urlSlug || '';
          if (!itemTotals.has(slug)) itemTotals.set(slug, { product, qty: 0 });
          itemTotals.get(slug)!.qty += 1;
        });

        for (const [slug, data] of itemTotals.entries()) {
          const quoteRes = await this.api.addToQuote({ qty: data.qty, productSlug: data.product.urlSlug });
          // Several quote lines can share a slug, so take the most recently added.
          const matching = quoteRes?.items
            ?.slice()
            .reverse()
            .find((i: any) => (i.product?.urlSlug || i.urlSlug) === slug);
          if (matching) productToQuoteId.set(slug, matching.quoteId);
        }

        for (const group of this.serviceGroups) {
          if (group.configs && group.configs.length > 0) {
            const product = group.unitRef?.product || group.unitRef || this.selectedProductForNewConfig;
            const quoteId = productToQuoteId.get(product?.urlSlug || '');
            if (!quoteId) continue;
            const services = this.buildServicesFromConfigs(product, group.qty || 1, group.configs, quoteId, group.uploadedFile);
            await this.api.addOptions({ QuoteId: quoteId, qty: group.qty || 1, services });
            group.configs.forEach((cfg: any) => cfg.isSavedToBackend = true);
          }
        }
        for (const svc of this.services) {
          if (svc.configs && svc.configs.length > 0) {
            const pendingConfigs = svc.configs.filter((c: any) => !c.isSavedToBackend);
            if (pendingConfigs.length > 0) {
              const product = this.selectedProductForNewConfig;
              const quoteId = productToQuoteId.get(product?.urlSlug || '');
              if (quoteId) {
                const qty = pendingConfigs[0].qty || 1;
                const services = this.buildServicesFromConfigs(product, qty, pendingConfigs, quoteId);
                await this.api.addOptions({ QuoteId: quoteId, qty, services });
              }
            }
          }
        }
      }

      const quotes = await this.api.getQuotes();
      this.util.setQuotes(quotes?.items);
      this.util.quotes$.next(quotes);   // refresh the Quotes page list (it subscribes to quotes$)
      const product = this.pendingServiceLatestProduct || this.selectedProductForNewConfig;
      this.forceClosePopup();
      // clear the pending-services card on the product-detail page
      this.util.emitSavedProductServices(null);
      this.util.showCartNotification(product, true);
      this.pendingServiceLatestProduct = null;
    } catch (err: any) {
      this.util.showQuotesToast('Failed to add quote options', 'error', undefined);
    } finally {
      this.util.setLoder(false);
    }
  }

  confirmDiscard() {
    this.showDiscardPopup = false;
    if (this.discardType === 'modal') {
      // In "Add Services" mode the configured services are saved back to the product
      // page, so closing the drawer must NOT wipe them — otherwise the product page
      // still shows the saved chip while a re-opened Edit drawer is empty. Revert the
      // in-session edits to the snapshot and just hide the drawer instead.
      if (this.addServiceMode && this.editServicesSnapshot) {
        this.restoreSavedServicesSnapshot();
      } else {
        this.forceClosePopup();
      }
    } else {
      this.draftConfig = null;
      this.addNewConfig = false;
      this.restoreVariantEditView();
    }
  }

  /** Deep-copy the currently-saved service state so it can be restored on discard. */
  private captureServiceState() {
    return {
      serviceGroups: JSON.parse(JSON.stringify(this.serviceGroups || [])),
      services: JSON.parse(JSON.stringify(this.services || [])),
      selectedProductForNewConfig: this.selectedProductForNewConfig
        ? JSON.parse(JSON.stringify(this.selectedProductForNewConfig)) : null,
      filterServicesForNewConfig: JSON.parse(JSON.stringify(this.filterServicesForNewConfig || [])),
      serviceFlow: this.serviceFlow,
      activeGroupId: this.activeGroupId,
    };
  }

  /** Restore the saved services captured on Edit and hide the drawer (keep them saved). */
  private restoreSavedServicesSnapshot() {
    const snap = this.editServicesSnapshot;
    if (!snap) {
      this.forceClosePopup();
      return;
    }
    this.serviceGroups = snap.serviceGroups;
    this.services = snap.services;
    this.selectedProductForNewConfig = snap.selectedProductForNewConfig;
    this.filterServicesForNewConfig = snap.filterServicesForNewConfig;
    this.serviceFlow = snap.serviceFlow;
    this.activeGroupId = snap.activeGroupId;
    // drop transient edit state but keep the saved services intact, then hide the drawer
    this.draftConfig = null;
    this.addNewConfig = false;
    this.showDiscardPopup = false;
    this.multipleVarientsPopupOpen = false;
  }

  cancelDiscard() {
    this.showDiscardPopup = false;
  }

  forceClosePopup() {
    this.multipleVarientsPopupOpen = false;
    this.quoteMode = false;
    this.generatorMode = false;
    this.generatorAllowedServices = null;
    this.generatorRecordId = null;
    this.addServiceMode = false;
    this.addNewConfig = false;
    this.showDiscardPopup = false;
    // Fully reset the "Editing Services" drawer state so a discarded session can't
    // leave stale edit flags (e.g. __servicesEditedSession) or pending ticks behind.
    this.editingVariantServices = false;
    this.editingVariant = null;
    this.editVariantSelectedTypes.clear();
    this.draftConfig = null;
    this.splitItemsIndividually = false;
    this.isConfiguringSplit = false;
    this.selectedSplitIndices.clear();
    this.serviceGroups = [];
    this.activeGroupId = null;
    this.serviceFlow = 'together';

    // reset transient service-selection + wizard state so checkboxes clear on close
    this.groupSelectedServices = {};
    this.wizardServices = [];
    this.wizardDrafts = {};
    this.wizardPieceSelection = {};
    this.wizardStep = 0;
    this.isReviewStep = false;
    this.showAutoAddedBanner = false;
    this.cameFromVariantEdit = false;


    if (isPlatformBrowser(this.platformId)) {
      sessionStorage.removeItem('selectedService');
    }

    this.services.forEach((s: any) => {
      s.configs = [];
    });

    if (this.filterServicesForNewConfig && this.filterServicesForNewConfig.length > 0) {
      this.filterServicesForNewConfig.forEach((s: any) => {
        s.configs = [];
      });
    }

    this.selectedService = null;
    this.selectedProductForNewConfig = null;
    this.editServicesSnapshot = null;
  }

  async skipServices() {
    // Editing an existing cart line and skipping services → clear its services in place
    // via PUT (Services:null) instead of delete + re-add, keeping the line/position.
    if (this.isEditVariantMode && this.selectedProductForNewConfig?.cartId) {
      const p = this.selectedProductForNewConfig;
      const qty = Number(p.qty) || Number(p.cartQty) || 1;
      await this.api.updateCartItem({ CartId: p.cartId, Qty: qty, ProductSlug: p.urlSlug, Services: null });
      const data = await this.api.getCartList();
      this.cartList = data;
      this.util.CartUpdated(data);
      this.util.PopupCartUpdated(this.findItemsInCart(p));
      this.util.emitSavedProductServices(null);
      this.forceClosePopup();
      return;
    }
    // Fresh add (no existing line) — add the product WITHOUT services.
    const qty = this.selectedProductForNewConfig?.qty || this.selectedProductForNewConfig?.cartQty || 1;
    this.performAddToCart(this.selectedProductForNewConfig, qty)
    // The product was added WITHOUT services, so clear the pending-services card on
    // the product-detail page — otherwise it keeps showing the skipped service.
    this.util.emitSavedProductServices(null);
    this.forceClosePopup();
  }

  backToServices() {
    this.closeMultipleVarientsPopup();
  }

  onEditSavedService(service: any, index: number) {
    this.selectedService = service;
    this.draftConfig = {
      ...service.configs[index],
      editIndex: index,
      isSaved: false
    };
    this.addNewConfig = true;
  }

  onRemoveSavedService(service: any, index: number) {
    service.configs.splice(index, 1);
  }

  async performAddToCart(item: any, qty: number, show = true) {
    console.log(item, "item123")
    const cartBody = {
      qty,
      productSlug: item.urlSlug,
    };

    try {
      const currentcart = await this.api.addToCart(cartBody);
      this.cartList = currentcart;
      this.util.CartUpdated(currentcart);
      this.util.PopupCartUpdated(this.findItemsInCart(item));
      if(show) this.util.showCartNotification(item);
      return currentcart;
    } catch (err: any) {
      if (this.util.isCustomerNotFoundError(err)) {
        this.util.showQuotesToast('Please login with a customer', 'error', 'Error');
        item.qty = 0;
        item.cartQty = 0;
      }
      throw err;
    }
  }

  toggleSpecDropdown(item: any) {
    const key = String(item.key);
    if (this.activeSpecKey === key) {
      this.activeSpecKey = null;
    } else {
      this.activeSpecKey = key;
    }
  }

  getSpecOptions(item: any): any[] {
    const values: any[] = item.value || [];
    return item.value;
  }

  selectSpecAttribute(item: any, value: any) {
    this.selectedProductForNewConfig.urlSlug = value.productSlug;
    this.onOptionChange(value.productSlug);
    this.activeSpecKey = null;
  }

  isSpecDropdownOpen(key: any): boolean {
    return this.activeSpecKey === String(key);
  }

  async onOptionChange(slug: string) {
    try {
      const data = await this.api.getProductDetail(slug);
      const currentQty = this.selectedProductForNewConfig?.qty || 1;
      this.selectedProductForNewConfig = data;
      console.log('Selected product for new config:', this.selectedProductForNewConfig);
      this.selectedProductForNewConfig.qty = currentQty;
      this.filterServicesForNewConfig = this.getFilteredServicesForConfig(this.selectedProductForNewConfig);

    } catch (err) {
      this.util.showQuotesToast('Error', 'error', 'Could not load variant options');
    }
  }

  checkSlugs(currentSlug: string, dataSlug: string): boolean {
    return currentSlug?.toLocaleLowerCase().trim() === dataSlug?.toLocaleLowerCase().trim();
  }

  getExtraQty(draftConfig: any): number {
    return draftConfig?.internalQty - draftConfig?.includedQtyInMinimumFee;
  }

  getServiceTotal(service: any) {
    return service?.configs?.reduce((acc: number, cfg: any) => acc + cfg.totalAmount, 0);
  }

  getTotalInternalQty(service: any): number {
    return service?.configs?.reduce((acc: number, cfg: any) => acc + (cfg.internalQty || 0), 0) || 0;
  }

  getInternalQtyLabel(svc: any): string {
    if (!svc) return '';
    let unit = 'item';
    const name = svc.name?.toLowerCase();
    if (name === 'cutting') unit = 'cut';
    else if (name === 'bending') unit = 'bend';
    else if (name === 'slitting') unit = 'slit';
    else if (name === 'punching') unit = 'punch';

    return unit;
  }

  isServiceConfigured(service: any): boolean {
    const configs = this.getConfigsForService(service);
    return configs && configs.length > 0;
  }

  getServiceConfigCount(service: any): number {
    const configs = this.getConfigsForService(service);
    return configs?.reduce((acc: number, cfg: any) => acc + (cfg.internalQty || 0), 0) || 0;
  }

  private getConfigsForService(service: any): any[] {
    if (this.activeGroupId !== null) {
      const group = this.serviceGroups.find(g => g.id === this.activeGroupId);
      return group?.configs?.filter((c: any) => c.serviceType === service.serviceType) || [];
    } else {
      return service.configs || [];
    }
  }

  trackByGroup(index: number, group: any) {
    return group.id;
  }

  trackByServiceName(index: number, service: any) {
    return service.name;
  }
}

